import React, { useState, useEffect } from "react";
import WidgetMakerHeader from "../../../WidgetMaker/Header";
import { Badge, Button, Layout, Modal, Tabs, Tooltip } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import { DragDropContext } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import {
  setCardSettings,
  setChartEditField,
  setFilterByDropdownAttributes,
  setRichFields,
  setX_attribute,
  setY_attribute,
} from "../../../../redux/actions/WidgetMaker/GraphConfig";
import {
  setFilterActiveKey,
  setFilterPanelData,
  setisFilterPanelVisible,
  setradioArray,
  setradioChecked,
} from "../../../../redux/actions/Filter";
import FilterDrawer from "../../../layout/Workspace/drawers/FilterDrawer";
import uuid from "react-uuid";
import moment from "moment";
import {
  getCustomizedDate,
  getBrands,
  getFilterPanelData,
  getSelectedCompBrand,
  getWidgetMakerFlag,
  callNotification,
  getEmptyFieldNotification,
  getRadiusAttributeValue,
  getPaneIndex,
  updateChartSettingsInGraphObjectBasedOnSelection,
  hasValidYSeries,
} from "../../../../redux/constants";
import {
  getChartAttributesFieldConfigAPI,
  setUpdateImpression,
  setWidgetMakerErrorCode,
  setWidgetMakerGraphData,
} from "../../../../redux/actions/WidgetMaker/WidgetAPI";
import { Redirect } from "react-router-dom";
import reset_dark from "../../../../assets/WidgetMaker/Reset_dark.svg";
import reset_white from "../../../../assets/WhiteIcons/Reset_white.svg";
import reset_red from "../../../../assets/WidgetMaker/Reset_red.svg";
import { setOptionHighChart } from "../../../../redux/actions/HighChart";
import ErrorBoundary from "../../../../ErrorBoundary";
import {
  setChartAttributesFieldConfig,
  setWidgetMakerApiCallFlag,
} from "../../../../redux/actions/WidgetMaker/WidgetMaker";
import ConfigurePanel from "../../../WidgetMaker/ConfigurePanel";
import AttributePanel from "../../../WidgetMaker/AttributePanel";
import ChartSetting from "../../../WidgetMaker/ChartSettings";
import isEqual from "react-fast-compare";
import WidgetMakerChart from "../../../WidgetMaker/Chart";
import {
  globalChartColor,
  supportedBenchmarkTraceChartTypes,
} from "../../../../redux/constants/enums";
import { setDataSource } from "../../../../redux/actions/WidgetMaker/WidgetLibrary";
import { setEditedWidgetGraphConfig } from "../../../../redux/actions/dashboard/Tab1";
import ExitModal from "../../../WidgetMaker/ExitModal";
import AttributeList from "../../../WidgetMaker/ConfigurePanel/AttributeFieldConfig/AttributeList";
import AttributeTabs from "../../../WidgetMaker/ConfigurePanel/AttributeFieldConfig/AttributeTabs";

const { Content } = Layout;
const { TabPane } = Tabs;

const EditWidgetMetaData = ({
  editWidgetMetaDataModal,
  setEditWidgetMetaDataModal,
  firstPage,
}) => {
  firstPage = true;
  const dispatch = useDispatch();
  const axisPanelAtt = useSelector(
    (state) => state.GraphConfig.widgetGraphConfig
  );
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const WM_attributes = useSelector((state) => state.WidgetMaker.WM_attributes);
  const widgetPreviewLoader = useSelector(
    (state) => state.WidgetAPI.widgetPreviewLoader
  );
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const isDuplicate = useSelector((state) => state.WidgetMaker.isDuplicate);
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditionConfigurationData
  );

  const graphConditions = useSelector(
    (state) => state?.apiCall?.graphConditions
  );

  const panes = useSelector((state) => state?.Tab1?.panes);
  const widgetShow = useSelector((state) => state.WidgetLibrary.widgetShow);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const editWidgetData = useSelector((state) => state.WidgetAPI.widgetPreview);
  const radioArray = useSelector((state) => state.Filter.radioArray);

  const radioChecked = useSelector((state) => state.Filter.radioChecked);

  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const configuration_data = useSelector(
    (state) => state.WidgetAPI.configuration_data
  );
  const wm_api_flag = useSelector((state) => state.WidgetMaker.wm_api_flag);
  const graphConditionAggregation = useSelector(
    (state) => state?.apiCall?.graphConditions?.column_aggregations
  );
  const data_source = useSelector((state) => state.WidgetLibrary.data_source);

  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  const graphLoader = useSelector((state) => state.apiCall.loader);
  const chartLoader = useSelector((state) => state?.WidgetAPI?.chart_loader);
  const widgetMakerGraphData = useSelector(
    (state) => state?.WidgetAPI?.widget_maker_graph_data
  );
  const chartAttributesFieldConfig = useSelector(
    (state) => state?.WidgetMaker?.chart_attributes_field_config
  );
  const isEditWidget = useSelector((state) => state.WidgetLibrary.editWidget);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  let index = getPaneIndex(panes, activeKey);

  const [showChartSettings, setShowChartSettings] = useState(false);
  const [showChartSide, setShowChartSide] = useState(false);
  const [searchTerm, setSearchTerm] = useState(null);

  const [isFilterApplied, setisFilterApplied] = useState(false);
  const [widgetMakerClearFilter, setWidgetMakerClearFilter] = useState(false);

  const [previousValueOfStaicMedian, setPreviousValueOfStaicMedian] =
    useState(false);

  const [refreshChart, setRefreshChart] = useState(false);
  const [filterSearch, setfilterSearch] = useState("");
  const [resetIcon, setResetIcon] = useState(reset_dark);
  const [resetDarkIcon, setResetDarkIcon] = useState(reset_white);
  const [cardCount, setCardCount] = useState(0);
  const [updatedDataSource, setUpdatedDataSource] = useState("");
  const [openExitModal, setOpenExitModal] = useState(false);
  const [isAllFieldEmpty, setIsAllFieldEmpty] = useState(true);

  useEffect(() => {
    if (
      axisPanelAtt?.x_axis?.attribute ||
      axisPanelAtt?.breakdown_by?.length > 0 ||
      (axisPanelAtt?.filter_by?.length > 0 &&
        axisPanelAtt?.filter_by?.[0]?.attribute) ||
      (axisPanelAtt?.order_by?.attribute &&
        axisPanelAtt?.chart_type !== "survey-card" &&
        axisPanelAtt?.chart_type !== "sankey" &&
        axisPanelAtt?.chart_type !== "rich-text")
    ) {
      setIsAllFieldEmpty(false);
    } else if (
      ["survey-card", "prolific-user"]?.includes(axisPanelAtt?.chart_type) &&
      widgetMakerGraphData &&
      widgetMakerGraphData !== "No data available"
    ) {
      setIsAllFieldEmpty(false);
    } else if (
      (["review-card", "news-card", "author-card"]?.includes(
        axisPanelAtt?.chart_type
      ) &&
        axisPanelAtt.order_by?.attribute) ||
      (["review-card", "news-card", "author-card"]?.includes(
        axisPanelAtt?.chart_type
      ) &&
        widgetMakerGraphData &&
        widgetMakerGraphData !== "No data available")
    ) {
      setIsAllFieldEmpty(false);
    } else if (axisPanelAtt?.y_axis) {
      const hasValidY = hasValidYSeries(axisPanelAtt.y_axis);
      setIsAllFieldEmpty(!hasValidY);
    }
  }, [axisPanelAtt, widgetMakerGraphData]);

  useEffect(() => {
    if (
      axisPanelAtt?.card_settings?.length > 0 &&
      axisPanelAtt?.card_settings[axisPanelAtt?.card_settings.length - 1]
        .response
    ) {
      let openCard;
      let cnt = 0;
      axisPanelAtt?.card_settings?.map((item, itemIndex) => {
        if (!item?.x_axis && !item?.y_series) {
          openCard = true;
        }
        if (itemIndex === axisPanelAtt?.card_settings?.length - 1) {
          if (item?.response?.[0]?.data) {
            item?.response?.map((res) => {
              res?.data?.map((data, dataIndex) => {
                cnt = cnt + 1;
              });
            });
          } else {
            item?.response?.map((data, dataIndex) => {
              cnt = cnt + 1;
            });
          }
        }
      });
      setCardCount(cnt);
    }
  }, [axisPanelAtt]);

  const onChange = (key) => {
    if (key === "filters") {
      setfilterSearch("");
      setSearchTerm(null);
      dispatch(setisFilterPanelVisible(true));
      dispatch(setFilterActiveKey([]));
    } else {
      dispatch(setisFilterPanelVisible(false));
    }
  };

  let y_series_array_drag = [];
  y_series_array_drag = Object?.keys(widgetGraphConfig?.y_axis)
    ?.map((key) => widgetGraphConfig?.y_axis?.[key]?.attribute)
    ?.filter((d) => d);
  const getDefaultAttributeValue = (axis, chartType) => {
    let updatedAxis =
      ["scatter", "multilayer-map"]?.includes(chartType) && axis === "y_axis"
        ? null
        : axis;
    if (updatedAxis) {
      return {
        primaryAttribute:
          graphConditions[chartType]?.[updatedAxis]?.include?.[0],
        secondaryAttribute:
          graphConditions[chartType]?.[updatedAxis]?.include?.[1],
      };
    } else if (["scatter", "multilayer-map"]?.includes(chartType)) {
      return {
        primaryAttribute:
          graphConditions[chartType]?.["primary_series"]?.include?.[0],
        secondaryAttribute:
          graphConditions[chartType]?.["secondary_series"]?.include?.[0],
      };
    }
    return graphConditions[chartType]?.[updatedAxis]?.include?.[0];
  };
  const checkIsAllowedToDrag = (
    axis,
    chartType,
    attributeName,
    destinationDroppableInfo
  ) => {
    let isAllowedToDrag = false;
    if (chartType === "network-graph" || chartType === "network-graph-v2") {
      if (axis === "x_axis") {
        isAllowedToDrag =
          (graphConditions[chartType]?.varchar?.include?.includes(
            attributeName
          ) ||
            graphConditions[chartType]?.enum?.include?.includes(
              attributeName
            )) &&
          (axisPanelAtt?.breakdown_by &&
          Array.isArray(axisPanelAtt?.breakdown_by) &&
          axisPanelAtt?.breakdown_by?.length > 0
            ? axisPanelAtt?.breakdown_by?.findIndex(
                (b) =>
                  b?.attribute === attributeName &&
                  (axisPanelAtt?.x_axis?.attribute
                    ? b?.attribute !== axisPanelAtt?.x_axis?.attribute
                    : true)
              ) === -1
            : true);
      } else if (axis === "breakdown_by") {
        isAllowedToDrag =
          (graphConditions[chartType]?.varchar?.include?.includes(
            attributeName
          ) ||
            graphConditions[chartType]?.enum?.include?.includes(
              attributeName
            )) &&
          (axisPanelAtt?.breakdown_by &&
          Array.isArray(axisPanelAtt?.breakdown_by) &&
          axisPanelAtt?.breakdown_by?.length > 0
            ? axisPanelAtt?.breakdown_by?.findIndex(
                (b) => b?.attribute === attributeName
              ) === -1
            : true) &&
          (axisPanelAtt?.x_axis?.attribute
            ? attributeName !== axisPanelAtt?.x_axis?.attribute
            : true);
      }
    } else if (["rich-text"]?.includes(chartType)) {
      if (axis === "x_axis") {
        isAllowedToDrag =
          (graphConditions[chartType]?.x_axes?.include?.includes(
            attributeName
          ) ||
            graphConditions[chartType]?.enum?.include?.includes(
              attributeName
            )) &&
          (axisPanelAtt?.breakdown_by &&
          Array.isArray(axisPanelAtt?.breakdown_by) &&
          axisPanelAtt?.breakdown_by?.length > 0
            ? axisPanelAtt?.breakdown_by?.findIndex(
                (b) =>
                  b?.attribute === attributeName &&
                  (axisPanelAtt?.x_axis?.attribute
                    ? b?.attribute !== axisPanelAtt?.x_axis?.attribute
                    : true)
              ) === -1
            : true);
      } else if (axis === "breakdown_by") {
        isAllowedToDrag =
          (graphConditions[chartType]?.y_axes?.include?.includes(
            attributeName
          ) ||
            graphConditions[chartType]?.enum?.include?.includes(
              attributeName
            )) &&
          (axisPanelAtt?.breakdown_by &&
          Array.isArray(axisPanelAtt?.breakdown_by) &&
          axisPanelAtt?.breakdown_by?.length > 0
            ? axisPanelAtt?.breakdown_by?.findIndex(
                (b) => b?.attribute === attributeName
              ) === -1
            : true) &&
          (axisPanelAtt?.x_axis?.attribute
            ? attributeName !== axisPanelAtt?.x_axis?.attribute
            : true);
      } else {
        // Prevent duplicate y-series attributes for rich-text
        const ySeriesAttributes = axisPanelAtt?.y_axis
          ? Object.values(axisPanelAtt.y_axis)
              ?.map((y) =>
                y?.attribute && !y?.hide_on_ui ? y?.attribute : null
              )
              ?.filter((y) => y)
          : [];
        isAllowedToDrag =
          (graphConditions[chartType]?.y_series?.include?.includes(
            attributeName
          ) ||
            !graphConditions[chartType]?.y_series?.exclude?.includes(
              attributeName
            ) ||
            graphConditions[chartType]?.enum?.include?.includes(
              attributeName
            )) &&
          !ySeriesAttributes?.includes(attributeName) &&
          (axisPanelAtt?.breakdown_by &&
          Array.isArray(axisPanelAtt?.breakdown_by) &&
          axisPanelAtt?.breakdown_by?.length > 0
            ? axisPanelAtt?.breakdown_by?.findIndex(
                (b) => b?.attribute === attributeName
              ) === -1
            : true) &&
          (axisPanelAtt?.x_axis?.attribute
            ? attributeName !== axisPanelAtt?.x_axis?.attribute
            : true);
      }
    } else if (chartType === "sankey") {
      if (axis === "x_axis") {
        isAllowedToDrag =
          (graphConditions[chartType]?.x_axes?.include?.includes(
            attributeName
          ) ||
            graphConditions[chartType]?.enum?.include?.includes(
              attributeName
            )) &&
          (axisPanelAtt?.breakdown_by &&
          Array.isArray(axisPanelAtt?.breakdown_by) &&
          axisPanelAtt?.breakdown_by?.length > 0
            ? axisPanelAtt?.breakdown_by?.findIndex(
                (b) =>
                  b?.attribute === attributeName &&
                  (axisPanelAtt?.x_axis?.attribute
                    ? b?.attribute !== axisPanelAtt?.x_axis?.attribute
                    : true)
              ) === -1
            : true);
      } else if (axis === "breakdown_by") {
        isAllowedToDrag =
          (graphConditions[chartType]?.y_axes?.include?.includes(
            attributeName
          ) ||
            graphConditions[chartType]?.enum?.include?.includes(
              attributeName
            )) &&
          (axisPanelAtt?.breakdown_by &&
          Array.isArray(axisPanelAtt?.breakdown_by) &&
          axisPanelAtt?.breakdown_by?.length > 0
            ? axisPanelAtt?.breakdown_by?.findIndex(
                (b) => b?.attribute === attributeName
              ) === -1
            : true) &&
          (axisPanelAtt?.x_axis?.attribute
            ? attributeName !== axisPanelAtt?.x_axis?.attribute
            : true);
      } else {
        isAllowedToDrag =
          (graphConditions[chartType]?.y_series?.exclude?.includes(
            attributeName
          ) ||
            graphConditions[chartType]?.enum?.include?.includes(
              attributeName
            )) &&
          (axisPanelAtt?.breakdown_by &&
          Array.isArray(axisPanelAtt?.breakdown_by) &&
          axisPanelAtt?.breakdown_by?.length > 0
            ? axisPanelAtt?.breakdown_by?.findIndex(
                (b) => b?.attribute === attributeName
              ) === -1
            : true) &&
          (axisPanelAtt?.x_axis?.attribute
            ? attributeName !== axisPanelAtt?.x_axis?.attribute
            : true);
      }
    } else if (chartType === "quadrant") {
      if (axis === "x_axis") {
        isAllowedToDrag =
          graphConditions[chartType]?.x_axes?.include?.includes(
            attributeName
          ) &&
          (axisPanelAtt?.breakdown_by &&
          Array.isArray(axisPanelAtt?.breakdown_by) &&
          axisPanelAtt?.breakdown_by?.length > 0
            ? axisPanelAtt?.breakdown_by?.findIndex(
                (b) =>
                  b?.attribute === attributeName &&
                  (axisPanelAtt?.x_axis?.attribute
                    ? b?.attribute !== axisPanelAtt?.x_axis?.attribute
                    : true)
              ) === -1
            : true);
      } else if (axis === "breakdown_by") {
        isAllowedToDrag =
          graphConditions[chartType]?.y_axes?.include?.includes(
            attributeName
          ) &&
          (axisPanelAtt?.breakdown_by &&
          Array.isArray(axisPanelAtt?.breakdown_by) &&
          axisPanelAtt?.breakdown_by?.length > 0
            ? axisPanelAtt?.breakdown_by?.findIndex(
                (b) => b?.attribute === attributeName
              ) === -1
            : true) &&
          (axisPanelAtt?.x_axis?.attribute
            ? attributeName !== axisPanelAtt?.x_axis?.attribute
            : true);
      } else {
        isAllowedToDrag =
          graphConditions[chartType]?.y_series?.include?.includes(
            attributeName
          ) &&
          (axisPanelAtt?.breakdown_by &&
          Array.isArray(axisPanelAtt?.breakdown_by) &&
          axisPanelAtt?.breakdown_by?.length > 0
            ? axisPanelAtt?.breakdown_by?.findIndex(
                (b) => b?.attribute === attributeName
              ) === -1
            : true) &&
          (axisPanelAtt?.x_axis?.attribute
            ? attributeName !== axisPanelAtt?.x_axis?.attribute
            : true);
      }
    } else if (["scatter", "multilayer-map"]?.includes(chartType)) {
      if (axis === "x_axis") {
        isAllowedToDrag =
          graphConditions[chartType]?.x_axes?.include?.includes(
            attributeName
          ) &&
          (axisPanelAtt?.breakdown_by &&
          Array.isArray(axisPanelAtt?.breakdown_by) &&
          axisPanelAtt?.breakdown_by?.length > 0
            ? axisPanelAtt?.breakdown_by?.findIndex(
                (b) =>
                  b?.attribute === attributeName &&
                  (axisPanelAtt?.x_axis?.attribute
                    ? b?.attribute !== axisPanelAtt?.x_axis?.attribute
                    : true)
              ) === -1
            : true);
      } else if (axis === "breakdown_by") {
        isAllowedToDrag =
          graphConditions[chartType]?.y_axes?.include?.includes(
            attributeName
          ) &&
          (axisPanelAtt?.breakdown_by &&
          Array.isArray(axisPanelAtt?.breakdown_by) &&
          axisPanelAtt?.breakdown_by?.length > 0
            ? axisPanelAtt?.breakdown_by?.findIndex(
                (b) => b?.attribute === attributeName
              ) === -1
            : true) &&
          (axisPanelAtt?.x_axis?.attribute
            ? attributeName !== axisPanelAtt?.x_axis?.attribute
            : true);
      } else if (axis === "y_axis") {
        let series = destinationDroppableInfo?.split("#")?.[1];
        let seriesIndex = parseInt(series?.split("_")?.[2]);
        // if seriesIndex === 1 that means primary Attribute
        if (seriesIndex === 1) {
          isAllowedToDrag =
            graphConditions[chartType]?.primary_series?.include?.includes(
              attributeName
            ) &&
            (axisPanelAtt?.breakdown_by &&
            Array.isArray(axisPanelAtt?.breakdown_by) &&
            axisPanelAtt?.breakdown_by?.length > 0
              ? axisPanelAtt?.breakdown_by?.findIndex(
                  (b) => b?.attribute === attributeName
                ) === -1
              : true) &&
            (axisPanelAtt?.x_axis?.attribute
              ? attributeName !== axisPanelAtt?.x_axis?.attribute
              : true);
        } else {
          isAllowedToDrag =
            graphConditions[chartType]?.secondary_series?.include?.includes(
              attributeName
            ) &&
            (axisPanelAtt?.breakdown_by &&
            Array.isArray(axisPanelAtt?.breakdown_by) &&
            axisPanelAtt?.breakdown_by?.length > 0
              ? axisPanelAtt?.breakdown_by?.findIndex(
                  (b) => b?.attribute === attributeName
                ) === -1
              : true) &&
            (axisPanelAtt?.x_axis?.attribute
              ? attributeName !== axisPanelAtt?.x_axis?.attribute
              : true);
        }
      }
    } else if (["treemap"]?.includes(chartType)) {
      return false;
      if (axis === "x_axis") {
        isAllowedToDrag =
          (graphConditions[chartType]?.x_axes?.include?.includes(
            attributeName
          ) ||
            graphConditions[chartType]?.enum?.include?.includes(
              attributeName
            )) &&
          (axisPanelAtt?.breakdown_by &&
          Array.isArray(axisPanelAtt?.breakdown_by) &&
          axisPanelAtt?.breakdown_by?.length > 0
            ? axisPanelAtt?.breakdown_by?.findIndex(
                (b) =>
                  b?.attribute === attributeName &&
                  (axisPanelAtt?.x_axis?.attribute
                    ? b?.attribute !== axisPanelAtt?.x_axis?.attribute
                    : true)
              ) === -1
            : true);
      } else if (axis === "breakdown_by") {
        isAllowedToDrag =
          (graphConditions[chartType]?.y_axes?.include?.includes(
            attributeName
          ) ||
            graphConditions[chartType]?.enum?.include?.includes(
              attributeName
            )) &&
          (axisPanelAtt?.breakdown_by &&
          Array.isArray(axisPanelAtt?.breakdown_by) &&
          axisPanelAtt?.breakdown_by?.length > 0
            ? axisPanelAtt?.breakdown_by?.findIndex(
                (b) => b?.attribute === attributeName
              ) === -1
            : true) &&
          (axisPanelAtt?.x_axis?.attribute
            ? attributeName !== axisPanelAtt?.x_axis?.attribute
            : true);
      } else {
        // Prevent duplicate y-series attributes for chart type
        const ySeriesAttributes = axisPanelAtt?.y_axis
          ? Object.values(axisPanelAtt.y_axis)
              ?.map((y) => (y?.attribute ? y?.attribute : null))
              ?.filter((y) => y)
          : [];

        isAllowedToDrag =
          (graphConditions[chartType]?.y_series?.include?.includes(
            attributeName
          ) ||
            !graphConditions[chartType]?.y_series?.exclude?.includes(
              attributeName
            ) ||
            graphConditions[chartType]?.enum?.include?.includes(
              attributeName
            )) &&
          // !ySeriesAttributes?.includes(attributeName) &&
          (axisPanelAtt?.breakdown_by &&
          Array.isArray(axisPanelAtt?.breakdown_by) &&
          axisPanelAtt?.breakdown_by?.length > 0
            ? axisPanelAtt?.breakdown_by?.findIndex(
                (b) => b?.attribute === attributeName
              ) === -1
            : true) &&
          (axisPanelAtt?.x_axis?.attribute
            ? attributeName !== axisPanelAtt?.x_axis?.attribute
            : true);
      }
    }
    return isAllowedToDrag;
  };
  // loops over WM_attributes to find attribute and its data
  function findAttributeObject(attributeName, dataArray) {
    for (const innerArray of dataArray?.map((item) => item[1])) {
      if (Array.isArray(innerArray)) {
        const found = innerArray?.find(
          (item) => Array.isArray(item) && item[0] === attributeName
        );
        if (found) {
          return found[1]; // Return the matching attribute value
        }
      }
    }
    return null;
  }
  function checkAttributeSource(attributes, attName) {
    for (let key in attributes) {
      if (attributes?.hasOwnProperty(key)) {
        let attributeSection = attributes?.[key];
        let attributeContents = attributeSection?.[1];

        for (let i = 0; i < attributeContents?.length; i++) {
          let attribute = attributeContents?.[i];

          if (attribute?.[0] === attName) {
            return attribute?.[1]?.source;
          }
        }
      }
    }

    return false;
  }
  const reorder = (list, startIndex, endIndex) => {
    if (!list || !Array.isArray(list)) return list;
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };
  // Helper: get aggregation type
  const getAggregation = (attr) => {
    if (graphConditionAggregation?.avg?.includes(attr)) return "avg";
    if (graphConditionAggregation?.average_attribute?.includes(attr))
      return "avg";
    if (graphConditionAggregation?.count_distinct?.includes(attr))
      return "COUNT";
    if (graphConditionAggregation?.count?.includes(attr)) return "COUNT";
    if (graphConditionAggregation?.max?.includes(attr)) return "max";
    if (["nss", "srs"].includes(attr)) return "COUNT";
    return "SUM";
  };

  const setFilterByDropdown = (result) => {
    let attributes = { ...WM_attributes };
    const dragType = result?.draggableId?.split("#")[1]; // varchar, int, datetime
    const dragAttr = result?.draggableId?.split("#")[0];

    let newDataSource = checkAttributeSource(attributes, dragAttr);
    const isUpdateMode =
      result?.destination?.droppableId?.split("#")[2] === "update";
    const dropTarget = result?.destination?.droppableId?.split("#")?.[0]; // filter_dropdown
    const dropIndex = result?.destination?.droppableId?.split("#")[4]; // filter_dropdown index
    const isAlreadyInFilterDropdown =
      Array.isArray(axisPanelAtt?.filter_dropdown) &&
      axisPanelAtt?.filter_dropdown?.some((d) => d?.attribute === dragAttr);
    let draggedAttributeObj = findAttributeObject(dragAttr, WM_attributes);
    // check is attribute qualify chart type condition
    let isAllowedToDrag = checkIsAllowedToDrag(
      "filter_dropdown",
      widgetGraphConfig?.chart_type,
      dragAttr,
      result?.destination?.droppableId
    );
    let updatedAxisPanelAtt = { ...axisPanelAtt };
    // Check if the attribute is already in the filter dropdown
    if (isAlreadyInFilterDropdown || dragType !== "varchar") {
      // !isAllowedToDrag currently don't allow drag
      // Update Redux state with new fields
      dispatch(
        setFilterByDropdownAttributes({
          ...updatedAxisPanelAtt,
          [`dragDataType`]: {
            ...updatedAxisPanelAtt[`dragDataType`],
            varchar: false,
            int: false,
            datetime: false,
            json: false,
          },
        })
      );
      callNotification(
        "This attribute cannot be added to Quick Filter Dropdown or is already present.",
        "alert"
      );
      return; // Prevent drop
    }
    // To reset drag state
    updatedAxisPanelAtt = {
      ...updatedAxisPanelAtt,
      [`dragDataType`]: {
        ...updatedAxisPanelAtt[`dragDataType`],
        varchar: false,
        int: false,
        datetime: false,
        json: false,
      },
    };
    // --- Filter By Dropdown Drop ---
    if (dropTarget === "filter_dropdown") {
      // If the attribute is already in the filter dropdown, update it
      if (isUpdateMode && dropIndex !== undefined) {
        const updatedFilterDropdown = axisPanelAtt?.filter_dropdown?.map(
          (d, i) =>
            i == dropIndex
              ? {
                  ...d,
                  attribute: dragAttr,
                  deep_dive_info: draggedAttributeObj?.deep_dive_info || null,
                  trace_name: All_WM_attributes[dragAttr],
                  data_source: newDataSource,
                  // config_filters: setConfigFilters(dragAttr),
                  allow_multiple_selection:
                    d?.allow_multiple_selection !== undefined
                      ? d.allow_multiple_selection
                      : true,
                }
              : d
        );
        updatedAxisPanelAtt = {
          ...updatedAxisPanelAtt,
          data_source: newDataSource,
          filter_dropdown: updatedFilterDropdown,
          filter_by_dropdown: [],
          filter_by_dropdown_data: [],
        };
      } else {
        // If not, add it to the filter dropdown
        // Create a new filter dropdown object
        const newFilterDropdown = {
          attribute: dragAttr,
          trace_name: All_WM_attributes[dragAttr],
          deep_dive_info: draggedAttributeObj?.deep_dive_info || null,
          data_source: newDataSource,
          // config_filters: setConfigFilters(dragAttr),
          date_part: null,
          date_aggregation: null,
          frequency: null,
          sort_order: "desc",
          limit: 30,
          span_on: false,
        };

        updatedAxisPanelAtt = {
          ...updatedAxisPanelAtt,
          data_source: newDataSource,
          filter_dropdown: [
            ...(axisPanelAtt?.filter_dropdown || []),
            newFilterDropdown,
          ],
          filter_by_dropdown: [],
          filter_by_dropdown_data: [],
        };
      }

      // Update Redux state with new fields
      dispatch(setFilterByDropdownAttributes(updatedAxisPanelAtt));
    }
  };

  const onDragEnd = (result) => {
    // --- For Filter By DropDown ---
    if (
      result?.destination?.droppableId?.split("#")?.[0] === "filter_dropdown"
    ) {
      setFilterByDropdown(result);
      return;
    }

    // --- Rich Text Widget: Handle drag to Selected Fields ---
    if (widgetGraphConfig?.chart_type === "rich-text" && result.destination) {
      // Check for both "rich-fields" and "fields" droppableIds for backward compatibility
      if (
        result?.destination?.droppableId?.split("#")?.[1] === "rich_fields" ||
        result?.destination?.droppableId?.split("#")?.[1] === "fields"
      ) {
        const [attName, dataType] = result.draggableId.split("#");
        let attributes = { ...WM_attributes };
        const newDataSource = checkAttributeSource(attributes, attName);
        // Check if this field is being added directly as a rich field
        // or also being added to another axis (x_axis, breakdown_by, y_series)
        let updatedAxisPanelAtt = { ...axisPanelAtt };
        if (result.destination.droppableId.split("#")[1] === "rich_fields") {
          const isHashtagMode =
            widgetGraphConfig?.x_axis?.attribute === "Hashtags";
          const isUpdateMode =
            result?.destination?.droppableId?.split("#")[3] === "update";
          const dropTarget = result?.destination?.droppableId?.split("#")[4]; // x_axis, breakdown_by, y_series
          const dropIndex = result?.destination?.droppableId?.split("#")[5];
          const dragType = result?.draggableId?.split("#")[1]; // varchar, int, datetime
          const dragAttr = result?.draggableId?.split("#")[0];
          const isAlreadyInBreakdown = axisPanelAtt?.breakdown_by?.some(
            (d) => d?.attribute === dragAttr
          );
          const skipForYSeries =
            ["nss", "srs"].includes(dragAttr) ||
            graphConditions?.["time-label-attrs"]?.includes(dragAttr);
          let filterVal = {};
          Object.entries(axisPanelAtt.y_axis).forEach((e) => {
            if (e[1].attribute !== null && !e[1]?.hide_on_ui) {
              filterVal = { ...filterVal, [e[0]]: e[1] };
            }
          });
          let draggedAttributeObj = findAttributeObject(
            dragAttr,
            WM_attributes
          );
          // check is attribute qualify chart type condition
          let isAllowedToDrag = checkIsAllowedToDrag(
            isUpdateMode
              ? dropTarget === "x_axis"
                ? "x_axis"
                : dropTarget === "breakdown_by"
                ? "breakdown_by"
                : dropTarget === "y_series"
                ? "y_series"
                : dropTarget === "y_axis"
                ? "y_axis"
                : ""
              : dragType === "int" && !skipForYSeries
              ? "y_series"
              : !axisPanelAtt?.x_axis?.attribute &&
                (dragType === "varchar" || dragType === "datetime")
              ? "x_axis"
              : axisPanelAtt?.breakdown_by?.length < 5 &&
                axisPanelAtt?.x_axis?.attribute &&
                dragType === "varchar"
              ? "breakdown_by"
              : "",
            "rich-text",
            dragAttr,
            result?.destination?.droppableId
          );
          let xCount = axisPanelAtt?.x_axis?.attribute ? 1 : 0;
          let y_series_array_drag = [];
          y_series_array_drag = Object.keys(axisPanelAtt?.y_axis)
            ?.map((key) => axisPanelAtt?.y_axis[key])
            ?.filter((d) => d?.attribute);
          let ySeriesCount = y_series_array_drag
            ? y_series_array_drag?.length
            : 0;
          let bCount =
            axisPanelAtt?.breakdown_by && axisPanelAtt?.breakdown_by?.length;
          let intCount = ySeriesCount;
          let varcharCount = bCount + xCount;
          let isValidToDrag = isUpdateMode
            ? true
            : dragType === "int"
            ? intCount < 5
            : dragType === "varchar" || dragType === "datetime"
            ? varcharCount < 5
            : true;
          if (!isAllowedToDrag || !isValidToDrag) {
            // Update Redux state with new fields
            dispatch(
              setRichFields({
                ...updatedAxisPanelAtt,
                [`dragDataType`]: {
                  ...updatedAxisPanelAtt[`dragDataType`],
                  varchar: false,
                  int: false,
                  datetime: false,
                  json: false,
                },
              })
            );
            callNotification(
              !isValidToDrag
                ? "Rich Text widget supports up to 5 integer attributes and 5 varchar attributes."
                : "This attribute cannot be added to Rich Text or is already present.",
              "alert"
            );
            return; // Prevent drop
          }
          // --- X Axis Drop ---
          if (
            isUpdateMode &&
            dropTarget === "x_axis" &&
            (dragType === "varchar" || dragType === "datetime") &&
            !isAlreadyInBreakdown
          ) {
            const updatedXAxis = {
              ...axisPanelAtt?.x_axis,
              attribute: dragAttr,
              deep_dive_info: draggedAttributeObj?.deep_dive_info || null,
              trace_name: All_WM_attributes[dragAttr],
              data_source: newDataSource,
              x_limit: 1,
            };

            updatedAxisPanelAtt = {
              ...updatedAxisPanelAtt,
              x_axis: updatedXAxis,
              data_source: newDataSource,
            };
          }
          // --- Breakdown By Drop ---
          else if (
            isUpdateMode &&
            dropTarget === "breakdown_by" &&
            dragType === "varchar" &&
            !isAlreadyInBreakdown &&
            dragAttr !== axisPanelAtt?.x_axis?.attribute
          ) {
            const updatedBreakdownBy = axisPanelAtt?.breakdown_by?.map((d, i) =>
              i == dropIndex
                ? {
                    ...d,
                    attribute: dragAttr,
                    deep_dive_info: draggedAttributeObj?.deep_dive_info || null,
                    trace_name: All_WM_attributes[dragAttr],
                    data_source: newDataSource,
                    sort_order: "desc",
                    y_limit: 1,
                    date_part: null,
                  }
                : d
            );

            updatedAxisPanelAtt = {
              ...updatedAxisPanelAtt,
              data_source: newDataSource,
              breakdown_by: updatedBreakdownBy,
              chart_settings: {
                ...axisPanelAtt.chart_settings,
                total_row: false,
              },
            };
          }
          // --- Y Series Drop (Update Mode) ---
          else if (
            isUpdateMode &&
            dropTarget === "y_series" &&
            dragType === "int" &&
            !skipForYSeries
          ) {
            const updatedYSeries = {
              ...axisPanelAtt.y_axis?.[dropIndex],
              attribute: dragAttr,
              deep_dive_info: draggedAttributeObj?.deep_dive_info || null,
              trace_name: All_WM_attributes[dragAttr],
              data_source: newDataSource,
              aggregation: getAggregation(dragAttr),
            };

            updatedAxisPanelAtt = {
              ...updatedAxisPanelAtt,
              data_source: newDataSource,
              y_axis: {
                ...updatedAxisPanelAtt?.y_axis,
                [dropIndex]: updatedYSeries,
              },
            };
          }

          // --- New Y Series Drop (Normal Mode) ---
          else if (!isUpdateMode && dragType === "int" && !skipForYSeries) {
            const newKey = `y_series_${
              Object.keys(filterVal || {}).length + 1
            }`;
            const newYSeries = {
              attribute: dragAttr,
              trace_name: All_WM_attributes[dragAttr],
              deep_dive_info: draggedAttributeObj?.deep_dive_info || null,
              data_source: newDataSource,
              aggregation: getAggregation(dragAttr),
            };
            updatedAxisPanelAtt = {
              ...updatedAxisPanelAtt,
              data_source: newDataSource,
              y_axis: {
                ...(filterVal || {}),
                [newKey]: newYSeries,
              },
              dragDataType: {
                varchar: false,
                int: false,
                datetime: false,
                json: false,
              },
            };
          }

          // --- First X Axis Drop (if not set yet) ---
          else if (
            !axisPanelAtt?.x_axis?.attribute &&
            (dragType === "varchar" || dragType === "datetime")
          ) {
            const fallbackYAttr =
              newDataSource === "tickets"
                ? "caseid"
                : newDataSource === "page"
                ? "page_followers_count"
                : "tagid";

            const fallbackYSeries = {
              attribute: fallbackYAttr,
              aggregation: getAggregation(fallbackYAttr),
              trace_name: All_WM_attributes[fallbackYAttr],
              data_source: newDataSource,
              hide_on_ui: true,
            };

            updatedAxisPanelAtt = {
              ...updatedAxisPanelAtt,
              data_source: newDataSource,
              x_axis: {
                attribute: dragAttr,
                trace_name: All_WM_attributes[dragAttr],
                deep_dive_info: draggedAttributeObj?.deep_dive_info || null,
                date_part: null,
                sort_order: "desc",
                x_limit: 1,
                data_source: newDataSource,
              },
              y_axis:
                axisPanelAtt?.y_axis?.y_series_1?.attribute &&
                axisPanelAtt?.y_axis?.y_series_1?.attribute !== "caseid"
                  ? axisPanelAtt.y_axis
                  : { y_series_1: fallbackYSeries },
              dragDataType: {
                varchar: false,
                int: false,
                datetime: false,
                json: false,
              },
            };
          }

          // --- Add to Breakdown If Under Limit ---
          else if (
            axisPanelAtt?.breakdown_by?.length < 5 &&
            axisPanelAtt?.x_axis?.attribute &&
            dragType === "varchar" &&
            dragAttr !== axisPanelAtt?.x_axis?.attribute &&
            !isAlreadyInBreakdown &&
            dragAttr !== "Hashtags"
          ) {
            const newBreakdown = {
              attribute: dragAttr,
              trace_name: All_WM_attributes[dragAttr],
              deep_dive_info: draggedAttributeObj?.deep_dive_info || null,
              data_source: newDataSource,
              sort_order: "desc",
              y_limit: 1,
              date_part: null,
            };
            updatedAxisPanelAtt = {
              ...updatedAxisPanelAtt,
              data_source: newDataSource,
              breakdown_by: [...axisPanelAtt.breakdown_by, newBreakdown],
              chart_settings: {
                ...axisPanelAtt.chart_settings,
                total_row: false,
              },
              dragDataType: {
                varchar: false,
                int: false,
                datetime: false,
                json: false,
              },
            };
          }
        }

        // Update Redux state with new fields
        dispatch(
          setRichFields({
            ...updatedAxisPanelAtt,
            [`dragDataType`]: {
              ...updatedAxisPanelAtt[`dragDataType`],
              varchar: false,
              int: false,
              datetime: false,
              json: false,
            },
          })
        );
        return;
      }
    }
    // Here we are handling our kpi rearragement thing
    if (result?.type === "CardSettingColumn") {
      if (!result?.destination) {
        return;
      }
      const source = result?.source;
      const destination = result?.destination;
      // did not move anywhere - can bail early
      if (
        source?.droppableId === destination?.droppableId &&
        source?.index === destination?.index
      ) {
        return;
      }
      let avaliableCardSettings = axisPanelAtt?.card_settings?.filter((e) => e);
      if (avaliableCardSettings && Array.isArray(avaliableCardSettings)) {
        const swappedCardSettings = reorder(
          avaliableCardSettings,
          source?.index,
          destination?.index
        );
        if (swappedCardSettings && Array.isArray(swappedCardSettings)) {
          let modifieldCardSettings = swappedCardSettings?.map((d, i) => {
            return { ...d, card_name: i + 1 };
          });
          let graphConfig = {
            ...axisPanelAtt,
            card_settings: modifieldCardSettings,
          };
          dispatch(setCardSettings(graphConfig));
        }
      }
      return;
    }
    const [attName, dataType] = result.draggableId.split("#");
    let attributes = { ...WM_attributes };
    const newDataSource = checkAttributeSource(attributes, attName);
    setUpdatedDataSource(newDataSource);
    if (newDataSource) {
      dispatch(setDataSource(newDataSource));
    }
    let seriesvalue = result?.destination?.droppableId?.split("#")?.[1]
      ? result?.destination?.droppableId?.split("#")?.[1]
      : "";
    let y_series_flag = getWidgetMakerFlag(widgetGraphConfig, wm_api_flag);
    if (
      !y_series_flag?.flag ||
      y_series_flag?.value?.includes(seriesvalue) ||
      y_series_flag?.value?.includes(result?.destination?.droppableId)
    ) {
      if (
        !result.destination ||
        result.destination.droppableId.split("#")[1] === "member"
      ) {
        dispatch(
          setX_attribute({
            ...axisPanelAtt,
            [`dragDataType`]: {
              ...axisPanelAtt[`dragDataType`],
              varchar: false,
              int: false,
              datetime: false,
              json: false,
            },
          })
        );
        return;
      }
      let draggedAttributeObj = findAttributeObject(
        result?.draggableId?.split("#")[0],
        WM_attributes
      );
      // This condition is for attributes in graphConditions[common]. In all cases breakdown_by and all other y_series is nulled.
      if (
        graphConditions?.common?.some(
          (item) => item.attribute === result.draggableId.split("#")[0]
        )
      ) {
        dispatch(
          setX_attribute({
            ...axisPanelAtt,
            data_source: newDataSource,
            [`y_axis`]: {
              [`y_series_1`]: {
                attribute: result.draggableId.split("#")[0],
                deep_dive_info: draggedAttributeObj?.deep_dive_info
                  ? draggedAttributeObj?.deep_dive_info
                  : null,
                data_source: newDataSource,
                aggregation: graphConditionAggregation?.avg?.includes(
                  result.draggableId.split("#")[0]
                )
                  ? "avg"
                  : graphConditionAggregation?.average_attribute?.includes(
                      // For mentions attribute
                      result.draggableId.split("#")[0]
                    )
                  ? "avg"
                  : graphConditionAggregation?.count_distinct?.includes(
                      result.draggableId.split("#")[0]
                    )
                  ? "COUNT"
                  : graphConditionAggregation?.count?.includes(
                      result.draggableId.split("#")[0]
                    )
                  ? "COUNT"
                  : graphConditionAggregation?.max?.includes(
                      result.draggableId.split("#")[0]
                    )
                  ? "max"
                  : result.draggableId.split("#")[0] === "nss"
                  ? "COUNT"
                  : result.draggableId.split("#")[0] === "srs"
                  ? "COUNT"
                  : "COUNT",
                trace_name: All_WM_attributes[result.draggableId.split("#")[0]],
              },
            },
            [`breakdown_by`]: [],
            [`filter_by`]: [],
            [`filter_dropdown`]: [],
            [`dragDataType`]: {
              ...axisPanelAtt[`dragDataType`],
              varchar: false,
              int: false,
              datetime: false,
              json: false,
            },
          })
        );
        return;
      }
      // check is attribute qualify chart type condition
      let isAllowedToDrag = checkIsAllowedToDrag(
        result?.destination?.droppableId === "x_axis"
          ? "x_axis"
          : result?.destination?.droppableId?.split("#")?.[0] === "breakdown_by"
          ? "breakdown_by"
          : result?.destination?.droppableId?.split("#")?.[0] === "y_axis"
          ? "y_axis"
          : "",
        widgetGraphConfig?.chart_type,
        result?.draggableId?.split("#")?.[0],
        result?.destination?.droppableId
      );
      let ySeriesAttributeName =
        Array.isArray(graphConditions?.["sankey"]?.y_series?.exclude) &&
        graphConditions?.["sankey"]?.y_series?.exclude?.length > 0
          ? graphConditions?.["sankey"]?.y_series?.exclude?.[0]
          : null;
      let defaultYSeriesAttrForNetwork = ySeriesAttributeName;
      let dateWithDateChartTypes =
        graphConditions?.["date_with_date-chart_types"] &&
        Array.isArray(graphConditions?.["date_with_date-chart_types"])
          ? graphConditions?.["date_with_date-chart_types"]
          : [];
      if (
        (((result.draggableId.split("#")[1] === "varchar" ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "combination") ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "bar") ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "horizontal-bar") ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "lollipop") ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "area") ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "line") ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "pie") ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "donut") ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "pivot-grid") ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "treemap") ||
          (result?.draggableId?.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "heatmap")) &&
          ![
            "sankey",
            "scatter",
            "quadrant",
            "multilayer-map",
            // "treemap",
          ]?.includes(widgetGraphConfig?.chart_type) &&
          ((result?.draggableId?.split("#")[1] === "datetime" &&
            dateWithDateChartTypes?.includes(widgetGraphConfig?.chart_type) &&
            result?.draggableId?.split("#")[0] ===
              axisPanelAtt?.breakdown_by?.[0]?.attribute) ||
            result?.draggableId?.split("#")[0] !==
              axisPanelAtt?.breakdown_by?.[0]?.attribute)) ||
          ([
            "sankey",
            "scatter",
            "quadrant",
            "multilayer-map",
            // "treemap",
          ]?.includes(widgetGraphConfig?.chart_type) &&
            isAllowedToDrag)) &&
        result.destination.droppableId === "x_axis"
      ) {
        if (
          // for KPI && progress KPI with varchar
          ["kpi", "progress-kpi"]?.includes(widgetGraphConfig?.chart_type) &&
          ![
            "combination",
            "scatter",
            "wordcloud",
            "heatmap",
            "bubble",
            "sunburst",
            "sankey",
            "multilayer-map",
          ]?.includes(widgetGraphConfig?.chart_type) &&
          result.draggableId.split("#")[1] === "varchar" &&
          result.draggableId.split("#")[0] !== "Keyword" &&
          result.draggableId.split("#")[0] !== "TagCloud" &&
          result.draggableId.split("#")[0] !== "Hashtags"
        ) {
          dispatch(
            setX_attribute({
              ...axisPanelAtt,
              [result.destination.droppableId]: {
                attribute: result.draggableId.split("#")[0],
                deep_dive_info: draggedAttributeObj?.deep_dive_info
                  ? draggedAttributeObj?.deep_dive_info
                  : null,
                data_source: newDataSource,
                trace_name: All_WM_attributes[result.draggableId.split("#")[0]],
                date_part:
                  widgetGraphConfig?.chart_type === "pie"
                    ? "ww"
                    : widgetGraphConfig?.chart_type === "donut"
                    ? "ww"
                    : null,
                sort_order:
                  result.draggableId.split("#")[1] === "datetime"
                    ? "asc"
                    : "desc",
                x_limit: 10,
              },
              [`y_axis`]:
                newDataSource === "tickets"
                  ? {
                      [`y_series_1`]: {
                        attribute: "caseid",
                        aggregation: "COUNT",
                        trace_name: All_WM_attributes["caseid"],
                        data_source: newDataSource,
                      },
                    }
                  : newDataSource === "page"
                  ? {
                      [`y_series_1`]: {
                        attribute: "page_followers_count",
                        aggregation: "SUM",
                        trace_name: All_WM_attributes["page_followers_count"],
                        data_source: newDataSource,
                      },
                    }
                  : {
                      [`y_series_1`]: {
                        attribute: "tagid",
                        aggregation: "COUNT",
                        trace_name: All_WM_attributes["tagid"],
                        data_source: "mentions",
                      },
                    },
              [`y_axis_settings`]: [
                ...axisPanelAtt[`y_axis_settings`],
                {
                  show_as:
                    axisPanelAtt?.y_axis_settings?.length === 0
                      ? "bar"
                      : "line",
                  y_axis_map_at:
                    axisPanelAtt?.y_axis_settings?.length === 0 ? 0 : 1,
                  y_axis_scale: "linear",
                  color_pattern_code: 1,
                  key: uuid(),
                },
              ],
              [`dragDataType`]: {
                ...axisPanelAtt[`dragDataType`],
                varchar: false,
                int: false,
                datetime: false,
                json: false,
              },
            })
          );
        } else if (
          ["wordcloud", "heatmap", "bubble", "sankey", "sunburst"]?.includes(
            widgetGraphConfig?.chart_type
          ) &&
          (result?.draggableId?.split("#")[1] === "varchar" ||
            (widgetGraphConfig?.chart_type === "heatmap" &&
              result?.draggableId?.split("#")[1] === "datetime")) &&
          result.draggableId.split("#")[0] !== "Rating" &&
          ![
            "kpi",
            "progress-kpi",
            "combination",
            "scatter",
            "multilayer-map",
          ]?.includes(widgetGraphConfig?.chart_type)
        ) {
          dispatch(
            setX_attribute({
              ...axisPanelAtt,
              [result.destination.droppableId]: {
                attribute: result.draggableId.split("#")[0],
                deep_dive_info: draggedAttributeObj?.deep_dive_info
                  ? draggedAttributeObj?.deep_dive_info
                  : null,
                data_source: newDataSource,
                trace_name: All_WM_attributes[result.draggableId.split("#")[0]],
                date_part:
                  widgetGraphConfig?.chart_type === "pie"
                    ? "ww"
                    : widgetGraphConfig?.chart_type === "donut"
                    ? "ww"
                    : null,
                sort_order:
                  result.draggableId.split("#")[1] === "datetime"
                    ? "asc"
                    : "desc",
                x_limit: 10,
              },
              [`y_axis`]: {
                [`y_series_1`]: widgetGraphConfig?.y_axis?.y_series_1?.attribute
                  ? widgetGraphConfig?.y_axis?.y_series_1
                  : newDataSource === "tickets"
                  ? {
                      attribute: "caseid",
                      aggregation: "COUNT",
                      trace_name: All_WM_attributes["caseid"],
                      data_source: newDataSource,
                    }
                  : newDataSource === "page"
                  ? {
                      attribute: "page_followers_count",
                      aggregation: "SUM",
                      trace_name: All_WM_attributes["page_followers_count"],
                      data_source: newDataSource,
                    }
                  : {
                      attribute: `${
                        widgetGraphConfig?.chart_type === "sankey"
                          ? "caseid"
                          : "tagid"
                      }`,
                      data_source: `${
                        widgetGraphConfig?.chart_type === "sankey"
                          ? "tickets"
                          : "mentions"
                      }`,
                      aggregation: "COUNT",
                      trace_name:
                        All_WM_attributes[
                          `${
                            widgetGraphConfig?.chart_type === "sankey"
                              ? "caseid"
                              : "tagid"
                          }`
                        ],
                    },
              },
              [`y_axis_settings`]: [
                ...axisPanelAtt[`y_axis_settings`],
                {
                  show_as:
                    axisPanelAtt?.y_axis_settings?.length === 0
                      ? "bar"
                      : "line",
                  y_axis_map_at:
                    axisPanelAtt?.y_axis_settings?.length === 0 ? 0 : 1,
                  y_axis_scale: "linear",
                  color_pattern_code: 1,
                  key: uuid(),
                },
              ],
              [`chart_settings`]:
                widgetGraphConfig?.chart_type === "wordcloud"
                  ? {
                      ...axisPanelAtt?.chart_settings,
                      wordcloud_color: "0",
                    }
                  : axisPanelAtt?.chart_settings,
              [`dragDataType`]: {
                ...axisPanelAtt[`dragDataType`],
                varchar: false,
                int: false,
                datetime: false,
                json: false,
              },
            })
          );
        } else if (
          (widgetGraphConfig?.chart_type === "wordcloud" ||
            widgetGraphConfig?.chart_type === "heatmap" ||
            widgetGraphConfig?.chart_type === "bubble" ||
            widgetGraphConfig?.chart_type === "sunburst") &&
          result.draggableId.split("#")[1] === "varchar" &&
          result.draggableId.split("#")[0] !== "rating" &&
          ![
            "kpi",
            "progress-kpi",
            "combination",
            "scatter",
            "wordcloud",
            "heatmap",
            "bubble",
            "sankey",
            "sunburst",
            "multilayer-map",
          ]?.includes(widgetGraphConfig?.chart_type)
        ) {
          if (widgetGraphConfig?.y_axis?.y_series_1?.attribute === "srs") {
            // only for BrandName and CreatedDate attribute
            if (
              result.draggableId.split("#")[0] === "CreatedDate" ||
              result.draggableId.split("#")[0] === "BrandName"
            ) {
              dispatch(
                setX_attribute({
                  ...axisPanelAtt,
                  [result.destination.droppableId]: {
                    attribute: result.draggableId.split("#")[0],
                    deep_dive_info: draggedAttributeObj?.deep_dive_info
                      ? draggedAttributeObj?.deep_dive_info
                      : null,
                    data_source: newDataSource,
                    trace_name:
                      All_WM_attributes[result.draggableId.split("#")[0]],
                    date_part:
                      widgetGraphConfig?.chart_type === "pie"
                        ? "ww"
                        : widgetGraphConfig?.chart_type === "donut"
                        ? "ww"
                        : null,
                    sort_order:
                      result.draggableId.split("#")[1] === "datetime"
                        ? "asc"
                        : "desc",
                    x_limit:
                      axisPanelAtt?.chart_type === "bar" ||
                      axisPanelAtt?.chart_type === "horizontal-bar" ||
                      axisPanelAtt?.chart_type === "lollipop" ||
                      axisPanelAtt?.chart_type === "area" ||
                      axisPanelAtt?.chart_type === "line" ||
                      axisPanelAtt?.chart_type === "heatmap" ||
                      axisPanelAtt?.chart_type === "scatter" ||
                      axisPanelAtt?.chart_type === "quadrant" ||
                      axisPanelAtt?.chart_type === "treemap"
                        ? 30
                        : axisPanelAtt?.chart_type === "pie" ||
                          axisPanelAtt?.chart_type === "donut"
                        ? 6
                        : axisPanelAtt?.chart_type === "kpi" ||
                          axisPanelAtt?.chart_type === "progress-kpi" ||
                          axisPanelAtt?.chart_type === "sunburst"
                        ? 10
                        : axisPanelAtt?.chart_type === "bubble" ||
                          axisPanelAtt?.chart_type === "wordcloud"
                        ? 20
                        : 50,
                  },
                  [`dragDataType`]: {
                    ...axisPanelAtt[`dragDataType`],
                    varchar: false,
                    int: false,
                    datetime: false,
                    json: false,
                  },
                })
              );
            } else {
              // Dont Drag
            }
            // only for BrandName and CreatedDate attribute
            if (
              result.draggableId.split("#")[0] === "CreatedDate" ||
              result.draggableId.split("#")[0] === "BrandName"
            ) {
              dispatch(
                setX_attribute({
                  ...axisPanelAtt,
                  [result.destination.droppableId]: {
                    attribute: result.draggableId.split("#")[0],
                    deep_dive_info: draggedAttributeObj?.deep_dive_info
                      ? draggedAttributeObj?.deep_dive_info
                      : null,
                    data_source: newDataSource,
                    trace_name:
                      All_WM_attributes[result.draggableId.split("#")[0]],
                    date_part:
                      widgetGraphConfig?.chart_type === "pie"
                        ? "ww"
                        : widgetGraphConfig?.chart_type === "donut"
                        ? "ww"
                        : null,
                    sort_order:
                      result.draggableId.split("#")[1] === "datetime"
                        ? "asc"
                        : "desc",
                    x_limit:
                      axisPanelAtt?.chart_type === "bar" ||
                      axisPanelAtt?.chart_type === "horizontal-bar" ||
                      axisPanelAtt?.chart_type === "lollipop" ||
                      axisPanelAtt?.chart_type === "area" ||
                      axisPanelAtt?.chart_type === "line" ||
                      axisPanelAtt?.chart_type === "heatmap" ||
                      axisPanelAtt?.chart_type === "scatter" ||
                      axisPanelAtt?.chart_type === "quadrant" ||
                      axisPanelAtt?.chart_type === "treemap"
                        ? 30
                        : axisPanelAtt?.chart_type === "pie" ||
                          axisPanelAtt?.chart_type === "donut"
                        ? 6
                        : axisPanelAtt?.chart_type === "kpi" ||
                          axisPanelAtt?.chart_type === "progress-kpi" ||
                          axisPanelAtt?.chart_type === "sunburst"
                        ? 10
                        : axisPanelAtt?.chart_type === "bubble" ||
                          axisPanelAtt?.chart_type === "wordcloud"
                        ? 20
                        : 50,
                  },
                  [`dragDataType`]: {
                    ...axisPanelAtt[`dragDataType`],
                    varchar: false,
                    int: false,
                    datetime: false,
                    json: false,
                  },
                })
              );
            } else {
              // Dont Drag
            }
          }
        } else if (
          widgetGraphConfig?.chart_type !== "kpi" &&
          widgetGraphConfig?.chart_type !== "combination" &&
          widgetGraphConfig?.chart_type !== "wordcloud" &&
          widgetGraphConfig?.chart_type !== "heatmap" &&
          widgetGraphConfig?.chart_type !== "bubble" &&
          widgetGraphConfig?.chart_type !== "sunburst" &&
          widgetGraphConfig?.chart_type !== "scatter" &&
          widgetGraphConfig?.chart_type !== "multilayer-map"
        ) {
          if (widgetGraphConfig?.y_axis?.y_series_1?.attribute === "srs") {
          } else {
            axisPanelAtt["y_axis"]["y_series_1"].attribute
              ? dispatch(
                  setX_attribute({
                    ...axisPanelAtt,
                    [result.destination.droppableId]: {
                      attribute: result.draggableId.split("#")[0],
                      deep_dive_info: draggedAttributeObj?.deep_dive_info
                        ? draggedAttributeObj?.deep_dive_info
                        : null,
                      data_source: newDataSource,
                      trace_name:
                        All_WM_attributes[result.draggableId.split("#")[0]],
                      date_part:
                        widgetGraphConfig?.chart_type === "pie"
                          ? "ww"
                          : widgetGraphConfig?.chart_type === "donut"
                          ? "ww"
                          : null,
                      sort_order:
                        result.draggableId.split("#")[1] === "datetime"
                          ? "asc"
                          : "desc",
                      x_limit:
                        axisPanelAtt?.chart_type === "bar" ||
                        axisPanelAtt?.chart_type === "horizontal-bar" ||
                        axisPanelAtt?.chart_type === "lollipop" ||
                        axisPanelAtt?.chart_type === "area" ||
                        axisPanelAtt?.chart_type === "line" ||
                        axisPanelAtt?.chart_type === "heatmap" ||
                        axisPanelAtt?.chart_type === "scatter" ||
                        axisPanelAtt?.chart_type === "quadrant" ||
                        axisPanelAtt?.chart_type === "treemap"
                          ? 30
                          : axisPanelAtt?.chart_type === "pie" ||
                            axisPanelAtt?.chart_type === "donut"
                          ? 6
                          : axisPanelAtt?.chart_type === "kpi" ||
                            axisPanelAtt?.chart_type === "progress-kpi" ||
                            axisPanelAtt?.chart_type === "sankey" ||
                            axisPanelAtt?.chart_type === "sunburst"
                          ? 10
                          : axisPanelAtt?.chart_type === "bubble" ||
                            axisPanelAtt?.chart_type === "wordcloud"
                          ? 20
                          : 50,
                    },
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                  })
                )
              : dispatch(
                  setX_attribute({
                    ...axisPanelAtt,
                    [result.destination.droppableId]: {
                      attribute: result.draggableId.split("#")[0],
                      deep_dive_info: draggedAttributeObj?.deep_dive_info
                        ? draggedAttributeObj?.deep_dive_info
                        : null,
                      data_source: newDataSource,
                      trace_name:
                        All_WM_attributes[result.draggableId.split("#")[0]],
                      date_part:
                        widgetGraphConfig?.chart_type === "pie"
                          ? "ww"
                          : widgetGraphConfig?.chart_type === "donut"
                          ? "ww"
                          : null,
                      sort_order:
                        result.draggableId.split("#")[1] === "datetime"
                          ? "asc"
                          : "desc",
                      x_limit:
                        axisPanelAtt?.chart_type === "bar" ||
                        axisPanelAtt?.chart_type === "horizontal-bar" ||
                        axisPanelAtt?.chart_type === "lollipop" ||
                        axisPanelAtt?.chart_type === "area" ||
                        axisPanelAtt?.chart_type === "line" ||
                        axisPanelAtt?.chart_type === "heatmap" ||
                        axisPanelAtt?.chart_type === "scatter" ||
                        axisPanelAtt?.chart_type === "quadrant" ||
                        axisPanelAtt?.chart_type === "treemap"
                          ? 30
                          : axisPanelAtt?.chart_type === "pie" ||
                            axisPanelAtt?.chart_type === "donut"
                          ? 6
                          : axisPanelAtt?.chart_type === "kpi" ||
                            axisPanelAtt?.chart_type === "progress-kpi" ||
                            axisPanelAtt?.chart_type === "sankey" ||
                            axisPanelAtt?.chart_type === "sunburst"
                          ? 10
                          : axisPanelAtt?.chart_type === "bubble" ||
                            axisPanelAtt?.chart_type === "wordcloud"
                          ? 20
                          : 50,
                    },
                    [`y_axis`]:
                      newDataSource === "tickets"
                        ? {
                            [`y_series_1`]: {
                              attribute: "caseid",
                              aggregation: "COUNT",
                              trace_name: All_WM_attributes["caseid"],
                              data_source: newDataSource,
                            },
                          }
                        : newDataSource === "page"
                        ? {
                            [`y_series_1`]: {
                              attribute: "page_followers_count",
                              aggregation: "SUM",
                              trace_name:
                                All_WM_attributes["page_followers_count"],
                              data_source: newDataSource,
                            },
                          }
                        : {
                            [`y_series_1`]: {
                              attribute: "tagid",
                              aggregation: "COUNT",
                              trace_name: All_WM_attributes["tagid"],
                              data_source: "mentions",
                            },
                          },
                    [`y_axis_settings`]: [
                      ...axisPanelAtt[`y_axis_settings`],
                      {
                        show_as:
                          axisPanelAtt?.y_axis_settings?.length === 0
                            ? "bar"
                            : "line",
                        y_axis_map_at:
                          axisPanelAtt?.y_axis_settings?.length === 0 ? 0 : 1,
                        y_axis_scale: "linear",
                        color_pattern_code: 1,
                        key: uuid(),
                      },
                    ],
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                  })
                );
          }
        } else if (widgetGraphConfig?.chart_type === "combination") {
          axisPanelAtt["y_axis"]["y_series_1"].attribute
            ? dispatch(
                setX_attribute({
                  ...axisPanelAtt,
                  [result.destination.droppableId]: {
                    attribute: result.draggableId.split("#")[0],
                    deep_dive_info: draggedAttributeObj?.deep_dive_info
                      ? draggedAttributeObj?.deep_dive_info
                      : null,
                    data_source: newDataSource,
                    trace_name:
                      All_WM_attributes[result.draggableId.split("#")[0]],
                    date_part:
                      widgetGraphConfig?.chart_type === "pie"
                        ? "ww"
                        : widgetGraphConfig?.chart_type === "donut"
                        ? "ww"
                        : null,
                    sort_order:
                      result.draggableId.split("#")[1] === "datetime"
                        ? "asc"
                        : "desc",
                    x_limit: 30,
                  },
                  [`dragDataType`]: {
                    ...axisPanelAtt[`dragDataType`],
                    varchar: false,
                    int: false,
                    datetime: false,
                    json: false,
                  },
                })
              )
            : dispatch(
                setX_attribute({
                  ...axisPanelAtt,
                  [result.destination.droppableId]: {
                    attribute: result.draggableId.split("#")[0],
                    deep_dive_info: draggedAttributeObj?.deep_dive_info
                      ? draggedAttributeObj?.deep_dive_info
                      : null,
                    data_source: newDataSource,
                    trace_name:
                      All_WM_attributes[result.draggableId.split("#")[0]],
                    date_part:
                      widgetGraphConfig?.chart_type === "pie"
                        ? "ww"
                        : widgetGraphConfig?.chart_type === "donut"
                        ? "ww"
                        : null,
                    sort_order:
                      result.draggableId.split("#")[1] === "datetime"
                        ? "asc"
                        : "desc",
                    x_limit: 30,
                  },
                  [`y_axis`]:
                    newDataSource === "tickets"
                      ? {
                          [`y_series_1`]: {
                            attribute: "FirstlevelTAT_Seconds",
                            aggregation: "avg",
                            trace_name:
                              All_WM_attributes["FirstlevelTAT_Seconds"],
                            data_source: newDataSource,
                          },
                          [`y_series_2`]: {
                            attribute: "caseid",
                            aggregation: "COUNT",
                            trace_name: All_WM_attributes["caseid"],
                            data_source: newDataSource,
                          },
                        }
                      : newDataSource === "page"
                      ? {
                          [`y_series_1`]: {
                            attribute: "page_followers_count",
                            aggregation: "SUM",
                            trace_name:
                              All_WM_attributes["page_followers_count"],
                            data_source: newDataSource,
                          },

                          [`y_series_2`]: {
                            attribute: "page_reactions_like",
                            aggregation: "SUM",
                            trace_name:
                              All_WM_attributes["page_reactions_like"],
                            data_source: newDataSource,
                          },
                        }
                      : {
                          [`y_series_1`]: {
                            attribute: "tagid",
                            aggregation: "COUNT",
                            trace_name: All_WM_attributes["tagid"],
                            data_source: "mentions",
                          },
                          [`y_series_2`]: {
                            attribute: "NumLikesCount",
                            aggregation: "SUM",
                            trace_name: All_WM_attributes["NumLikesCount"],
                            data_source: "mentions",
                          },
                        },
                  [`y_axis_settings`]: [
                    ...axisPanelAtt[`y_axis_settings`],
                    {
                      show_as:
                        axisPanelAtt?.y_axis_settings?.length === 0
                          ? "bar"
                          : "line",
                      y_axis_map_at:
                        axisPanelAtt?.y_axis_settings?.length === 0 ? 0 : 1,
                      y_axis_scale: "linear",
                      color_pattern_code: 1,
                      key: uuid(),
                    },
                    {
                      show_as: "line",
                      y_axis_map_at: 1,
                      y_axis_scale: "linear",
                      color_pattern_code: 1,
                      key: uuid(),
                    },
                  ],
                  [`dragDataType`]: {
                    ...axisPanelAtt[`dragDataType`],
                    varchar: false,
                    int: false,
                    datetime: false,
                    json: false,
                  },
                })
              );
        } else if (widgetGraphConfig?.chart_type === "scatter") {
          let defaultAttribute = getDefaultAttributeValue(
            "y_axis",
            widgetGraphConfig?.chart_type
          );
          let primaryDraggedAttributeObj = findAttributeObject(
            defaultAttribute?.primaryAttribute,
            WM_attributes
          );
          let secondaryDraggedAttributeObj = findAttributeObject(
            defaultAttribute?.secondaryAttribute,
            WM_attributes
          );
          axisPanelAtt["y_axis"]["y_series_1"].attribute
            ? dispatch(
                setX_attribute({
                  ...axisPanelAtt,
                  data_source: newDataSource,
                  [result.destination.droppableId]: {
                    attribute: result.draggableId.split("#")[0],
                    deep_dive_info: draggedAttributeObj?.deep_dive_info
                      ? draggedAttributeObj?.deep_dive_info
                      : null,
                    data_source: newDataSource,
                    trace_name:
                      All_WM_attributes[result.draggableId.split("#")[0]],
                    date_part: null,
                    sort_order:
                      result.draggableId.split("#")[1] === "datetime"
                        ? "asc"
                        : "desc",
                    x_limit: 30,
                  },
                  [`dragDataType`]: {
                    ...axisPanelAtt[`dragDataType`],
                    varchar: false,
                    int: false,
                    datetime: false,
                    json: false,
                  },
                })
              )
            : dispatch(
                setX_attribute({
                  ...axisPanelAtt,
                  data_source: newDataSource,
                  [result.destination.droppableId]: {
                    attribute: result.draggableId.split("#")[0],
                    deep_dive_info: draggedAttributeObj?.deep_dive_info
                      ? draggedAttributeObj?.deep_dive_info
                      : null,
                    data_source: newDataSource,
                    trace_name:
                      All_WM_attributes[result.draggableId.split("#")[0]],
                    date_part: null,
                    sort_order:
                      result.draggableId.split("#")[1] === "datetime"
                        ? "asc"
                        : "desc",
                    x_limit: 30,
                  },
                  [`y_axis`]:
                    newDataSource === "tickets"
                      ? {
                          [`y_series_1`]: {
                            attribute: "FirstlevelTAT_Seconds",
                            aggregation: "avg",
                            trace_name:
                              All_WM_attributes["FirstlevelTAT_Seconds"],
                            data_source: newDataSource,
                          },
                          [`y_series_2`]: {
                            attribute: "caseid",
                            aggregation: "COUNT",
                            trace_name: All_WM_attributes["caseid"],
                            data_source: newDataSource,
                          },
                        }
                      : newDataSource === "page"
                      ? {
                          [`y_series_1`]: {
                            attribute: "page_followers_count",
                            aggregation: "SUM",
                            trace_name:
                              All_WM_attributes["page_followers_count"],
                            data_source: newDataSource,
                          },

                          [`y_series_2`]: {
                            attribute: "page_reactions_like",
                            aggregation: "SUM",
                            trace_name:
                              All_WM_attributes["page_reactions_like"],
                            data_source: newDataSource,
                          },
                        }
                      : {
                          [`y_series_1`]: {
                            attribute: defaultAttribute?.primaryAttribute,
                            deep_dive_info:
                              primaryDraggedAttributeObj?.deep_dive_info
                                ? primaryDraggedAttributeObj?.deep_dive_info
                                : null,
                            data_source: checkAttributeSource(
                              attributes,
                              defaultAttribute?.primaryAttribute
                            ),
                            aggregation:
                              graphConditionAggregation?.avg?.includes(
                                defaultAttribute?.primaryAttribute
                              )
                                ? "avg"
                                : graphConditionAggregation?.average_attribute?.includes(
                                    // For mentions attribute
                                    defaultAttribute?.primaryAttribute
                                  )
                                ? "avg"
                                : graphConditionAggregation?.count_distinct?.includes(
                                    defaultAttribute?.primaryAttribute
                                  )
                                ? "COUNT"
                                : graphConditionAggregation?.count?.includes(
                                    defaultAttribute?.primaryAttribute
                                  )
                                ? "COUNT"
                                : graphConditionAggregation?.max?.includes(
                                    defaultAttribute?.primaryAttribute
                                  )
                                ? "max"
                                : defaultAttribute?.primaryAttribute === "nss"
                                ? "COUNT"
                                : defaultAttribute?.primaryAttribute === "srs"
                                ? "COUNT"
                                : "SUM",
                            trace_name:
                              All_WM_attributes[
                                defaultAttribute?.primaryAttribute
                              ],
                          },
                          [`y_series_2`]: {
                            attribute: defaultAttribute?.secondaryAttribute,
                            deep_dive_info:
                              secondaryDraggedAttributeObj?.deep_dive_info
                                ? secondaryDraggedAttributeObj?.deep_dive_info
                                : null,
                            data_source: checkAttributeSource(
                              attributes,
                              defaultAttribute?.secondaryAttribute
                            ),
                            aggregation:
                              graphConditionAggregation?.avg?.includes(
                                defaultAttribute?.secondaryAttribute
                              )
                                ? "avg"
                                : graphConditionAggregation?.average_attribute?.includes(
                                    // For mentions attribute
                                    defaultAttribute?.secondaryAttribute
                                  )
                                ? "avg"
                                : graphConditionAggregation?.count_distinct?.includes(
                                    defaultAttribute?.secondaryAttribute
                                  )
                                ? "COUNT"
                                : graphConditionAggregation?.count?.includes(
                                    defaultAttribute?.secondaryAttribute
                                  )
                                ? "COUNT"
                                : graphConditionAggregation?.max?.includes(
                                    defaultAttribute?.secondaryAttribute
                                  )
                                ? "max"
                                : defaultAttribute?.secondaryAttribute === "nss"
                                ? "COUNT"
                                : defaultAttribute?.secondaryAttribute === "srs"
                                ? "COUNT"
                                : "SUM",
                            trace_name:
                              All_WM_attributes[
                                defaultAttribute?.secondaryAttribute
                              ],
                          },
                        },
                  [`y_axis_settings`]: [
                    {
                      show_as: "line",
                      y_axis_map_at:
                        axisPanelAtt?.y_axis_settings?.length === 0 ? 0 : 1,
                      y_axis_scale: "linear",
                      color_pattern_code: 1,
                      key: uuid(),
                    },
                    {
                      show_as: "line",
                      y_axis_map_at: 1,
                      y_axis_scale: "linear",
                      color_pattern_code: 1,
                      key: uuid(),
                    },
                  ],
                  [`dragDataType`]: {
                    ...axisPanelAtt[`dragDataType`],
                    varchar: false,
                    int: false,
                    datetime: false,
                    json: false,
                  },
                })
              );
        } else if (
          ["multilayer-map"]?.includes(widgetGraphConfig?.chart_type)
        ) {
          let defaultAttribute = getDefaultAttributeValue(
            "y_axis",
            widgetGraphConfig?.chart_type
          );
          let primaryDraggedAttributeObj = findAttributeObject(
            defaultAttribute?.primaryAttribute,
            WM_attributes
          );
          let secondaryDraggedAttributeObj = findAttributeObject(
            defaultAttribute?.secondaryAttribute,
            WM_attributes
          );
          let multilayerMapColorSetting =
            ["multilayer-map"]?.includes(widgetGraphConfig?.chart_type) &&
            !axisPanelAtt["y_axis"]["y_series_1"].attribute
              ? graphConditions?.["multilayer_map_color_setting"]
                ? graphConditions?.["multilayer_map_color_setting"]?.[
                    result.draggableId.split("#")[0]
                  ]
                : null
              : null;
          axisPanelAtt["y_axis"]["y_series_1"].attribute
            ? dispatch(
                setX_attribute({
                  ...axisPanelAtt,
                  data_source: newDataSource,
                  [result.destination.droppableId]: {
                    attribute: result.draggableId.split("#")[0],
                    deep_dive_info: draggedAttributeObj?.deep_dive_info
                      ? draggedAttributeObj?.deep_dive_info
                      : null,
                    data_source: newDataSource,
                    trace_name:
                      All_WM_attributes[result.draggableId.split("#")[0]],
                    date_part: null,
                    sort_order:
                      result.draggableId.split("#")[1] === "datetime"
                        ? "asc"
                        : "desc",
                    x_limit: 30,
                  },
                  [`dragDataType`]: {
                    ...axisPanelAtt[`dragDataType`],
                    varchar: false,
                    int: false,
                    datetime: false,
                    json: false,
                  },
                })
              )
            : dispatch(
                setX_attribute({
                  ...axisPanelAtt,
                  data_source: newDataSource,
                  [result.destination.droppableId]: {
                    attribute: result.draggableId.split("#")[0],
                    deep_dive_info: draggedAttributeObj?.deep_dive_info
                      ? draggedAttributeObj?.deep_dive_info
                      : null,
                    data_source: newDataSource,
                    trace_name:
                      All_WM_attributes[result.draggableId.split("#")[0]],
                    date_part: null,
                    sort_order:
                      result.draggableId.split("#")[1] === "datetime"
                        ? "asc"
                        : "desc",
                    x_limit: 30,
                  },
                  [`y_axis`]:
                    newDataSource === "tickets"
                      ? {
                          [`y_series_1`]: {
                            attribute: "FirstlevelTAT_Seconds",
                            aggregation: "avg",
                            trace_name:
                              All_WM_attributes["FirstlevelTAT_Seconds"],
                            data_source: newDataSource,
                          },
                        }
                      : newDataSource === "page"
                      ? {
                          [`y_series_1`]: {
                            attribute: "page_followers_count",
                            aggregation: "SUM",
                            trace_name:
                              All_WM_attributes["page_followers_count"],
                            data_source: newDataSource,
                          },
                        }
                      : {
                          [`y_series_1`]: {
                            attribute: defaultAttribute?.primaryAttribute,
                            deep_dive_info:
                              primaryDraggedAttributeObj?.deep_dive_info
                                ? primaryDraggedAttributeObj?.deep_dive_info
                                : null,
                            data_source: checkAttributeSource(
                              attributes,
                              defaultAttribute?.primaryAttribute
                            ),
                            aggregation:
                              graphConditionAggregation?.avg?.includes(
                                defaultAttribute?.primaryAttribute
                              )
                                ? "avg"
                                : graphConditionAggregation?.average_attribute?.includes(
                                    // For mentions attribute
                                    defaultAttribute?.primaryAttribute
                                  )
                                ? "avg"
                                : graphConditionAggregation?.count_distinct?.includes(
                                    defaultAttribute?.primaryAttribute
                                  )
                                ? "COUNT"
                                : graphConditionAggregation?.count?.includes(
                                    defaultAttribute?.primaryAttribute
                                  )
                                ? "COUNT"
                                : graphConditionAggregation?.max?.includes(
                                    defaultAttribute?.primaryAttribute
                                  )
                                ? "max"
                                : defaultAttribute?.primaryAttribute === "nss"
                                ? "COUNT"
                                : defaultAttribute?.primaryAttribute === "srs"
                                ? "COUNT"
                                : "SUM",
                            trace_name:
                              All_WM_attributes[
                                defaultAttribute?.primaryAttribute
                              ],
                          },
                        },
                  [`y_axis_settings`]: [
                    {
                      show_as: "line",
                      y_axis_map_at:
                        axisPanelAtt?.y_axis_settings?.length === 0 ? 0 : 1,
                      y_axis_scale: "linear",
                      color_pattern_code: 1,
                      key: uuid(),
                      multilayer_thresholds: multilayerMapColorSetting,
                    },
                  ],
                  [`dragDataType`]: {
                    ...axisPanelAtt[`dragDataType`],
                    varchar: false,
                    int: false,
                    datetime: false,
                    json: false,
                  },
                })
              );
        }
      } else if (
        result.destination.droppableId.split("#")[0] === "breakdown_by" &&
        (widgetGraphConfig?.chart_type === "network-graph" ||
          widgetGraphConfig?.chart_type === "network-graph-v2")
      ) {
        if (isAllowedToDrag) {
          if (result.destination.droppableId.split("#")[1] === "nodes") {
            if (result.destination.droppableId.split("#")[3] === "update") {
              dispatch(
                setY_attribute({
                  ...axisPanelAtt,
                  [`breakdown_by`]: axisPanelAtt?.breakdown_by?.map(
                    (e, index) => {
                      if (
                        index == result.destination.droppableId.split("#")[4]
                      ) {
                        let radiusAttributeValue = getRadiusAttributeValue(
                          graphConditions,
                          widgetGraphConfig?.chart_type,
                          result.draggableId.split("#")[0]?.toLowerCase()
                        );
                        return {
                          ...e,
                          attribute: result.draggableId.split("#")[0],
                          deep_dive_info: draggedAttributeObj?.deep_dive_info
                            ? draggedAttributeObj?.deep_dive_info
                            : null,
                          data_source: newDataSource,
                          trace_name:
                            All_WM_attributes[result.draggableId.split("#")[0]],
                          radius_attribute: radiusAttributeValue,
                          color: globalChartColor?.[index + 1],
                        };
                      } else {
                        return e;
                      }
                    }
                  ),
                  [`chart_settings`]: {
                    ...axisPanelAtt?.chart_settings,
                    total_row: false,
                  },
                })
              );
            } else {
              let radiusAttributeValue = getRadiusAttributeValue(
                graphConditions,
                widgetGraphConfig?.chart_type,
                result.draggableId.split("#")[0]?.toLowerCase()
              );
              if (
                axisPanelAtt?.y_axis?.[
                  `y_series_${parseInt(
                    result.destination.droppableId.split("#")[3] + 2
                  )}`
                ]?.attribute
              ) {
                dispatch(
                  setY_attribute({
                    ...axisPanelAtt,
                    breakdown_by: [
                      ...axisPanelAtt?.breakdown_by,
                      {
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                        attribute: result.draggableId.split("#")[0],
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        data_source: newDataSource,
                        date_part: null,
                        sort_order: "desc",
                        y_limit: 5,
                        radius_attribute: radiusAttributeValue,
                        color:
                          globalChartColor?.[
                            axisPanelAtt?.breakdown_by?.length + 1
                          ],
                      },
                    ],
                    [`chart_settings`]: {
                      ...axisPanelAtt?.chart_settings,
                      total_row: false,
                    },
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                  })
                );
              } else {
                dispatch(
                  setY_attribute({
                    ...axisPanelAtt,
                    breakdown_by: [
                      ...axisPanelAtt?.breakdown_by,
                      {
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                        attribute: result.draggableId.split("#")[0],
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        data_source: newDataSource,
                        date_part: null,
                        sort_order: "desc",
                        y_limit: 5,
                        radius_attribute: radiusAttributeValue,
                        color:
                          globalChartColor?.[
                            axisPanelAtt?.breakdown_by?.length + 1
                          ],
                      },
                    ],
                    [`y_axis`]: {
                      ...axisPanelAtt?.["y_axis"],
                      [`y_series_${parseInt(
                        result.destination.droppableId.split("#")[3] + 2
                      )}`]: defaultYSeriesAttrForNetwork
                        ? defaultYSeriesAttrForNetwork
                        : {
                            ...graphConditions?.default_attrs?.[
                              data_source
                            ]?.[0],
                            data_source:
                              graphConditions?.default_attrs?.[data_source]?.[0]
                                ?.type,
                            aggregation: "COUNT",

                            trace_name:
                              graphConditions?.default_attrs?.[data_source]?.[0]
                                ?.title,
                            // attribute: "tagid",
                            // data_source: newDataSource,
                          },
                    },
                    [`y_axis_settings`]: [
                      ...axisPanelAtt[`y_axis_settings`],
                      {
                        show_as:
                          axisPanelAtt?.y_axis_settings?.length === 0
                            ? "bar"
                            : "line",
                        y_axis_map_at:
                          axisPanelAtt?.y_axis_settings?.length === 0 ? 0 : 1,
                        y_axis_scale: "linear",
                        color_pattern_code: 1,
                        key: uuid(),
                      },
                    ],
                    [`chart_settings`]: {
                      ...axisPanelAtt?.chart_settings,
                      total_row: false,
                    },
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                  })
                );
              }
            }
          }
        }
      } else if (
        result.destination.droppableId.split("#")[0] === "y_axis" &&
        ([
          "scatter",
          "quadrant",
          "multilayer-map",
          // "treemap"
        ]?.includes(widgetGraphConfig?.chart_type) &&
        result.destination.droppableId.split("#")[2] === "attribute"
          ? isAllowedToDrag
          : true)
      ) {
        // to stop kformatting and enable secondsToHumanReadable for ticket attr
        if (
          graphConditions?.["time-label-attrs"]?.includes(
            widgetGraphConfig?.y_axis?.y_series_1?.attribute
          ) ||
          graphConditions?.["ticket-time-label-attrs"]?.includes(
            widgetGraphConfig?.y_axis?.y_series_1?.attribute
          )
        ) {
          let flrIsNotExistAfterThisSeries = true;
          let y_series_array = [];
          y_series_array = Object.keys(widgetGraphConfig?.y_axis).map(
            (key) => widgetGraphConfig?.y_axis[key]
          );
          y_series_array = y_series_array?.filter((el) => el?.attribute);

          let st_inx = result?.destination?.droppableId
            ?.split("#")[1]
            ?.split("_")?.[2];
          if (
            !graphConditions?.["time-label-attrs"]?.includes(
              result?.draggableId?.split("#")?.[0]
            )
          )
            for (; st_inx < y_series_array?.length; st_inx++) {
              if (
                graphConditions?.["time-label-attrs"]?.includes(
                  y_series_array?.[st_inx]?.attribute
                )
              ) {
                flrIsNotExistAfterThisSeries = false;
                break;
              }
            }
          if (
            [
              "bar",
              "lollipop",
              "horizontal-bar",
              "area",
              "line",
              "scatter",
              "quadrant",
              "multilayer-map",
              "treemap",
            ]?.includes(widgetGraphConfig?.chart_type)
          ) {
            // allow multiple y-series time based attributes for these charts
            (graphConditions?.["time-label-attrs"]?.includes(
              result.draggableId.split("#")[0]
            ) ||
              graphConditions?.["ticket-time-label-attrs"]?.includes(
                result.draggableId.split("#")[0]
              )) &&
              dispatch(
                setY_attribute({
                  ...axisPanelAtt,
                  [result.destination.droppableId.split("#")[0]]: {
                    ...axisPanelAtt[
                      result.destination.droppableId.split("#")[0]
                    ],
                    [result.destination.droppableId.split("#")[1]]: {
                      ...axisPanelAtt[
                        result.destination.droppableId.split("#")[0]
                      ][result.destination.droppableId.split("#")[1]],
                      [result.destination.droppableId.split("#")[2]]:
                        result.draggableId.split("#")[0],
                      aggregation: graphConditionAggregation?.avg?.includes(
                        result.draggableId.split("#")[0]
                      )
                        ? "avg"
                        : graphConditionAggregation?.average_attribute?.includes(
                            // For mentions attribute
                            result.draggableId.split("#")[0]
                          )
                        ? "avg"
                        : graphConditionAggregation?.count_distinct?.includes(
                            result.draggableId.split("#")[0]
                          )
                        ? "COUNT"
                        : graphConditionAggregation?.count?.includes(
                            result.draggableId.split("#")[0]
                          )
                        ? "COUNT"
                        : graphConditionAggregation?.max?.includes(
                            result.draggableId.split("#")[0]
                          )
                        ? "max"
                        : result.draggableId.split("#")[0] === "nss"
                        ? "COUNT"
                        : result.draggableId.split("#")[0] === "srs"
                        ? "COUNT"
                        : "SUM",
                      deep_dive_info: draggedAttributeObj?.deep_dive_info
                        ? draggedAttributeObj?.deep_dive_info
                        : null,
                      trace_name:
                        All_WM_attributes[result.draggableId.split("#")[0]],
                      data_source: newDataSource,
                    },
                  },
                  [`dragDataType`]: {
                    ...axisPanelAtt[`dragDataType`],
                    varchar: false,
                    int: false,
                    datetime: false,
                    json: false,
                  },
                  [`y_axis_settings`]: axisPanelAtt.y_axis[
                    result.destination.droppableId.split("#")[1]
                  ]?.attribute
                    ? [...axisPanelAtt[`y_axis_settings`]]
                    : result.destination.droppableId.split("#")[1] ===
                        "y_series_1" &&
                      axisPanelAtt?.y_axis_settings?.length > 0
                    ? [...axisPanelAtt[`y_axis_settings`]]
                    : [
                        ...axisPanelAtt[`y_axis_settings`],
                        {
                          show_as:
                            axisPanelAtt?.y_axis_settings?.length === 0
                              ? "bar"
                              : "line",
                          y_axis_map_at:
                            axisPanelAtt?.y_axis_settings?.length === 0 ? 0 : 1,
                          show_markers: true,
                          show_data_label: true,
                          y_axis_scale: "linear",
                          color_pattern_code: 1,
                          key: uuid(),
                        },
                      ],
                })
              );
          } else if (
            widgetGraphConfig?.chart_type === "combination" &&
            flrIsNotExistAfterThisSeries
          ) {
            widgetGraphConfig?.y_axis?.y_series_1?.attribute !==
              result.draggableId.split("#")[0] &&
              dispatch(
                setY_attribute({
                  ...axisPanelAtt,
                  [result.destination.droppableId.split("#")[0]]: {
                    ...axisPanelAtt[
                      result.destination.droppableId.split("#")[0]
                    ],
                    [result.destination.droppableId.split("#")[1]]: {
                      ...axisPanelAtt[
                        result.destination.droppableId.split("#")[0]
                      ][result.destination.droppableId.split("#")[1]],
                      [result.destination.droppableId.split("#")[2]]:
                        result.draggableId.split("#")[0],
                      aggregation: graphConditionAggregation?.avg?.includes(
                        result.draggableId.split("#")[0]
                      )
                        ? "avg"
                        : graphConditionAggregation?.average_attribute?.includes(
                            // For mentions attribute
                            result.draggableId.split("#")[0]
                          )
                        ? "avg"
                        : graphConditionAggregation?.count_distinct?.includes(
                            result.draggableId.split("#")[0]
                          )
                        ? "COUNT"
                        : graphConditionAggregation?.count?.includes(
                            result.draggableId.split("#")[0]
                          )
                        ? "COUNT"
                        : graphConditionAggregation?.max?.includes(
                            result.draggableId.split("#")[0]
                          )
                        ? "max"
                        : result.draggableId.split("#")[0] === "nss"
                        ? "COUNT"
                        : result.draggableId.split("#")[0] === "srs"
                        ? "COUNT"
                        : "SUM",
                      deep_dive_info: draggedAttributeObj?.deep_dive_info
                        ? draggedAttributeObj?.deep_dive_info
                        : null,
                      trace_name:
                        All_WM_attributes[result.draggableId.split("#")[0]],
                      data_source: newDataSource,
                    },
                  },
                  [`dragDataType`]: {
                    ...axisPanelAtt[`dragDataType`],
                    varchar: false,
                    int: false,
                    datetime: false,
                    json: false,
                  },
                  [`y_axis_settings`]: axisPanelAtt.y_axis[
                    result.destination.droppableId.split("#")[1]
                  ]?.attribute
                    ? [...axisPanelAtt[`y_axis_settings`]]
                    : result.destination.droppableId.split("#")[1] ===
                        "y_series_1" &&
                      axisPanelAtt?.y_axis_settings?.length > 0
                    ? [...axisPanelAtt[`y_axis_settings`]]
                    : [
                        ...axisPanelAtt[`y_axis_settings`],
                        {
                          show_as:
                            axisPanelAtt?.y_axis_settings?.length === 0
                              ? "bar"
                              : "line",
                          y_axis_map_at:
                            axisPanelAtt?.y_axis_settings?.length === 0 ? 0 : 1,
                          show_markers: true,
                          show_data_label: true,
                          y_axis_scale: "linear",
                          color_pattern_code: 1,
                          key: uuid(),
                        },
                      ],
                })
              );
          }
        } else if (
          !graphConditions?.["time-label-attrs"]?.includes(
            widgetGraphConfig?.y_axis?.y_series_1?.attribute
          )
        ) {
          //to clear y_axis_map_at in case of flr
          let update_y_axis_settings = axisPanelAtt?.y_axis_settings?.length
            ? [...axisPanelAtt?.y_axis_settings]
            : [];
          if (
            graphConditions?.["time-label-attrs"]?.includes(
              result.draggableId.split("#")?.[0]
            ) ||
            graphConditions?.["ticket-time-label-attrs"]?.includes(
              result.draggableId.split("#")?.[0]
            )
          ) {
            update_y_axis_settings = update_y_axis_settings?.map((el, i) => {
              el.y_axis_map_at = i === 0 ? 0 : 1;
              el.y_axis_scale = "linear";
              return el;
            });
          }

          let filterVal = {};
          Object.entries(axisPanelAtt.y_axis).forEach((e) => {
            if (e[1].attribute !== null) {
              filterVal = { ...filterVal, [e[0]]: e[1] };
            }
          });

          if (result.destination.droppableId.split("#")[1] === "columns") {
            if (widgetGraphConfig?.x_axis?.attribute === "Hashtags") {
              if (result.destination.droppableId.split("#")[3] === "update") {
                if (
                  result.destination.droppableId.split("#")[4] === "x_axis" &&
                  (result.draggableId.split("#")[1] === "varchar" ||
                    result.draggableId.split("#")[1] === "datetime") &&
                  !axisPanelAtt?.breakdown_by
                    ?.map((d) => d.attribute)
                    ?.includes(result.draggableId.split("#")[0])
                ) {
                  dispatch(
                    setY_attribute({
                      ...axisPanelAtt,
                      [`x_axis`]: {
                        ...axisPanelAtt[`x_axis`],
                        attribute: result.draggableId.split("#")[0],
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        data_source: newDataSource,
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                      },
                    })
                  );
                } else if (
                  result.destination.droppableId.split("#")[4] ===
                    "breakdown_by" &&
                  result.draggableId.split("#")[1] === "varchar" &&
                  result.draggableId.split("#")[0] !==
                    axisPanelAtt?.x_axis?.attribute &&
                  !axisPanelAtt?.breakdown_by
                    ?.map((d) => d.attribute)
                    ?.includes(result.draggableId.split("#")[0])
                ) {
                  dispatch(
                    setY_attribute({
                      ...axisPanelAtt,
                      [`breakdown_by`]: axisPanelAtt?.breakdown_by?.map(
                        (e, index) => {
                          if (
                            index ==
                            result.destination.droppableId.split("#")[5]
                          ) {
                            return {
                              ...e,
                              attribute: result.draggableId.split("#")[0],
                              deep_dive_info:
                                draggedAttributeObj?.deep_dive_info
                                  ? draggedAttributeObj?.deep_dive_info
                                  : null,
                              data_source: newDataSource,
                              trace_name:
                                All_WM_attributes[
                                  result.draggableId.split("#")[0]
                                ],
                            };
                          } else {
                            return e;
                          }
                        }
                      ),
                      [`chart_settings`]: {
                        ...axisPanelAtt?.chart_settings,
                        total_row: false,
                      },
                    })
                  );
                } else if (
                  result.destination.droppableId.split("#")[4] === "y_series" &&
                  result.draggableId.split("#")[1] === "int" &&
                  result.draggableId.split("#")[0] !== "nss" &&
                  result.draggableId.split("#")[0] !== "srs" &&
                  !graphConditions?.["time-label-attrs"]?.includes(
                    result.draggableId.split("#")[0]
                  ) &&
                  !y_series_array_drag?.includes(
                    result.draggableId.split("#")[0]
                  )
                ) {
                  dispatch(
                    setY_attribute({
                      ...axisPanelAtt,
                      [`y_axis`]: {
                        ...axisPanelAtt[`y_axis`],
                        [result.destination.droppableId.split("#")[5]]: {
                          ...axisPanelAtt[`y_axis`][
                            result.destination.droppableId.split("#")[5]
                          ],
                          // average
                          aggregation: graphConditionAggregation?.avg?.includes(
                            result.draggableId.split("#")[0]
                          )
                            ? "avg"
                            : graphConditionAggregation?.average_attribute?.includes(
                                // For mentions attribute
                                result.draggableId.split("#")[0]
                              )
                            ? "avg"
                            : graphConditionAggregation?.count_distinct?.includes(
                                result.draggableId.split("#")[0]
                              )
                            ? "COUNT"
                            : graphConditionAggregation?.count?.includes(
                                result.draggableId.split("#")[0]
                              )
                            ? "COUNT"
                            : graphConditionAggregation?.max?.includes(
                                result.draggableId.split("#")[0]
                              )
                            ? "max"
                            : result.draggableId.split("#")[0] === "nss"
                            ? "COUNT"
                            : result.draggableId.split("#")[0] === "srs"
                            ? "COUNT"
                            : "SUM",
                          attribute: result.draggableId.split("#")[0],
                          deep_dive_info: draggedAttributeObj?.deep_dive_info
                            ? draggedAttributeObj?.deep_dive_info
                            : null,
                          data_source: newDataSource,
                          trace_name:
                            All_WM_attributes[result.draggableId.split("#")[0]],
                        },
                      },
                    })
                  );
                }
              } else if (
                result.draggableId.split("#")[1] === "int" &&
                result.draggableId.split("#")[0] !== "nss" &&
                result.draggableId.split("#")[0] !== "srs" &&
                !graphConditions?.["time-label-attrs"]?.includes(
                  result.draggableId.split("#")[0]
                ) &&
                !y_series_array_drag?.includes(result.draggableId.split("#")[0])
              ) {
                dispatch(
                  setY_attribute({
                    ...axisPanelAtt,
                    y_axis: {
                      ...filterVal,
                      [`y_series_${Object.keys(filterVal)?.length + 1}`]: {
                        attribute: result.draggableId.split("#")[0],
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        data_source: newDataSource,
                        aggregation: graphConditionAggregation?.avg?.includes(
                          result.draggableId.split("#")[0]
                        )
                          ? "avg"
                          : graphConditionAggregation?.average_attribute?.includes(
                              // For mentions attribute
                              result.draggableId.split("#")[0]
                            )
                          ? "avg"
                          : graphConditionAggregation?.count_distinct?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.count?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.max?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "max"
                          : result.draggableId.split("#")[0] === "nss"
                          ? "COUNT"
                          : result.draggableId.split("#")[0] === "srs"
                          ? "COUNT"
                          : "SUM",
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                      },
                    },
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                  })
                );
              }
            } else {
              if (
                result.destination.droppableId.split("#")[3] === "update" &&
                result.draggableId.split("#")[0] !== "Hashtags"
              ) {
                if (
                  result.destination.droppableId.split("#")[4] === "x_axis" &&
                  (result.draggableId.split("#")[1] === "varchar" ||
                    result.draggableId.split("#")[1] === "datetime") &&
                  !axisPanelAtt?.breakdown_by
                    ?.map((d) => d.attribute)
                    ?.includes(result.draggableId.split("#")[0])
                ) {
                  dispatch(
                    setY_attribute({
                      ...axisPanelAtt,
                      [`x_axis`]: {
                        ...axisPanelAtt[`x_axis`],
                        attribute: result.draggableId.split("#")[0],
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        data_source: newDataSource,
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                      },
                    })
                  );
                } else if (
                  result.destination.droppableId.split("#")[4] ===
                    "breakdown_by" &&
                  result.draggableId.split("#")[1] === "varchar" &&
                  result.draggableId.split("#")[0] !==
                    axisPanelAtt?.x_axis?.attribute &&
                  !axisPanelAtt?.breakdown_by
                    ?.map((d) => d.attribute)
                    ?.includes(result.draggableId.split("#")[0])
                ) {
                  dispatch(
                    setY_attribute({
                      ...axisPanelAtt,
                      [`breakdown_by`]: axisPanelAtt?.breakdown_by?.map(
                        (e, index) => {
                          if (
                            index ==
                            result.destination.droppableId.split("#")[5]
                          ) {
                            return {
                              ...e,
                              attribute: result.draggableId.split("#")[0],
                              deep_dive_info:
                                draggedAttributeObj?.deep_dive_info
                                  ? draggedAttributeObj?.deep_dive_info
                                  : null,
                              data_source: newDataSource,
                              trace_name:
                                All_WM_attributes[
                                  result.draggableId.split("#")[0]
                                ],
                            };
                          } else {
                            return e;
                          }
                        }
                      ),
                      [`chart_settings`]: {
                        ...axisPanelAtt?.chart_settings,
                        total_row: false,
                      },
                    })
                  );
                } else if (
                  result.destination.droppableId.split("#")[4] === "y_series" &&
                  result.draggableId.split("#")[1] === "int" &&
                  result.draggableId.split("#")[0] !== "nss" &&
                  result.draggableId.split("#")[0] !== "srs" &&
                  !graphConditions?.["time-label-attrs"]?.includes(
                    result.draggableId.split("#")[0]
                  ) &&
                  !y_series_array_drag?.includes(
                    result.draggableId.split("#")[0]
                  )
                  // &&
                  // !y_series_array_drag?.includes(
                  //   result.draggableId.split("#")[0]
                  // )
                ) {
                  dispatch(
                    setY_attribute({
                      ...axisPanelAtt,
                      [`y_axis`]: {
                        ...axisPanelAtt[`y_axis`],
                        [result.destination.droppableId.split("#")[5]]: {
                          ...axisPanelAtt[`y_axis`][
                            result.destination.droppableId.split("#")[5]
                          ],
                          aggregation: graphConditionAggregation?.avg?.includes(
                            result.draggableId.split("#")[0]
                          )
                            ? "avg"
                            : graphConditionAggregation?.average_attribute?.includes(
                                // For mentions attribute
                                result.draggableId.split("#")[0]
                              )
                            ? "avg"
                            : graphConditionAggregation?.count_distinct?.includes(
                                result.draggableId.split("#")[0]
                              )
                            ? "COUNT"
                            : graphConditionAggregation?.count?.includes(
                                result.draggableId.split("#")[0]
                              )
                            ? "COUNT"
                            : graphConditionAggregation?.max?.includes(
                                result.draggableId.split("#")[0]
                              )
                            ? "max"
                            : result.draggableId.split("#")[0] === "nss"
                            ? "COUNT"
                            : result.draggableId.split("#")[0] === "srs"
                            ? "COUNT"
                            : "SUM",
                          attribute: result.draggableId.split("#")[0],
                          deep_dive_info: draggedAttributeObj?.deep_dive_info
                            ? draggedAttributeObj?.deep_dive_info
                            : null,
                          data_source: newDataSource,
                          trace_name:
                            All_WM_attributes[result.draggableId.split("#")[0]],
                        },
                      },
                    })
                  );
                }
              } else if (
                result.draggableId.split("#")[1] === "int" &&
                result.draggableId.split("#")[0] !== "nss" &&
                result.draggableId.split("#")[0] !== "srs" &&
                !graphConditions?.["time-label-attrs"]?.includes(
                  result.draggableId.split("#")[0]
                )
                // &&
                // commented check to allow y-axis attribute to be dragged more than once in grid
                // !y_series_array_drag?.includes(result.draggableId.split("#")[0])
              ) {
                dispatch(
                  setY_attribute({
                    ...axisPanelAtt,
                    y_axis: {
                      ...filterVal,
                      [`y_series_${Object.keys(filterVal)?.length + 1}`]: {
                        attribute: result.draggableId.split("#")[0],
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        data_source: newDataSource,
                        aggregation: graphConditionAggregation?.avg?.includes(
                          result.draggableId.split("#")[0]
                        )
                          ? "avg"
                          : graphConditionAggregation?.average_attribute?.includes(
                              // For mentions attribute
                              result.draggableId.split("#")[0]
                            )
                          ? "avg"
                          : graphConditionAggregation?.count_distinct?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.count?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.max?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "max"
                          : result.draggableId.split("#")[0] === "nss"
                          ? "COUNT"
                          : result.draggableId.split("#")[0] === "srs"
                          ? "COUNT"
                          : "SUM",
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                      },
                    },
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                  })
                );
              } else if (
                !axisPanelAtt?.x_axis?.attribute &&
                (result.draggableId.split("#")[1] === "varchar" ||
                  result.draggableId.split("#")[1] === "datetime")
              ) {
                dispatch(
                  setX_attribute({
                    ...axisPanelAtt,
                    x_axis: {
                      attribute: result.draggableId.split("#")[0],
                      deep_dive_info: draggedAttributeObj?.deep_dive_info
                        ? draggedAttributeObj?.deep_dive_info
                        : null,
                      data_source: newDataSource,
                      trace_name:
                        All_WM_attributes[result.draggableId.split("#")[0]],
                      date_part: null,
                      sort_order: "desc",
                      x_limit:
                        widgetGraphConfig?.chart_type === "cluster-chart"
                          ? 5
                          : 50,
                    },
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                    [`y_axis`]:
                      axisPanelAtt?.y_axis?.y_series_1?.attribute &&
                      axisPanelAtt?.y_axis?.y_series_1?.attribute !== "caseid"
                        ? axisPanelAtt?.y_axis
                        : newDataSource === "tickets"
                        ? {
                            [`y_series_1`]: {
                              attribute: "caseid",
                              aggregation: "COUNT",
                              trace_name: All_WM_attributes["caseid"],
                              data_source: newDataSource,
                            },
                          }
                        : newDataSource === "page"
                        ? {
                            [`y_series_1`]: {
                              attribute: "page_followers_count",
                              aggregation: "SUM",
                              trace_name:
                                All_WM_attributes["page_followers_count"],
                              data_source: newDataSource,
                            },
                          }
                        : {
                            [`y_series_1`]: {
                              attribute: "tagid",
                              aggregation: "COUNT",
                              trace_name: All_WM_attributes["tagid"],
                              data_source: "mentions",
                            },
                          },
                  })
                );
              } else if (
                axisPanelAtt?.breakdown_by?.length < 2 &&
                axisPanelAtt?.x_axis?.attribute &&
                result.draggableId.split("#")[1] === "varchar" &&
                result.draggableId.split("#")[0] !==
                  axisPanelAtt?.x_axis?.attribute &&
                !axisPanelAtt?.breakdown_by
                  ?.map((d) => d.attribute)
                  ?.includes(result.draggableId.split("#")[0]) &&
                widgetGraphConfig?.x_axis?.attribute &&
                result.draggableId.split("#")[0] !== "Hashtags"
              ) {
                dispatch(
                  setY_attribute({
                    ...axisPanelAtt,
                    breakdown_by: [
                      ...axisPanelAtt?.breakdown_by,
                      {
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                        attribute: result.draggableId.split("#")[0],
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        data_source: newDataSource,
                        date_part: null,
                        sort_order: "desc",
                        y_limit: 5,
                      },
                    ],
                    [`chart_settings`]: {
                      ...axisPanelAtt?.chart_settings,
                      total_row: false,
                    },
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                  })
                );
              }
            }
          } else if (
            result.destination.droppableId.split("#")[1] === "columns_pivot" &&
            result.draggableId.split("#")[0] !== "nss" &&
            result.draggableId.split("#")[0] !== "srs" &&
            !graphConditions?.["time-label-attrs"]?.includes(
              result.draggableId.split("#")[0]
            ) &&
            !axisPanelAtt?.breakdown_by
              ?.map((d) => d.attribute)
              ?.includes(result.draggableId.split("#")[0]) &&
            axisPanelAtt?.x_axis?.attribute !== result.draggableId.split("#")[0]
          ) {
            if (result.destination.droppableId.split("#")[3] === "update") {
              if (
                result.destination.droppableId.split("#")[4] === "x_axis" &&
                (result.draggableId.split("#")[1] === "varchar" ||
                  result.draggableId.split("#")[1] === "datetime")
              ) {
                dispatch(
                  setY_attribute({
                    ...axisPanelAtt,
                    [`x_axis`]: {
                      ...axisPanelAtt[`x_axis`],
                      attribute: result.draggableId.split("#")[0],
                      deep_dive_info: draggedAttributeObj?.deep_dive_info
                        ? draggedAttributeObj?.deep_dive_info
                        : null,
                      data_source: newDataSource,
                      trace_name:
                        All_WM_attributes[result.draggableId.split("#")[0]],
                    },
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                  })
                );
              } else if (
                result.destination.droppableId.split("#")[4] ===
                  "breakdown_by" &&
                result.draggableId.split("#")[1] === "varchar"
              ) {
                dispatch(
                  setY_attribute({
                    ...axisPanelAtt,
                    [`breakdown_by`]: axisPanelAtt?.breakdown_by?.map(
                      (e, index) => {
                        if (
                          index == result.destination.droppableId.split("#")[5]
                        ) {
                          return {
                            ...e,
                            attribute: result.draggableId.split("#")[0],
                            deep_dive_info: draggedAttributeObj?.deep_dive_info
                              ? draggedAttributeObj?.deep_dive_info
                              : null,
                            data_source: newDataSource,
                            trace_name:
                              All_WM_attributes[
                                result.draggableId.split("#")[0]
                              ],
                          };
                        } else {
                          return e;
                        }
                      }
                    ),
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                  })
                );
              } else if (
                result.destination.droppableId.split("#")[4] === "y_series" &&
                result.draggableId.split("#")[1] === "int" &&
                result.draggableId.split("#")[0] !== "nss" &&
                result.draggableId.split("#")[0] !== "srs" &&
                !graphConditions?.["time-label-attrs"]?.includes(
                  result.draggableId.split("#")[0]
                ) &&
                !y_series_array_drag?.includes(
                  result.draggableId.split("#")[0]
                ) &&
                (Array.isArray(
                  graphConditions?.[widgetGraphConfig?.chart_type]?.["y_series"]
                    ?.exclude
                )
                  ? !graphConditions?.[widgetGraphConfig?.chart_type]?.[
                      "y_series"
                    ]?.exclude.includes(result.draggableId.split("#")[0])
                  : true)
              ) {
                dispatch(
                  setY_attribute({
                    ...axisPanelAtt,
                    [`y_axis`]: {
                      ...axisPanelAtt[`y_axis`],
                      [result.destination.droppableId.split("#")[5]]: {
                        ...axisPanelAtt[`y_axis`][
                          result.destination.droppableId.split("#")[5]
                        ],
                        attribute: result.draggableId.split("#")[0],
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        data_source: newDataSource,
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                        aggregation: graphConditionAggregation?.avg?.includes(
                          result.draggableId.split("#")[0]
                        )
                          ? "avg"
                          : graphConditionAggregation?.average_attribute?.includes(
                              // For mentions attribute
                              result.draggableId.split("#")[0]
                            )
                          ? "avg"
                          : graphConditionAggregation?.count_distinct?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.count?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.max?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "max"
                          : graphConditions?.[`latest-agg-columns`]?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "latest"
                          : result.draggableId.split("#")[0] === "nss"
                          ? "COUNT"
                          : result.draggableId.split("#")[0] === "srs"
                          ? "COUNT"
                          : "SUM",
                      },
                    },
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                  })
                );
              } else {
                dispatch(
                  setY_attribute({
                    ...axisPanelAtt,
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                  })
                );
              }
            } else if (
              result.draggableId.split("#")[1] === "int" &&
              !y_series_array_drag?.includes(
                result.draggableId.split("#")[0]
              ) &&
              (Array.isArray(
                graphConditions?.[widgetGraphConfig?.chart_type]?.["y_series"]
                  ?.exclude
              )
                ? !graphConditions?.[widgetGraphConfig?.chart_type]?.[
                    "y_series"
                  ]?.exclude.includes(result.draggableId.split("#")[0])
                : true)
            ) {
              dispatch(
                setY_attribute({
                  ...axisPanelAtt,
                  y_axis: {
                    ...filterVal,
                    [`y_series_${1}`]: {
                      attribute: result.draggableId.split("#")[0],
                      deep_dive_info: draggedAttributeObj?.deep_dive_info
                        ? draggedAttributeObj?.deep_dive_info
                        : null,
                      data_source: newDataSource,
                      aggregation: graphConditionAggregation?.avg?.includes(
                        result.draggableId.split("#")[0]
                      )
                        ? "avg"
                        : graphConditionAggregation?.average_attribute?.includes(
                            // For mentions attribute
                            result.draggableId.split("#")[0]
                          )
                        ? "avg"
                        : graphConditionAggregation?.count_distinct?.includes(
                            result.draggableId.split("#")[0]
                          )
                        ? "COUNT"
                        : graphConditionAggregation?.count?.includes(
                            result.draggableId.split("#")[0]
                          )
                        ? "COUNT"
                        : graphConditionAggregation?.max?.includes(
                            result.draggableId.split("#")[0]
                          )
                        ? "max"
                        : result.draggableId.split("#")[0] === "nss"
                        ? "COUNT"
                        : result.draggableId.split("#")[0] === "srs"
                        ? "COUNT"
                        : "SUM",
                      trace_name:
                        All_WM_attributes[result.draggableId.split("#")[0]],
                    },
                  },
                  [`dragDataType`]: {
                    ...axisPanelAtt[`dragDataType`],
                    varchar: false,
                    int: false,
                    datetime: false,
                    json: false,
                  },
                })
              );
            } else if (
              result.draggableId.split("#")[1] === "varchar" ||
              result.draggableId.split("#")[1] === "datetime"
            ) {
              if (
                axisPanelAtt?.x_axis?.attribute &&
                result.draggableId.split("#")[1] !== "datetime"
              ) {
                let pivot = axisPanelAtt?.breakdown_by?.some(
                  (d) => d?.is_pivot
                );

                if (pivot && axisPanelAtt?.breakdown_by?.length < 2) {
                  dispatch(
                    setY_attribute({
                      ...axisPanelAtt,
                      breakdown_by: [
                        ...axisPanelAtt?.breakdown_by,
                        {
                          trace_name:
                            All_WM_attributes[result.draggableId.split("#")[0]],
                          attribute: result.draggableId.split("#")[0],
                          deep_dive_info: draggedAttributeObj?.deep_dive_info
                            ? draggedAttributeObj?.deep_dive_info
                            : null,
                          data_source: newDataSource,
                          date_part:
                            result.draggableId.split("#")[1] === "datetime"
                              ? "ww"
                              : null,
                          sort_order: "desc",
                          y_limit: 5,
                        },
                      ],
                      [`dragDataType`]: {
                        ...axisPanelAtt[`dragDataType`],
                        varchar: false,
                        int: false,
                        datetime: false,
                        json: false,
                      },
                    })
                  );
                } else if (!pivot && axisPanelAtt?.breakdown_by?.length < 1) {
                  dispatch(
                    setY_attribute({
                      ...axisPanelAtt,
                      breakdown_by: [
                        ...axisPanelAtt?.breakdown_by,
                        {
                          trace_name:
                            All_WM_attributes[result.draggableId.split("#")[0]],
                          attribute: result.draggableId.split("#")[0],
                          deep_dive_info: draggedAttributeObj?.deep_dive_info
                            ? draggedAttributeObj?.deep_dive_info
                            : null,
                          data_source: newDataSource,
                          date_part:
                            result.draggableId.split("#")[1] === "datetime"
                              ? "ww"
                              : null,
                          sort_order: "desc",
                          y_limit: 5,
                        },
                      ],
                      [`dragDataType`]: {
                        ...axisPanelAtt[`dragDataType`],
                        varchar: false,
                        int: false,
                        datetime: false,
                        json: false,
                      },
                    })
                  );
                }
              } else if (
                axisPanelAtt?.x_axis?.attribute &&
                result.draggableId.split("#")[1] === "datetime"
              ) {
                dispatch(
                  setX_attribute({
                    ...axisPanelAtt,
                    x_axis: {
                      attribute: result.draggableId.split("#")[0],
                      deep_dive_info: draggedAttributeObj?.deep_dive_info
                        ? draggedAttributeObj?.deep_dive_info
                        : null,
                      data_source: newDataSource,
                      trace_name:
                        All_WM_attributes[result.draggableId.split("#")[0]],
                      date_part: null,
                      sort_order: "desc",
                      x_limit: 50,
                    },
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                  })
                );
              } else {
                (result.draggableId.split("#")[1] === "varchar" ||
                  result.draggableId.split("#")[1] === "datetime") &&
                  result.draggableId.split("#")[0] !== "Keyword" &&
                  result.draggableId.split("#")[0] !== "TagCloud" &&
                  dispatch(
                    setX_attribute({
                      ...axisPanelAtt,
                      x_axis: {
                        attribute: result.draggableId.split("#")[0],
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        data_source: newDataSource,
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                        date_part: null,
                        sort_order: "desc",
                        x_limit: 50,
                      },
                      [`dragDataType`]: {
                        ...axisPanelAtt[`dragDataType`],
                        varchar: false,
                        int: false,
                        datetime: false,
                        json: false,
                      },
                      [`y_axis`]:
                        newDataSource === "tickets"
                          ? {
                              [`y_series_1`]: {
                                attribute: "caseid",
                                aggregation: "COUNT",
                                trace_name: All_WM_attributes["caseid"],
                                data_source: newDataSource,
                              },
                            }
                          : newDataSource === "page"
                          ? {
                              [`y_series_1`]: {
                                attribute: "page_followers_count",
                                aggregation: "SUM",
                                trace_name:
                                  All_WM_attributes["page_followers_count"],
                                data_source: newDataSource,
                              },
                            }
                          : {
                              [`y_series_1`]: {
                                attribute: "tagid",
                                aggregation: "COUNT",
                                trace_name: All_WM_attributes["tagid"],
                                data_source: "mentions",
                              },
                            },
                    })
                  );
              }
            } else {
              dispatch(
                setY_attribute({
                  ...axisPanelAtt,
                  [`dragDataType`]: {
                    ...axisPanelAtt[`dragDataType`],
                    varchar: false,
                    int: false,
                    datetime: false,
                    json: false,
                  },
                })
              );
            }
          } else if (
            result.destination.droppableId.split("#")[1] === "pivot" &&
            axisPanelAtt?.x_axis?.attribute !==
              result.draggableId.split("#")[0] &&
            !axisPanelAtt?.breakdown_by
              ?.map((d) => d.attribute)
              ?.includes(result.draggableId.split("#")[0])
          ) {
            graphConditionConfig?.map((d) => {
              if (d === result.draggableId.split("#")[0]) {
                (result.draggableId.split("#")[1] === "varchar" ||
                  result.draggableId.split("#")[1] === "datetime") &&
                  dispatch(
                    setY_attribute({
                      ...axisPanelAtt,
                      breakdown_by:
                        result.destination.droppableId.split("#")[3] === "-1"
                          ? [
                              ...axisPanelAtt?.breakdown_by,
                              {
                                trace_name:
                                  All_WM_attributes[
                                    result.draggableId.split("#")[0]
                                  ],
                                attribute: result.draggableId.split("#")[0],
                                deep_dive_info:
                                  draggedAttributeObj?.deep_dive_info
                                    ? draggedAttributeObj?.deep_dive_info
                                    : null,
                                data_source: newDataSource,
                                is_pivot: true,
                                y_limit: 5,
                              },
                            ]
                          : axisPanelAtt?.breakdown_by?.map((e, index) => {
                              if (
                                index ==
                                result.destination.droppableId.split("#")[3]
                              ) {
                                return {
                                  ...e,
                                  attribute: result.draggableId.split("#")[0],
                                  deep_dive_info:
                                    draggedAttributeObj?.deep_dive_info
                                      ? draggedAttributeObj?.deep_dive_info
                                      : null,
                                  data_source: newDataSource,
                                  trace_name:
                                    All_WM_attributes[
                                      result.draggableId.split("#")[0]
                                    ],
                                  is_pivot: true,
                                };
                              } else {
                                return e;
                              }
                            }),
                      [`dragDataType`]: {
                        ...axisPanelAtt[`dragDataType`],
                        varchar: false,
                        int: false,
                        datetime: false,
                        json: false,
                      },
                    })
                  );
              }
            });
          } else {
            let y_axis_length = Object?.keys(widgetGraphConfig?.y_axis)?.length;
            let multilayerMapColorSetting = ["multilayer-map"]?.includes(
              widgetGraphConfig?.chart_type
            )
              ? graphConditions?.["multilayer_map_color_setting"]
                ? graphConditions?.["multilayer_map_color_setting"]?.[
                    result.draggableId.split("#")[0]
                  ]
                : null
              : null;
            // let card_settings_data = [];
            // widgetGraphConfig?.card_settings?.map((d) => {
            //   if (
            //     (d?.x_axis?.data_source === newDataSource ||
            //       (!d?.x_axis?.attribute &&
            //         d?.y_series?.data_source === newDataSource)) &&
            //     d?.y_series?.data_source === newDataSource
            //   ) {
            //     if (
            //       (d?.x_axis?.attribute ||
            //         (!d?.x_axis?.attribute && d?.y_series)) &&
            //       d?.y_series?.attribute
            //     ) {
            //       card_settings_data = [
            //         ...card_settings_data,
            //         {
            //           x_axis:
            //             d?.x_axis == null
            //               ? null
            //               : Object.keys(d?.x_axis).length == 0
            //               ? null
            //               : d?.x_axis,
            //           y_series: d?.y_series,
            //         },
            //       ];
            //     }
            //   }
            // });

            result.draggableId.split("#")[1] === "int" &&
            result.destination.droppableId.split("#")[2] === "values" &&
            result.draggableId.split("#")[0] !== "nss" &&
            result.draggableId.split("#")[0] !== "srs" &&
            !graphConditions?.["time-label-attrs"]?.includes(
              result.draggableId.split("#")[0]
            )
              ? dispatch(
                  setY_attribute({
                    ...axisPanelAtt,
                    [result.destination.droppableId.split("#")[0]]: {
                      [result.destination.droppableId.split("#")[1]]: {
                        attribute: result.draggableId.split("#")[0],
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        data_source: newDataSource,
                        aggregation: graphConditionAggregation?.avg?.includes(
                          result.draggableId.split("#")[0]
                        )
                          ? "avg"
                          : graphConditionAggregation?.average_attribute?.includes(
                              // For mentions attribute
                              result.draggableId.split("#")[0]
                            )
                          ? "avg"
                          : graphConditionAggregation?.count_distinct?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.count?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.max?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "max"
                          : result.draggableId.split("#")[0] === "nss"
                          ? "COUNT"
                          : result.draggableId.split("#")[0] === "srs"
                          ? "COUNT"
                          : "SUM",
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                      },
                    },
                    // [`card_settings`]: card_settings_data?.length
                    //   ? card_settings_data
                    //   : [
                    //       {
                    //         card_id: uuid(),
                    //         card_name: 1,
                    //         card_value: null,
                    //         x_axis: null,
                    //         y_series: null,
                    //         response: [],
                    //       },
                    //     ],
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                  })
                )
              : // in case in future ticket attribute with #values
              result.draggableId.split("#")[1] === "int" &&
                result.destination.droppableId.split("#")[2] === "values" &&
                result.draggableId.split("#")[0] !== "nss" &&
                result.draggableId.split("#")[0] !== "srs" &&
                (graphConditions?.["time-label-attrs"]?.includes(
                  result.draggableId.split("#")[0]
                ) ||
                  graphConditions?.["tikcket-time-label-attrs"]?.includes(
                    result.draggableId.split("#")[0]
                  )) &&
                (widgetGraphConfig?.chart_type === "kpi" ||
                  widgetGraphConfig?.chart_type === "progress-kpi")
              ? dispatch(
                  setY_attribute({
                    ...axisPanelAtt,
                    [result.destination.droppableId.split("#")[0]]: {
                      [result.destination.droppableId.split("#")[1]]: {
                        attribute: result.draggableId.split("#")[0],
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        data_source: newDataSource,
                        aggregation: graphConditionAggregation?.avg?.includes(
                          result.draggableId.split("#")[0]
                        )
                          ? "avg"
                          : graphConditionAggregation?.average_attribute?.includes(
                              // For mentions attribute
                              result.draggableId.split("#")[0]
                            )
                          ? "avg"
                          : graphConditionAggregation?.count_distinct?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.count?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.max?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "max"
                          : result.draggableId.split("#")[0] === "nss"
                          ? "COUNT"
                          : result.draggableId.split("#")[0] === "srs"
                          ? "COUNT"
                          : "SUM",
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                      },
                    },
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                  })
                )
              : result.draggableId.split("#")[0] !== "nss" &&
                result.draggableId.split("#")[0] !== "srs" &&
                !graphConditions?.["time-label-attrs"]?.includes(
                  result.draggableId.split("#")[0]
                ) &&
                result.draggableId.split("#")[1] === "int" &&
                result.destination.droppableId.split("#")[2] === "attribute"
              ? dispatch(
                  setY_attribute({
                    ...axisPanelAtt,
                    [result.destination.droppableId.split("#")[0]]: {
                      ...axisPanelAtt[
                        result.destination.droppableId.split("#")[0]
                      ],
                      [result.destination.droppableId.split("#")[1]]: {
                        ...axisPanelAtt[
                          result.destination.droppableId.split("#")[0]
                        ][result.destination.droppableId.split("#")[1]],
                        [result.destination.droppableId.split("#")[2]]:
                          result.draggableId.split("#")[0],
                        aggregation: graphConditionAggregation?.avg?.includes(
                          result.draggableId.split("#")[0]
                        )
                          ? "avg"
                          : graphConditionAggregation?.average_attribute?.includes(
                              // For mentions attribute
                              result.draggableId.split("#")[0]
                            )
                          ? "avg"
                          : graphConditionAggregation?.count_distinct?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.count?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.max?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "max"
                          : result.draggableId.split("#")[0] === "nss"
                          ? "COUNT"
                          : result.draggableId.split("#")[0] === "srs"
                          ? "COUNT"
                          : "SUM",
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                        data_source: newDataSource,
                      },
                    },
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                    [`y_axis_settings`]: axisPanelAtt.y_axis[
                      result.destination.droppableId.split("#")[1]
                    ]?.attribute
                      ? [...axisPanelAtt[`y_axis_settings`]]
                      : result.destination.droppableId.split("#")[1] ===
                          "y_series_1" &&
                        axisPanelAtt?.y_axis_settings?.length > 0
                      ? [...axisPanelAtt[`y_axis_settings`]]
                      : [
                          ...axisPanelAtt[`y_axis_settings`],
                          {
                            show_as:
                              axisPanelAtt?.y_axis_settings?.length === 0
                                ? "bar"
                                : "line",
                            y_axis_map_at:
                              axisPanelAtt?.y_axis_settings?.length === 0
                                ? 0
                                : 1,
                            show_markers: true,
                            show_data_label: true,
                            y_axis_scale: "linear",
                            color_pattern_code: 1,
                            key: uuid(),
                            multilayer_thresholds: multilayerMapColorSetting,
                          },
                        ],
                  })
                )
              : result.destination.droppableId.split("#")[1] !== "y_series_2" &&
                result.destination.droppableId.split("#")[1] !== "y_series_3" &&
                result.destination.droppableId.split("#")[1] !== "y_series_4" &&
                result.destination.droppableId.split("#")[1] !== "y_series_5" &&
                (widgetGraphConfig?.chart_type === "bar" ||
                  widgetGraphConfig?.chart_type === "horizontal-bar" ||
                  widgetGraphConfig?.chart_type === "lollipop" ||
                  widgetGraphConfig?.chart_type === "area" ||
                  widgetGraphConfig?.chart_type === "line" ||
                  widgetGraphConfig?.chart_type === "scatter" ||
                  widgetGraphConfig?.chart_type === "treemap" ||
                  widgetGraphConfig?.chart_type === "quadrant") &&
                (result.draggableId.split("#")[0] === "nss" ||
                  result.draggableId.split("#")[0] === "srs") &&
                result.draggableId.split("#")[1] === "int" &&
                !graphConditions?.["time-label-attrs"]?.includes(
                  result.draggableId.split("#")[0]
                ) &&
                result.destination.droppableId.split("#")[2] === "attribute" &&
                y_axis_length == 1
              ? dispatch(
                  setY_attribute({
                    ...axisPanelAtt,
                    [result.destination.droppableId.split("#")[0]]: {
                      ...axisPanelAtt[
                        result.destination.droppableId.split("#")[0]
                      ],
                      [result.destination.droppableId.split("#")[1]]: {
                        ...axisPanelAtt[
                          result.destination.droppableId.split("#")[0]
                        ][result.destination.droppableId.split("#")[1]],
                        [result.destination.droppableId.split("#")[2]]:
                          result.draggableId.split("#")[0],
                        aggregation: graphConditionAggregation?.avg?.includes(
                          result.draggableId.split("#")[0]
                        )
                          ? "avg"
                          : graphConditionAggregation?.average_attribute?.includes(
                              // For mentions attribute
                              result.draggableId.split("#")[0]
                            )
                          ? "avg"
                          : graphConditionAggregation?.count_distinct?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.count?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.max?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "max"
                          : result.draggableId.split("#")[0] === "nss"
                          ? "COUNT"
                          : result.draggableId.split("#")[0] === "srs"
                          ? "COUNT"
                          : "SUM",
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                        data_source: newDataSource,
                      },
                    },
                    x_axis: {
                      attribute: "CreatedDate",
                      trace_name: All_WM_attributes["CreatedDate"],
                      date_part: null,
                      sort_order: "desc",
                      x_limit: 30,
                      data_source: "mentions",
                    },
                    breakdown_by: [
                      {
                        trace_name: All_WM_attributes["BrandName"],
                        attribute: "BrandName",
                        date_part: null,
                        sort_order: "desc",
                        y_limit: 5,
                        data_source: "mentions",
                      },
                    ],
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                    [`y_axis_settings`]: axisPanelAtt.y_axis[
                      result.destination.droppableId.split("#")[1]
                    ]?.attribute
                      ? [...axisPanelAtt[`y_axis_settings`]]
                      : [
                          ...axisPanelAtt[`y_axis_settings`],
                          {
                            show_as:
                              axisPanelAtt?.y_axis_settings?.length === 0
                                ? "bar"
                                : "line",
                            y_axis_map_at:
                              axisPanelAtt?.y_axis_settings?.length === 0
                                ? 0
                                : 1,
                            show_markers: true,
                            show_data_label: true,
                            y_axis_scale: "linear",
                            color_pattern_code: 1,
                            key: uuid(),
                            multilayer_thresholds: multilayerMapColorSetting,
                          },
                        ],
                  })
                )
              : result.destination.droppableId.split("#")[1] !== "y_series_2" &&
                result.destination.droppableId.split("#")[1] !== "y_series_3" &&
                result.destination.droppableId.split("#")[1] !== "y_series_4" &&
                result.destination.droppableId.split("#")[1] !== "y_series_5" &&
                (widgetGraphConfig?.chart_type === "bar" ||
                  widgetGraphConfig?.chart_type === "horizontal-bar" ||
                  widgetGraphConfig?.chart_type === "lollipop" ||
                  widgetGraphConfig?.chart_type === "area" ||
                  widgetGraphConfig?.chart_type === "line" ||
                  widgetGraphConfig?.chart_type === "scatter" ||
                  widgetGraphConfig?.chart_type === "treemap" ||
                  widgetGraphConfig?.chart_type === "quadrant") &&
                graphConditions?.["time-label-attrs"]?.includes(
                  result.draggableId.split("#")[0]
                ) &&
                result.draggableId.split("#")[1] === "int" &&
                result.destination.droppableId.split("#")[2] === "attribute"
              ? dispatch(
                  setY_attribute({
                    ...axisPanelAtt,
                    [result.destination.droppableId.split("#")[0]]: {
                      ...axisPanelAtt[
                        result.destination.droppableId.split("#")[0]
                      ],
                      [result.destination.droppableId.split("#")[1]]: {
                        ...axisPanelAtt[
                          result.destination.droppableId.split("#")[0]
                        ][result.destination.droppableId.split("#")[1]],
                        [result.destination.droppableId.split("#")[2]]:
                          result.draggableId.split("#")[0],
                        aggregation: graphConditionAggregation?.avg?.includes(
                          result.draggableId.split("#")[0]
                        )
                          ? "avg"
                          : graphConditionAggregation?.average_attribute?.includes(
                              // For mentions attribute
                              result.draggableId.split("#")[0]
                            )
                          ? "avg"
                          : graphConditionAggregation?.count_distinct?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.count?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.max?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "max"
                          : result.draggableId.split("#")[0] === "nss"
                          ? "COUNT"
                          : result.draggableId.split("#")[0] === "srs"
                          ? "COUNT"
                          : "SUM",
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                        data_source: newDataSource,
                      },
                    },
                    y_axis: {
                      y_series_1: {
                        attribute: result.draggableId.split("#")[0],
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        data_source: newDataSource,
                        aggregation: graphConditionAggregation?.avg?.includes(
                          result.draggableId.split("#")[0]
                        )
                          ? "avg"
                          : graphConditionAggregation?.average_attribute?.includes(
                              // For mentions attribute
                              result.draggableId.split("#")[0]
                            )
                          ? "avg"
                          : graphConditionAggregation?.count_distinct?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.count?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.max?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "max"
                          : result.draggableId.split("#")[0] === "nss"
                          ? "COUNT"
                          : result.draggableId.split("#")[0] === "srs"
                          ? "COUNT"
                          : "SUM",
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                      },
                    },
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                    [`y_axis_settings`]: axisPanelAtt.y_axis[
                      result.destination.droppableId.split("#")[1]
                    ]?.attribute
                      ? [...axisPanelAtt[`y_axis_settings`]]
                      : result.destination.droppableId.split("#")[1] ===
                          "y_series_1" &&
                        axisPanelAtt?.y_axis_settings?.length > 0
                      ? [...axisPanelAtt[`y_axis_settings`]]
                      : [
                          ...axisPanelAtt[`y_axis_settings`],
                          {
                            show_as:
                              axisPanelAtt?.y_axis_settings?.length === 0
                                ? "bar"
                                : "line",
                            y_axis_map_at:
                              axisPanelAtt?.y_axis_settings?.length === 0
                                ? 0
                                : 1,
                            show_markers: true,
                            show_data_label: true,
                            y_axis_scale: "linear",
                            color_pattern_code: 1,
                            key: uuid(),
                            multilayer_thresholds: multilayerMapColorSetting,
                          },
                        ],
                  })
                )
              : result.destination.droppableId.split("#")[1] !== "y_series_2" &&
                result.destination.droppableId.split("#")[1] !== "y_series_3" &&
                result.destination.droppableId.split("#")[1] !== "y_series_4" &&
                result.destination.droppableId.split("#")[1] !== "y_series_5" &&
                widgetGraphConfig?.chart_type === "combination" &&
                graphConditions?.["time-label-attrs"]?.includes(
                  result.draggableId.split("#")[0]
                ) &&
                result.draggableId.split("#")[1] === "int" &&
                result.destination.droppableId.split("#")[2] === "attribute"
              ? dispatch(
                  setY_attribute({
                    ...axisPanelAtt,
                    [result.destination.droppableId.split("#")[0]]: {
                      ...axisPanelAtt[
                        result.destination.droppableId.split("#")[0]
                      ],
                      [result.destination.droppableId.split("#")[1]]: {
                        ...axisPanelAtt[
                          result.destination.droppableId.split("#")[0]
                        ][result.destination.droppableId.split("#")[1]],
                        [result.destination.droppableId.split("#")[2]]:
                          result.draggableId.split("#")[0],
                        aggregation: graphConditionAggregation?.avg?.includes(
                          result.draggableId.split("#")[0]
                        )
                          ? "avg"
                          : graphConditionAggregation?.average_attribute?.includes(
                              // For mentions attribute
                              result.draggableId.split("#")[0]
                            )
                          ? "avg"
                          : graphConditionAggregation?.count_distinct?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.count?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.max?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "max"
                          : result.draggableId.split("#")[0] === "nss"
                          ? "COUNT"
                          : result.draggableId.split("#")[0] === "srs"
                          ? "COUNT"
                          : "SUM",
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                        data_source: newDataSource,
                      },
                    },
                    y_axis: {
                      y_series_1: {
                        attribute: result.draggableId.split("#")[0],
                        deep_dive_info: draggedAttributeObj?.deep_dive_info
                          ? draggedAttributeObj?.deep_dive_info
                          : null,
                        data_source: newDataSource,
                        aggregation: graphConditionAggregation?.avg?.includes(
                          result.draggableId.split("#")[0]
                        )
                          ? "avg"
                          : graphConditionAggregation?.average_attribute?.includes(
                              // For mentions attribute
                              result.draggableId.split("#")[0]
                            )
                          ? "avg"
                          : graphConditionAggregation?.count_distinct?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.count?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "COUNT"
                          : graphConditionAggregation?.max?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "max"
                          : graphConditions?.[`latest-agg-columns`]?.includes(
                              result.draggableId.split("#")[0]
                            )
                          ? "latest"
                          : result.draggableId.split("#")[0] === "nss"
                          ? "COUNT"
                          : result.draggableId.split("#")[0] === "srs"
                          ? "COUNT"
                          : "SUM",
                        trace_name:
                          All_WM_attributes[result.draggableId.split("#")[0]],
                      },
                      y_series_2: {
                        attribute:
                          widgetGraphConfig?.y_axis?.y_series_2?.attribute,
                        deep_dive_info: widgetGraphConfig?.y_axis?.y_series_2
                          ?.deep_dive_info
                          ? widgetGraphConfig?.y_axis?.y_series_2
                              ?.deep_dive_info
                          : null,
                        data_source: checkAttributeSource(
                          attributes,
                          widgetGraphConfig?.y_axis?.y_series_2?.attribute
                        ),
                        aggregation:
                          widgetGraphConfig?.y_axis?.y_series_2?.aggregation,
                        trace_name:
                          widgetGraphConfig?.y_axis?.y_series_2?.trace_name,
                      },
                    },
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                    [`y_axis_settings`]: axisPanelAtt.y_axis[
                      result.destination.droppableId.split("#")[1]
                    ]?.attribute
                      ? [...axisPanelAtt[`y_axis_settings`]]
                      : result.destination.droppableId.split("#")[1] ===
                          "y_series_1" &&
                        axisPanelAtt?.y_axis_settings?.length > 0
                      ? [...update_y_axis_settings]
                      : [
                          ...axisPanelAtt[`y_axis_settings`],
                          {
                            show_as:
                              axisPanelAtt?.y_axis_settings?.length === 0
                                ? "bar"
                                : "line",
                            y_axis_map_at:
                              axisPanelAtt?.y_axis_settings?.length === 0
                                ? 0
                                : 1,
                            show_markers: true,
                            show_data_label: true,
                            y_axis_scale: "linear",
                            color_pattern_code: 1,
                            key: uuid(),
                            multilayer_thresholds: multilayerMapColorSetting,
                          },
                        ],
                  })
                )
              : dispatch(
                  setY_attribute({
                    ...axisPanelAtt,
                    [`dragDataType`]: {
                      ...axisPanelAtt[`dragDataType`],
                      varchar: false,
                      int: false,
                      datetime: false,
                      json: false,
                    },
                  })
                );
          }
        }
      } else if (
        (((result.draggableId.split("#")[1] === "varchar" ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "combination") ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "bar") ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "lollipop") ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "horizontal-bar") ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "area") ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "line") ||
          (result.draggableId.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "treemap") ||
          (result?.draggableId?.split("#")[1] === "datetime" &&
            widgetGraphConfig?.chart_type === "heatmap")) &&
          ![
            "sankey",
            "scatter",
            "quadrant",
            "multilayer-map",
            // "treemap",
          ]?.includes(widgetGraphConfig?.chart_type) &&
          ((result?.draggableId?.split("#")[1] === "datetime" &&
            dateWithDateChartTypes?.includes(widgetGraphConfig?.chart_type) &&
            result?.draggableId?.split("#")[0] ===
              axisPanelAtt?.x_axis?.attribute) ||
            result?.draggableId?.split("#")[0] !==
              axisPanelAtt?.x_axis?.attribute)) ||
          ([
            "sankey",
            "scatter",
            "quadrant",
            "multilayer-map",
            // "treemap",
          ]?.includes(widgetGraphConfig?.chart_type) &&
            isAllowedToDrag)) &&
        result.destination.droppableId.split("#")[0] === "breakdown_by"
      ) {
        if (
          (widgetGraphConfig?.chart_type === "wordcloud" ||
            widgetGraphConfig?.chart_type === "heatmap" ||
            widgetGraphConfig?.chart_type === "bubble" ||
            widgetGraphConfig?.chart_type === "sankey" ||
            widgetGraphConfig?.chart_type === "sunburst") &&
          (result?.draggableId?.split("#")[1] === "varchar" ||
            (widgetGraphConfig?.chart_type === "heatmap" &&
              result?.draggableId?.split("#")[1] === "datetime")) &&
          result.draggableId.split("#")[0] !== "Rating"
        ) {
          // To add breakdown by in sankey
          let index = result.destination?.droppableId.split("#")[1];
          if (widgetGraphConfig?.chart_type === "sankey") {
            const updatedBreakdownBy = [...axisPanelAtt.breakdown_by];

            updatedBreakdownBy[index] = {
              ...updatedBreakdownBy[index],
              attribute: result.draggableId.split("#")[0],
              deep_dive_info: draggedAttributeObj?.deep_dive_info
                ? draggedAttributeObj?.deep_dive_info
                : null,
              data_source: newDataSource,
              trace_name: All_WM_attributes[result.draggableId.split("#")[0]],
              date_part:
                result.draggableId.split("#")[1] === "datetime" ? "ww" : null,
              sort_order: "desc",
              y_limit: 5,
            };

            const updatedAxisPanelAtt = {
              ...axisPanelAtt,
              breakdown_by: updatedBreakdownBy,
            };

            dispatch(
              setY_attribute({
                ...updatedAxisPanelAtt,
                dragDataType: {
                  ...updatedAxisPanelAtt.dragDataType,
                  varchar: false,
                  int: false,
                  datetime: false,
                  json: false,
                },
              })
            );
          } else {
            dispatch(
              setY_attribute({
                ...axisPanelAtt,
                [result.destination.droppableId]: [
                  {
                    trace_name:
                      All_WM_attributes[result.draggableId.split("#")[0]],
                    attribute: result.draggableId.split("#")[0],
                    deep_dive_info: draggedAttributeObj?.deep_dive_info
                      ? draggedAttributeObj?.deep_dive_info
                      : null,
                    data_source: newDataSource,
                    date_part:
                      result.draggableId.split("#")[1] === "datetime"
                        ? "ww"
                        : null,
                    sort_order: "desc",
                    y_limit: 5,
                  },
                ],
                [`dragDataType`]: {
                  ...axisPanelAtt[`dragDataType`],
                  varchar: false,
                  int: false,
                  datetime: false,
                  json: false,
                },
              })
            );
          }
        } else if (
          widgetGraphConfig?.chart_type !== "wordcloud" &&
          widgetGraphConfig?.chart_type !== "heatmap" &&
          widgetGraphConfig?.chart_type !== "bubble" &&
          widgetGraphConfig?.chart_type !== "sankey" &&
          widgetGraphConfig?.chart_type !== "sunburst"
        ) {
          if (
            widgetGraphConfig?.y_axis?.y_series_1?.attribute === "nss" ||
            widgetGraphConfig?.y_axis?.y_series_1?.attribute === "srs"
          ) {
            // only for BrandName attribute for breakdown by
            if (
              widgetGraphConfig?.y_axis?.y_series_1?.attribute === "srs" &&
              result.draggableId.split("#")[0] === "BrandName"
            ) {
              dispatch(
                setY_attribute({
                  ...axisPanelAtt,
                  [result.destination.droppableId]: [
                    {
                      trace_name:
                        All_WM_attributes[result.draggableId.split("#")[0]],
                      attribute: result.draggableId.split("#")[0],
                      deep_dive_info: draggedAttributeObj?.deep_dive_info
                        ? draggedAttributeObj?.deep_dive_info
                        : null,
                      data_source: newDataSource,
                      date_part:
                        result.draggableId.split("#")[1] === "datetime"
                          ? "ww"
                          : null,
                      sort_order: "desc",
                      y_limit: 5,
                    },
                  ],
                  [`dragDataType`]: {
                    ...axisPanelAtt[`dragDataType`],
                    varchar: false,
                    int: false,
                    datetime: false,
                    json: false,
                  },
                })
              );
            } else {
              // Dont drag
            }
          } else {
            if (widgetGraphConfig?.chart_type === "combination") {
              axisPanelAtt.chart_settings.is_stacked = true;
              axisPanelAtt.chart_settings.gradient_color = false;
            }
            dispatch(
              setY_attribute({
                ...axisPanelAtt,
                [result.destination.droppableId]: [
                  {
                    trace_name:
                      All_WM_attributes[result.draggableId.split("#")[0]],
                    attribute: result.draggableId.split("#")[0],
                    deep_dive_info: draggedAttributeObj?.deep_dive_info
                      ? draggedAttributeObj?.deep_dive_info
                      : null,
                    data_source: newDataSource,
                    date_part:
                      result.draggableId.split("#")[1] === "datetime"
                        ? "ww"
                        : null,
                    sort_order: "desc",
                    y_limit: 5,
                  },
                ],
                [`dragDataType`]: {
                  ...axisPanelAtt[`dragDataType`],
                  varchar: false,
                  int: false,
                  datetime: false,
                  json: false,
                },
              })
            );
          }
        }
      } else if (
        result.destination.droppableId === "fields" &&
        !axisPanelAtt?.fields
          ?.map((d) => d.title)
          ?.includes(result.draggableId.split("#")[0]) &&
        axisPanelAtt?.fields?.length < 5
      ) {
        dispatch(
          setY_attribute({
            ...axisPanelAtt,
            [result.destination.droppableId]: [
              ...axisPanelAtt[result.destination.droppableId],
              {
                title: result.draggableId.split("#")[0],
                datatype: result.draggableId.split("#")[1],
              },
            ],
            [`dragDataType`]: {
              ...axisPanelAtt[`dragDataType`],
              varchar: false,
              int: false,
              datetime: false,
              json: false,
            },
          })
        );
      } else if (
        // cannot allow card setting change
        result.destination.droppableId.split("#")[0] === "card_settings" &&
        ((result.destination.droppableId.split("#")[1] === "x_axis" &&
          dataType === "varchar") ||
          (result.destination.droppableId.split("#")[1] === "y_series" &&
            result.draggableId.split("#")[0] !== "nss" &&
            result.draggableId.split("#")[0] !== "srs" &&
            !graphConditions?.["time-label-attrs"]?.includes(
              result.draggableId.split("#")[0]
            ) &&
            !graphConditions?.["ticket-time-label-attrs"]?.includes(
              result.draggableId.split("#")[0]
            ) &&
            dataType === "int"))
      ) {
        let initialCard = axisPanelAtt?.card_settings?.filter(
          (e) => e.x_axis !== null
        );
        let totalCardLimit = 15;

        let graphConfig = {
          ...axisPanelAtt,
          [`dragDataType`]: {
            ...axisPanelAtt[`dragDataType`],
            varchar: false,
            int: false,
            datetime: false,
            json: false,
          },
          [result.destination.droppableId.split("#")[0]]:
            axisPanelAtt.card_settings?.length === 0 ||
            !axisPanelAtt.card_settings?.find(
              (e) => e?.card_id === result.destination.droppableId.split("#")[2]
            )
              ? [
                  ...initialCard,
                  {
                    card_id: result.destination.droppableId.split("#")[2],
                    [result.destination.droppableId.split("#")[1]]:
                      result.destination.droppableId.split("#")[1] === "x_axis"
                        ? {
                            attribute: attName,
                            deep_dive_info: draggedAttributeObj?.deep_dive_info
                              ? draggedAttributeObj?.deep_dive_info
                              : null,
                            data_source: newDataSource,
                            date_part: null,
                            sort_order: "desc",
                            x_limit:
                              cardCount && totalCardLimit - cardCount < 5
                                ? totalCardLimit - cardCount
                                : 5,
                          }
                        : {
                            attribute: attName,
                            deep_dive_info: draggedAttributeObj?.deep_dive_info
                              ? draggedAttributeObj?.deep_dive_info
                              : null,
                            data_source: newDataSource,
                            aggregation:
                              graphConditionAggregation?.avg?.includes(attName)
                                ? "avg"
                                : graphConditionAggregation?.average_attribute?.includes(
                                    // For mentions attribute
                                    attName
                                  )
                                ? "avg"
                                : graphConditionAggregation?.count_distinct?.includes(
                                    attName
                                  )
                                ? "COUNT"
                                : graphConditionAggregation?.count?.includes(
                                    attName
                                  )
                                ? "COUNT"
                                : graphConditionAggregation?.max?.includes(
                                    attName
                                  )
                                ? "max"
                                : graphConditions?.[
                                    `latest-agg-columns`
                                  ]?.includes(attName)
                                ? "latest"
                                : attName === "nss"
                                ? "COUNT"
                                : attName === "srs"
                                ? "COUNT"
                                : "SUM",
                            trace_name: null,
                          },
                  },
                ]
              : [
                  ...axisPanelAtt[
                    result.destination.droppableId.split("#")[0]
                  ].map((e) =>
                    e.card_id === result.destination.droppableId.split("#")[2]
                      ? {
                          ...e,
                          ["x_axis"]:
                            result.destination.droppableId.split("#")[1] ===
                            "x_axis"
                              ? {
                                  attribute: attName,
                                  deep_dive_info:
                                    draggedAttributeObj?.deep_dive_info
                                      ? draggedAttributeObj?.deep_dive_info
                                      : null,
                                  data_source: newDataSource,
                                  date_part: null,
                                  sort_order: "desc",
                                  x_limit: e?.x_axis?.x_limit
                                    ? e?.x_axis?.x_limit
                                    : cardCount &&
                                      totalCardLimit - cardCount < 5
                                    ? totalCardLimit - cardCount
                                    : 5,
                                  trace_name:
                                    All_WM_attributes?.[attName] +
                                    " With " +
                                    All_WM_attributes?.[
                                      e?.y_series?.attribute
                                        ? e?.y_series?.attribute
                                        : "tagid"
                                    ],
                                }
                              : e?.x_axis?.attribute && {
                                  ...e?.x_axis,
                                  trace_name:
                                    e?.x_axis?.attribute &&
                                    All_WM_attributes?.[e?.x_axis?.attribute] +
                                      " With " +
                                      All_WM_attributes?.[attName],
                                },
                          [`y_series`]:
                            result.destination.droppableId.split("#")[1] ===
                            "x_axis"
                              ? ![result.destination.droppableId.split("#")[1]]
                                  .attribute && {
                                  attribute:
                                    dataType === "int"
                                      ? attName
                                      : e?.y_series?.attribute
                                      ? e?.y_series?.attribute
                                      : e?.y_series?.attribute == null
                                      ? newDataSource === "page"
                                        ? "page_followers_count"
                                        : "tagid"
                                      : e?.y_series?.attribute,
                                  deep_dive_info:
                                    dataType === "int"
                                      ? draggedAttributeObj?.deep_dive_info
                                        ? draggedAttributeObj?.deep_dive_info
                                        : null
                                      : e?.y_series?.deep_dive_info
                                      ? e?.y_series?.deep_dive_info
                                      : null,
                                  data_source: checkAttributeSource(
                                    attributes,
                                    dataType === "int"
                                      ? attName
                                      : e?.y_series?.attribute
                                      ? e?.y_series?.attribute
                                      : e?.y_series?.attribute == null
                                      ? newDataSource === "page"
                                        ? "page_followers_count"
                                        : "tagid"
                                      : e?.y_series?.attribute
                                  ),
                                  aggregation: e?.y_series?.aggregation
                                    ? e?.y_series?.aggregation
                                    : graphConditionAggregation?.avg?.includes(
                                        attName
                                      )
                                    ? "avg"
                                    : graphConditionAggregation?.average_attribute?.includes(
                                        // For mentions attribute
                                        attName
                                      )
                                    ? "avg"
                                    : graphConditionAggregation?.count_distinct?.includes(
                                        attName
                                      )
                                    ? "COUNT"
                                    : graphConditionAggregation?.count?.includes(
                                        attName
                                      )
                                    ? "COUNT"
                                    : graphConditionAggregation?.max?.includes(
                                        attName
                                      )
                                    ? "max"
                                    : attName === "nss"
                                    ? "COUNT"
                                    : attName === "srs"
                                    ? "COUNT"
                                    : newDataSource === "page"
                                    ? "SUM"
                                    : "COUNT",
                                  trace_name: null,
                                }
                              : {
                                  attribute: attName,
                                  deep_dive_info:
                                    draggedAttributeObj?.deep_dive_info
                                      ? draggedAttributeObj?.deep_dive_info
                                      : null,
                                  data_source: newDataSource,

                                  aggregation:
                                    graphConditionAggregation?.avg?.includes(
                                      attName
                                    )
                                      ? "avg"
                                      : graphConditionAggregation?.average_attribute?.includes(
                                          // For mentions attribute
                                          attName
                                        )
                                      ? "avg"
                                      : graphConditionAggregation?.count_distinct?.includes(
                                          attName
                                        )
                                      ? "COUNT"
                                      : graphConditionAggregation?.count?.includes(
                                          attName
                                        )
                                      ? "COUNT"
                                      : graphConditionAggregation?.max?.includes(
                                          attName
                                        )
                                      ? "max"
                                      : graphConditions?.[
                                          `latest-agg-columns`
                                        ]?.includes(attName)
                                      ? "latest"
                                      : attName === "nss"
                                      ? "COUNT"
                                      : attName === "srs"
                                      ? "COUNT"
                                      : "SUM",
                                  trace_name: All_WM_attributes[attName],
                                },
                        }
                      : e
                  ),
                ],
        };
        dispatch(setCardSettings(graphConfig));
      } else if (
        (result.destination.droppableId.split("#")[1] === "post-card" ||
          result.destination.droppableId.split("#")[1] === "news-card" ||
          result.destination.droppableId.split("#")[1] === "review-card" ||
          result.destination.droppableId.split("#")[1] === "survey-card") &&
        result.draggableId.split("#")[0] !== "nss" &&
        result.draggableId.split("#")[0] !== "srs" &&
        !graphConditions?.["time-label-attrs"]?.includes(
          result.draggableId.split("#")[0]
        ) &&
        !graphConditions?.["ticket-time-label-attrs"]?.includes(
          result.draggableId.split("#")[0]
        )
      ) {
        if (
          (dataType === "int" || dataType === "datetime") &&
          attName !== "tagid" &&
          attName !== "authorid" &&
          ((result.destination.droppableId.split("#")[1] === "survey-card" &&
            graphConditions?.["survey-card"]?.order_by?.include?.includes(
              attName
            )) ||
            (result.destination.droppableId.split("#")[1] === "post-card" &&
              graphConditions?.["post-card"]?.order_by?.include?.includes(
                attName
              )) ||
            (result.destination.droppableId.split("#")[1] === "review-card" &&
              graphConditions?.["review-card"]?.order_by?.include?.includes(
                attName
              )) ||
            (result.destination.droppableId.split("#")[1] === "news-card" &&
              graphConditions?.["news-card"]?.order_by?.include?.includes(
                attName
              )))
        ) {
          dispatch(
            setY_attribute({
              ...axisPanelAtt,
              [`order_by`]: {
                attribute: attName,
                data_source: newDataSource,
                sort_order: "desc",
                offset: 0,
              },
              [`dragDataType`]: {
                ...axisPanelAtt[`dragDataType`],
                varchar: false,
                int: false,
                datetime: false,
                json: false,
              },
            })
          );
        } else if (
          (dataType === "varchar" &&
            ((result.destination.droppableId.split("#")[1] === "survey-card" &&
              !graphConditions["survey-card"]?.y_axes?.exclude?.includes(
                attName
              )) ||
              (result.destination.droppableId.split("#")[1] === "post-card" &&
                !graphConditions["post-card"]?.y_axes?.exclude?.includes(
                  attName
                )))) ||
          ((dataType === "varchar" || dataType === "int") &&
            result.destination.droppableId.split("#")[1] === "review-card" &&
            graphConditions["review-attributes"]?.includes(attName))
        ) {
          dispatch(
            setY_attribute({
              ...axisPanelAtt,
              [`filter_by_data`]: null,
              [`postcard_pills_filter`]: null,
              [`breakdown_by`]: [],
              [`order_by`]: axisPanelAtt?.order_by?.attribute && {
                ...axisPanelAtt?.order_by,
                offset: 0,
              },
              [`filter_by`]: [
                {
                  trace_name: All_WM_attributes[attName],
                  attribute: attName,
                  data_source: newDataSource,
                  is_pivot: true,
                  date_part: null,
                  sort_order: "desc",
                  y_limit: 5,
                },
              ],
              [`dragDataType`]: {
                ...axisPanelAtt[`dragDataType`],
                varchar: false,
                int: false,
                datetime: false,
                json: false,
              },
            })
          );
        }
      } else if (
        result.destination.droppableId.split("#")[1] === "word-cloud" &&
        result.draggableId.split("#")[0] !== "nss" &&
        result.draggableId.split("#")[0] !== "srs" &&
        !graphConditions?.["time-label-attrs"]?.includes(
          result.draggableId.split("#")[0]
        ) &&
        !graphConditions?.["ticket-time-label-attrs"]?.includes(
          result.draggableId.split("#")[0]
        ) &&
        dataType === "varchar"
      ) {
        if (
          dataType === "varchar" &&
          !graphConditions["post-card"]?.y_axes?.exclude?.includes(attName)
        ) {
          dispatch(
            setY_attribute({
              ...axisPanelAtt,
              [`filter_by_data`]: null,
              [`postcard_pills_filter`]: null,
              [`breakdown_by`]: [],
              [`order_by`]: axisPanelAtt?.order_by?.attribute && {
                ...axisPanelAtt?.order_by,
                offset: 0,
              },
              [`filter_by`]: [
                {
                  trace_name: All_WM_attributes[attName],
                  attribute: attName,
                  data_source: newDataSource,
                  is_pivot: true,
                  date_part: null,
                  sort_order: "desc",
                  y_limit: 5,
                },
              ],
              [`dragDataType`]: {
                ...axisPanelAtt[`dragDataType`],
                varchar: false,
                int: false,
                datetime: false,
                json: false,
              },
            })
          );
        }
      } else if (
        result.destination.droppableId.split("#")[1] === "review-card" &&
        (result.draggableId.split("#")[0] === "CreatedDate" ||
          result.draggableId.split("#")[0] === "Rating")
      ) {
        dispatch(
          setY_attribute({
            ...axisPanelAtt,
            [`order_by`]: {
              attribute: attName,
              data_source: newDataSource,
              sort_order: "desc",
              offset: 0,
            },
            [`dragDataType`]: {
              ...axisPanelAtt[`dragDataType`],
              varchar: false,
              int: false,
              datetime: false,
              json: false,
            },
          })
        );
      } else if (
        result.destination.droppableId.split("#")[1] === "author-card" &&
        (result.draggableId.split("#")[0] === "FollowersCount" ||
          result.draggableId.split("#")[0] === "FollowingCount" ||
          result.draggableId.split("#")[0] === "NumShareCount")
      ) {
        dispatch(
          setY_attribute({
            ...axisPanelAtt,
            [`order_by`]: {
              attribute: attName,
              data_source: newDataSource,
              sort_order: "desc",
              offset: 0,
            },
            [`dragDataType`]: {
              ...axisPanelAtt[`dragDataType`],
              varchar: false,
              int: false,
              datetime: false,
              json: false,
            },
          })
        );
      } else {
        dispatch(
          setY_attribute({
            ...axisPanelAtt,
            [`dragDataType`]: {
              ...axisPanelAtt[`dragDataType`],
              varchar: false,
              int: false,
              datetime: false,
              json: false,
            },
          })
        );
        return;
      }

      dispatch(setUpdateImpression(false));
    } else {
      dispatch(
        setX_attribute({
          ...axisPanelAtt,
          [`dragDataType`]: {
            varchar: false,
            int: false,
            datetime: false,
            json: false,
          },
          [`edit_fields`]: axisPanelAtt.edit_fields && {
            ...axisPanelAtt.edit_fields,
            boolValue: false,
          },
        })
      );
      getEmptyFieldNotification();
    }
  };

  const onDragStart = (result) => {
    // Here we are handling our kpi rearragement thing
    if (result?.type === "CardSettingColumn") {
      if (axisPanelAtt?.edit_fields?.boolValue) {
        let data = {
          boolValue: false,
        };
        dispatch(setChartEditField(data, axisPanelAtt));
      }
      return;
    }
    let attributes = { ...WM_attributes };
    dispatch(
      setX_attribute({
        ...axisPanelAtt,
        [`dragDataType`]: {
          ...axisPanelAtt[`dragDataType`],
          [result.draggableId.split("#")[1]]: true,
          attribute: result.draggableId.split("#")[0],
          data_source: checkAttributeSource(
            attributes,
            result.draggableId.split("#")[0]
          ),
        },
        [`edit_fields`]: axisPanelAtt.edit_fields && {
          ...axisPanelAtt.edit_fields,
          boolValue: false,
        },
      })
    );
  };

  const checkCardValidation = () => {
    let result = false;

    if (
      widgetGraphConfig?.card_settings[
        widgetGraphConfig?.card_settings.length - 1
      ]?.x_axis ||
      widgetGraphConfig?.card_settings[
        widgetGraphConfig?.card_settings.length - 1
      ]?.y_series
    ) {
      result = true;
    } else result = false;

    return result;
  };

  const resetWidgetMaker = (event) => {
    dispatch(
      setradioChecked({
        global_dashboard: { data: {} },
        dashboard_section: { data: {} },
        dashboard_widget: { data: {} },
        template_global: { data: {} },
        template_section: { data: {} },
        template_widget: { data: {} },
        graph_page: { data: {} },
        orm_dashboard: { data: {} },
        widgetMaker: { data: {} },
        y_series_1: { data: {} },
        y_series_2: { data: {} },
        y_series_3: { data: {} },
        y_series_4: { data: {} },
        y_series_5: { data: {} },
        kpi_card_1: { data: {} },
        kpi_card_2: { data: {} },
        kpi_card_3: { data: {} },
        kpi_card_4: { data: {} },
        kpi_card_5: { data: {} },
        kpi_card_6: { data: {} },
        kpi_card_7: { data: {} },
        kpi_card_8: { data: {} },
        kpi_card_9: { data: {} },
        kpi_card_10: { data: {} },
        kpi_card_11: { data: {} },
        kpi_card_12: { data: {} },
        kpi_card_13: { data: {} },
        kpi_card_14: { data: {} },
        kpi_card_15: { data: {} },
        command_center_global: { data: {} },
        command_center_section: { data: {} },
        command_center_widget: { data: {} },
        deep_dive_global: { data: {} },
      })
    );
    dispatch(
      setradioArray({
        global_dashboard: { data: [] },
        dashboard_section: { data: [] },
        dashboard_widget: { data: [] },
        template_global: { data: [] },
        template_section: { data: [] },
        template_widget: { data: [] },
        graph_page: { data: [] },
        orm_dashboard: { data: [] },
        widgetMaker: { data: [] },
        y_series_1: { data: [] },
        y_series_2: { data: [] },
        y_series_3: { data: [] },
        y_series_4: { data: [] },
        y_series_5: { data: [] },
        kpi_card_1: { data: [] },
        kpi_card_2: { data: [] },
        kpi_card_3: { data: [] },
        kpi_card_4: { data: [] },
        kpi_card_5: { data: [] },
        kpi_card_6: { data: [] },
        kpi_card_7: { data: [] },
        kpi_card_8: { data: [] },
        kpi_card_9: { data: [] },
        kpi_card_10: { data: [] },
        kpi_card_11: { data: [] },
        kpi_card_12: { data: [] },
        kpi_card_13: { data: [] },
        kpi_card_14: { data: [] },
        kpi_card_15: { data: [] },
        command_center_global: { data: [] },
        command_center_section: { data: [] },
        command_center_widget: { data: [] },
        deep_dive_global: { data: [] },
      })
    );
    dispatch(
      setY_attribute({
        x_axis: null,
        y_axis: {
          y_series_1: {
            attribute: null,
            aggregation: null,
          },
        },
        y_axis_settings: [],
        breakdown_by: [],
        filter_dropdown: [],
        filter_by: [],
        fields: [],
        chart_type: "line",
        duration: null,
        brands: null,
        filters: [],
        show_marker: true,
        card_position: "Top",
        card_limit: 5,
        card_settings: [
          {
            card_id: uuid(),
            card_name: 1,
            card_value: null,
            x_axis: null,
            y_series: null,
            response: [],
          },
        ],
        rich_fields_content: null,
        chart_settings: {
          global_data_label: false,
          show_details_on_card: false,
          show_3d: false,
          settings_3d: null,
          show_label_names: true,
          show_horizontal_view: false,
          is_stacked: true,
          data_count_card: true,
          duration_comparison: false, // This is used for only KPI
          show_previous_duration_comparison: false, // This is used for charts
          show_previous_duration_data: false, // This is used for charts
          show_as_median: false, // this is used for scatter chart
          card_percent: true,
          chart_percent: false,
          gradient_color: false,
          group_line_agg: null,
          benchmark_line: false,
          benchmark_static_value: null,
          duplicate_for_brands: false,
          split_cards: true,
          wordcloud_color: "0",
          top_posts_in_cards: false,
          show_header: true,
          show_peak: true,
          show_valley: true,
          chart_styles: null,
          cluster_chart_type: null,
          cluster_style: null,
          total_count_flag: false,
        },
        chart_property: {
          chart_name: widgetGraphConfig?.chart_property?.chart_name,
          show_legend: widgetGraphConfig?.chart_property?.show_legend,
          legend_position: "bottom",
          y_axis_mode: 2,
          no_of_top_posts: 1,
        },
        widget_description: widgetGraphConfig?.widget_description,
        dragDataType: {
          varchar: false,
          int: false,
          datetime: false,
          json: false,
        },
        edit_fields: {
          boolValue: false,
          series: "",
          data: "",
        },
        order_by: null,
        custom_attribute: {
          name: null,
          description: null,
          formula: null,
          custom_column: [
            {
              parameters: {
                attribute: null,
                display_name: null,
                data_type: null,
                selected: true,
              },
              operator: { value: null, selected: false },
              pair: {
                parameters: {
                  attribute: null,
                  display_name: null,
                  data_type: null,
                  selected: false,
                },
                numeric: { value: null, selected: false },
              },
              combined_operator: {
                value: null,
                selected: false,
              },
            },
          ],
        },
        widgetResetState: true,
        tags: widgetGraphConfig?.tags,
        filter_by_data: [],
        filter_by_dropdown: [],
        filter_by_dropdown_data: [],

        postcard_pills_filter: null,
        multilevel_breakdown: null,
      })
    );
    dispatch({ type: "SET_WIDGET_MAKER_CHART", payload: null });
    dispatch(setWidgetMakerErrorCode(null));
    // Remove focus from the button
    event?.currentTarget?.blur();
    setOpenExitModal(false);

    let payloadObj = {
      authParams: authParams,
      chart_type: "line",
      chartAttributesFieldConfig: chartAttributesFieldConfig,
    };
    authParams && dispatch(getChartAttributesFieldConfigAPI(payloadObj));
    dispatch(setChartAttributesFieldConfig(null));
  };

  const handleMouseOverReset = () => {
    setResetIcon(reset_red);
    setResetDarkIcon(reset_red);
  };

  const handleMouseOutReset = () => {
    setResetIcon(reset_dark);
    setResetDarkIcon(reset_white);
  };

  useEffect(() => {
    if (panes?.[index]?.is_widget_maker_open_obj?.open_flag) {
      let twoMonthsDuration = getCustomizedDate(6, "Days");
      let defaultDuration = {
        from:
          moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
          " " +
          twoMonthsDuration?.time?.startTime,
        to:
          moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
          " " +
          twoMonthsDuration?.time?.endTime,
      };

      // console.log("Hey panes[index]", panes[index]);
      let axisData = panes?.[index]?.is_widget_maker_open_obj?.widget_metadata;

      let kpi_card_radioArray = {};
      let kpi_card_radioChecked = {};
      axisData?.chart?.chart_settings?.cards_settings?.length > 0 &&
        axisData?.chart?.chart_settings?.cards_settings?.forEach((el, i) => {
          kpi_card_radioArray = {
            ...kpi_card_radioArray,
            [`kpi_card_${i + 1}`]: { data: [] },
          };
          kpi_card_radioChecked = {
            ...kpi_card_radioChecked,
            [`kpi_card_${i + 1}`]: { data: [] },
          };
        });

      let updateRadioArray = { ...radioArray, ...kpi_card_radioArray };
      let updateRadioChecked = { ...radioChecked, ...kpi_card_radioChecked };
      dispatch(setradioArray(updateRadioArray));
      dispatch(setradioChecked(updateRadioChecked));

      let WM_attributes = {};
      const schemaData =
        configuration_data?.[
          axisData?.data_source === "tickets" ||
          axisData?.data_source === "page"
            ? "mentions"
            : axisData?.data_source
            ? axisData?.data_source
            : "mentions"
        ]?.data?.result?.schema;

      if (schemaData && typeof schemaData === "object") {
        Object.entries(schemaData).forEach((el) => {
          WM_attributes = {
            [axisData?.data_source === "tickets"
              ? "mentions"
              : axisData?.data_source
              ? axisData?.data_source
              : "mentions"]: {
              ...WM_attributes[
                axisData?.data_source === "tickets"
                  ? "mentions"
                  : axisData?.data_source
                  ? axisData?.data_source
                  : "mentions"
              ],
              [el[0]]:
                el[1]?.members && typeof el[1].members === "object"
                  ? Object.entries(el[1].members)
                  : [],
            },
          };
        });
      }

      dispatch({
        type: "SET_WM_ATTRIBUTES",
        payload:
          WM_attributes &&
          typeof WM_attributes === "object" &&
          WM_attributes[
            axisData?.data_source === "tickets"
              ? "mentions"
              : axisData?.data_source
              ? axisData?.data_source
              : "mentions"
          ]
            ? Object.entries(
                WM_attributes[
                  axisData?.data_source === "tickets"
                    ? "mentions"
                    : axisData?.data_source
                    ? axisData?.data_source
                    : "mentions"
                ]
              )
            : [],
      });

      let filterPanelData = getFilterPanelData(
        configuration_data?.[
          axisData?.data_source === "tickets" ||
          axisData?.data_source === "page"
            ? "mentions"
            : axisData?.data_source
            ? axisData?.data_source
            : "mentions"
        ]?.data,
        false,
        false,
        axisData?.data_source
      );
      dispatch(setFilterPanelData(filterPanelData));

      let selectedBrands;
      let comp_brands;

      // // console.log("Start axisData", { ...axisData });
      // if (axisData?.brand_ids?.length) {
      //   axisData.brand_ids = axisData?.brand_ids?.map((d) => {
      //     let findObj = brands?.find((b) => b?.brand_id === d?.brand_id);
      //     if (findObj?.brand_id === d?.brand_id) {
      //       d = findObj;
      //     }
      //     return d;
      //   });
      // }
      // // console.log("End axisData", { ...axisData });

      // if (panes?.[index]?.brands) {
      //   if (panes?.[index]?.brands?.columns?.[0]) {
      //     axisData.brand_groups = panes?.[index]?.brands?.columns;
      //   } else {
      //     axisData.brand_ids = panes?.[index]?.brands;
      //   }
      // }

      // if (
      //   axisData?.brand_groups.length > 0 &&
      //           axisData?.brand_ids?.length > 0
      //       ) {
      //           combinedBrands = getBrands(
      //               brandlogicalgroup,
      //               axisData?.brand_ids,
      //               brands,
      //               axisData?.brand_groups
      //           );
      //       } else if (
      //           axisData?.comp_brand_list?.length > 0 &&
      //           axisData?.brand_ids?.length > 0
      //       ) {
      //           comp_brands = getSelectedCompBrand(
      //               competitorBrands,
      //               axisData?.brand_ids,
      //               axisData?.comp_brand_list
      //           );
      //       }

      // new code for calculating brands properly
      if (
        panes?.[index]?.brands &&
        !axisData?.comp_brand_list?.length &&
        !axisData?.brand_ids?.length &&
        !axisData?.brand_groups?.length
      ) {
        let formattedBrands = panes?.[index]?.brands;
        if (formattedBrands?.columns && formattedBrands?.columns?.length) {
          selectedBrands = formattedBrands?.columns;
        } else {
          selectedBrands = formattedBrands;
        }
      }
      if (
        axisData?.brand_groups?.length > 0 ||
        axisData?.brand_ids?.length > 0
      ) {
        let formattedBrands = getBrands(
          brandlogicalgroup,
          axisData?.brand_ids,
          brands,
          axisData?.brand_groups
        );
        if (formattedBrands?.columns && formattedBrands?.columns?.length) {
          selectedBrands = formattedBrands?.columns;
        }
      } else if (
        axisData?.comp_brand_list?.length > 0 &&
        axisData?.brand_ids?.length > 0
      ) {
        comp_brands = getSelectedCompBrand(
          competitorBrands,
          axisData?.brand_ids,
          axisData?.comp_brand_list
        );
      }
      let ySeries = {};
      axisData?.y_series?.forEach((e, i) => {
        ySeries = {
          ...ySeries,
          [`y_series_${i + 1}`]: {
            ...e,
            data_source: e?.data_source
              ? e?.data_source
              : axisData?.data_source
              ? axisData?.data_source
              : "mentions",
          },
        };
      });

      let modifieldCardSettings =
        axisData?.chart?.chart_settings?.cards_settings?.map((d, i) => {
          return { ...d, card_id: uuid(), card_name: i + 1 };
        });
      if (axisData?.x_axis?.attribute) {
        axisData.x_axis.data_source = axisData?.x_axis?.data_source
          ? axisData?.x_axis?.data_source
          : axisData?.data_source
          ? axisData?.data_source
          : "mentions";
      }
      if (axisData?.order_by?.attribute) {
        axisData.order_by.data_source = axisData?.order_by?.data_source
          ? axisData?.order_by?.data_source
          : axisData?.data_source
          ? axisData?.data_source
          : "mentions";
      }

      // console.log("axisData", axisData);
      if (axisData?.filters?.length) {
        axisData?.filters?.map((d) => {
          if (d?.attribute) {
            d.attribute = d?.attribute;
          }
          return d;
        });
      }
      let updatedBreakdownBy = Array.isArray(axisData?.y_axes)
        ? axisData?.y_axes?.map((breakDownBy) => {
            return {
              ...breakDownBy,
              data_source: breakDownBy?.data_source
                ? breakDownBy?.data_source
                : axisData?.data_source
                ? axisData?.data_source
                : "mentions",
            };
          })
        : [];

      let payloadChartSettings = axisData?.payload?.chart?.chart_settings
        ? axisData?.payload?.chart?.chart_settings
        : axisData?.chart?.chart_settings;
      let widgetDuration =
        axisData?.start_date && axisData?.end_date
          ? { from: axisData?.start_date, to: axisData?.end_date }
          : null;

      if (axisData?.relative_duration?.is_relative && widgetDuration) {
        widgetDuration.relative = {
          type: "short",
          value: axisData?.relative_duration?.relative_type,
        };
        widgetDuration.save_as_relative =
          axisData?.relative_duration?.is_relative;
      }
      dispatch(
        setY_attribute({
          ...axisPanelAtt,
          edit: true,
          x_axis: axisData?.x_axis,
          y_axis: { ...ySeries },
          y_axis_settings: axisData?.chart?.chart_settings?.y_axes_settings
            ? [...axisData?.chart?.chart_settings?.y_axes_settings]
            : [],
          breakdown_by: updatedBreakdownBy ? [...updatedBreakdownBy] : [],
          filter_dropdown:
            axisData?.filter_dropdown?.length > 0
              ? [...axisData?.filter_dropdown]
              : [],
          filter_by_dropdown:
            axisData?.filter_by_dropdown?.length > 0
              ? [...axisData?.filter_by_dropdown]
              : [],
          filter_by_dropdown_data:
            axisData?.filter_by_dropdown_data?.length > 0
              ? [...axisData?.filter_by_dropdown_data]
              : [],
          chart_type: axisData?.chart?.chart_type,
          duration: widgetDuration
            ? widgetDuration
            : panes?.[index]?.duration
            ? panes?.[index]?.duration
            : defaultDuration,
          brands:
            selectedBrands &&
            !axisData?.comp_brand_list?.length &&
            !axisData?.brand_ids?.length &&
            !axisData?.brand_groups?.length
              ? selectedBrands
              : axisData?.comp_brand_list?.length > 0
              ? comp_brands
              : selectedBrands &&
                (axisData?.brand_groups?.length > 0 ||
                  axisData?.brand_ids?.length > 0)
              ? selectedBrands
              : axisData?.brand_groups?.length > 0
              ? axisData?.brand_groups
              : axisData?.brand_ids?.length
              ? axisData?.brand_ids
              : brandlogicalgroup?.length > 0
              ? brandlogicalgroup?.[0]
              : brands,
          filters: axisData?.filters,
          // show_marker: true,
          show_marker: payloadChartSettings?.show_marker,
          card_position: payloadChartSettings?.card_position,
          card_limit: payloadChartSettings?.card_limit,
          card_settings:
            modifieldCardSettings?.length > 0
              ? modifieldCardSettings
              : [
                  {
                    card_id: "1",
                    card_name: 1,
                    card_value: null,
                    x_axis: null,
                    y_series: null,
                    response: [],
                  },
                ],
          rich_fields_content: axisData?.chart?.rich_fields_content,
          chart_settings: {
            grid_config: payloadChartSettings?.grid_config,
            show_3d: payloadChartSettings?.show_3d,
            settings_3d: payloadChartSettings?.settings_3d,
            duration_comparison: payloadChartSettings?.duration_comparison,
            show_previous_duration_comparison:
              payloadChartSettings?.show_previous_duration_comparison,
            show_previous_duration_data:
              payloadChartSettings?.show_previous_duration_data,
            global_data_label: payloadChartSettings?.show_data_labels,
            show_details_on_card: payloadChartSettings?.show_details_on_card,
            show_as_median: payloadChartSettings?.show_as_median, // this is used for scatter chart
            duplicate_for_brands: payloadChartSettings?.duplicate_for_brands
              ? payloadChartSettings?.duplicate_for_brands
              : false,
            is_stacked: payloadChartSettings?.is_stacked,
            data_count_card: payloadChartSettings?.show_count_cards,
            card_percent: payloadChartSettings?.card_percent,
            chart_percent: payloadChartSettings?.chart_percent,
            gradient_color: payloadChartSettings?.gradient_color,
            benchmark_line: payloadChartSettings?.benchmark_line,
            group_line_agg: payloadChartSettings?.group_line_agg,
            benchmark_static_value: payloadChartSettings?.benchmark_line
              ? payloadChartSettings?.benchmark_static_value || null
              : null,
            total_row: payloadChartSettings?.total_row,
            split_cards: payloadChartSettings?.split_cards,
            wordcloud_color: payloadChartSettings?.wordcloud_color
              ? payloadChartSettings?.wordcloud_color
              : "0",
            top_posts_in_cards: payloadChartSettings?.top_posts_in_cards,
            show_header:
              typeof payloadChartSettings?.show_header === "boolean"
                ? payloadChartSettings?.show_header
                : true,
            y_axes_settings: payloadChartSettings?.y_axes_settings?.map(
              (el) => {
                if (!el?.key) el.key = uuid();
                return el;
              }
            ),
            show_peak:
              supportedBenchmarkTraceChartTypes?.includes(
                axisData?.chart?.chart_type
              ) &&
              payloadChartSettings?.benchmark_line &&
              payloadChartSettings?.show_peak === undefined
                ? false
                : payloadChartSettings?.show_peak
                ? payloadChartSettings?.show_peak
                : payloadChartSettings?.show_peak === false
                ? false
                : payloadChartSettings?.show_peak === undefined
                ? true
                : true,
            show_valley:
              supportedBenchmarkTraceChartTypes?.includes(
                axisData?.chart?.chart_type
              ) &&
              payloadChartSettings?.benchmark_line &&
              payloadChartSettings?.show_valley === undefined
                ? false
                : payloadChartSettings?.show_valley
                ? payloadChartSettings?.show_valley
                : payloadChartSettings?.show_valley === false
                ? false
                : payloadChartSettings?.show_valley === undefined
                ? true
                : true,
            chart_styles: payloadChartSettings?.chart_styles || null,
            cluster_chart_type:
              axisData?.chart?.chart_settings?.cluster_chart_type || null,
            cluster_style:
              axisData?.chart?.chart_settings?.cluster_style || null,
            total_count_flag:
              axisData?.chart?.chart_settings?.total_count_flag || false,
          },
          widget_description: axisData?.widget_description,
          chart_property: {
            chart_name: axisData?.widget_name,
            legend_position:
              payloadChartSettings?.chart_property?.legend_position,
            y_axis_mode: payloadChartSettings?.chart_property?.y_axis_mode,
            no_of_top_posts:
              payloadChartSettings?.chart_property?.no_of_top_posts,
            show_legend: payloadChartSettings?.chart_property?.show_legend
              ? payloadChartSettings?.chart_property?.show_legend
              : payloadChartSettings?.chart_property?.show_legend === false
              ? false
              : true,
          },
          order_by: axisData?.order_by,
          filter_by_data: axisData?.filter_by_data,
          postcard_pills_filter: axisData?.postcard_pills_filter,
          filter_by:
            ["wordcloud", "post-card", "survey-card", "review-card"]?.includes(
              axisData?.chart?.chart_type
            ) && axisData?.y_axes
              ? [...axisData?.y_axes]
              : [],
          tags: axisData?.tags ? axisData?.tags : [],
          data_source: axisData?.data_source,
          multilevel_breakdown: axisData?.multilevel_breakdown || null,
        })
      );

      // Update Panes state
      if (!panes?.[index]?.edited_widgetGraphConfig) {
        let basicObj = {
          ...widgetGraphConfig,
          edit: true,
          x_axis: axisData?.x_axis,
          y_axis: { ...ySeries },
          y_axis_settings: axisData?.chart?.chart_settings?.y_axes_settings
            ? [...axisData?.chart?.chart_settings?.y_axes_settings]
            : [],
          breakdown_by: axisData?.y_axes ? [...axisData?.y_axes] : [],
          filter_dropdown:
            axisData?.filter_dropdown?.length > 0
              ? [...axisData?.filter_dropdown]
              : [],
          filter_by_dropdown:
            axisData?.filter_by_dropdown?.length > 0
              ? [...axisData?.filter_by_dropdown]
              : [],
          filter_by_dropdown_data:
            axisData?.filter_by_dropdown_data?.length > 0
              ? [...axisData?.filter_by_dropdown_data]
              : [],
          chart_type: axisData?.chart?.chart_type,
          duration:
            panes?.[index]?.duration &&
            !axisData?.start_date &&
            !axisData?.end_date
              ? panes?.[index]?.duration
              : axisData?.start_date
              ? { from: axisData?.start_date, to: axisData?.end_date }
              : defaultDuration,
          brands:
            panes?.[index]?.brands &&
            !axisData?.comp_brand_list?.length &&
            !axisData?.brand_ids?.length &&
            !axisData?.brand_groups?.length
              ? panes?.[index]?.brands
              : axisData?.comp_brand_list?.length > 0
              ? comp_brands
              : axisData?.brand_groups?.length > 0
              ? axisData?.brand_groups
              : axisData?.brand_ids?.length
              ? axisData?.brand_ids
              : brandlogicalgroup?.length > 0
              ? brandlogicalgroup?.[0]
              : brands,
          filters: axisData?.filters,
          // show_marker: true,
          show_marker: payloadChartSettings?.show_marker,
          card_position: payloadChartSettings?.card_position,
          card_limit: payloadChartSettings?.card_limit,
          card_settings:
            modifieldCardSettings?.length > 0
              ? modifieldCardSettings
              : [
                  {
                    card_id: "1",
                    card_name: 1,
                    card_value: null,
                    x_axis: null,
                    y_series: null,
                    response: [],
                  },
                ],
          rich_fields_content: axisData?.chart?.rich_fields_content,
          chart_settings: {
            grid_config: payloadChartSettings?.grid_config,
            show_3d: payloadChartSettings?.show_3d,
            settings_3d: payloadChartSettings?.settings_3d,
            duration_comparison: payloadChartSettings?.duration_comparison,
            show_previous_duration_comparison:
              payloadChartSettings?.show_previous_duration_comparison,
            show_previous_duration_data:
              payloadChartSettings?.show_previous_duration_data,
            global_data_label: payloadChartSettings?.show_data_labels,
            show_details_on_card: payloadChartSettings?.show_details_on_card,
            show_as_median: payloadChartSettings?.show_as_median, // this is used for scatter chart
            duplicate_for_brands: payloadChartSettings?.duplicate_for_brands
              ? payloadChartSettings?.duplicate_for_brands
              : false,
            is_stacked: payloadChartSettings?.is_stacked,
            data_count_card: payloadChartSettings?.show_count_cards,
            card_percent: payloadChartSettings?.card_percent,
            chart_percent: payloadChartSettings?.chart_percent,
            gradient_color: payloadChartSettings?.gradient_color,
            benchmark_line: payloadChartSettings?.benchmark_line,
            group_line_agg: payloadChartSettings?.group_line_agg,
            benchmark_static_value: payloadChartSettings?.benchmark_line
              ? payloadChartSettings?.benchmark_static_value || null
              : null,
            total_row: payloadChartSettings?.total_row,
            split_cards: payloadChartSettings?.split_cards,
            wordcloud_color: payloadChartSettings?.wordcloud_color
              ? payloadChartSettings?.wordcloud_color
              : "0",
            top_posts_in_cards: payloadChartSettings?.top_posts_in_cards,
            show_header:
              typeof payloadChartSettings?.show_header === "boolean"
                ? payloadChartSettings?.show_header
                : true,
            y_axes_settings: payloadChartSettings?.y_axes_settings?.map(
              (el) => {
                if (!el?.key) el.key = uuid();
                return el;
              }
            ),
            show_peak:
              supportedBenchmarkTraceChartTypes?.includes(
                axisData?.chart?.chart_type
              ) &&
              payloadChartSettings?.benchmark_line &&
              payloadChartSettings?.show_peak === undefined
                ? false
                : payloadChartSettings?.show_peak
                ? payloadChartSettings?.show_peak
                : payloadChartSettings?.show_peak === false
                ? false
                : payloadChartSettings?.show_peak === undefined
                ? true
                : true,
            show_valley:
              supportedBenchmarkTraceChartTypes?.includes(
                axisData?.chart?.chart_type
              ) &&
              payloadChartSettings?.benchmark_line &&
              payloadChartSettings?.show_valley === undefined
                ? false
                : payloadChartSettings?.show_valley
                ? payloadChartSettings?.show_valley
                : payloadChartSettings?.show_valley === false
                ? false
                : payloadChartSettings?.show_valley === undefined
                ? true
                : true,
            chart_styles: payloadChartSettings?.chart_styles || null,
            cluster_chart_type:
              axisData?.chart?.chart_settings?.cluster_chart_type || null,
            cluster_style:
              axisData?.chart?.chart_settings?.cluster_style || null,
            total_count_flag:
              axisData?.chart?.chart_settings?.total_count_flag || false,
          },
          widget_description: axisData?.widget_description,
          chart_property: {
            chart_name: axisData?.widget_name,
            legend_position:
              payloadChartSettings?.chart_property?.legend_position,
            y_axis_mode: payloadChartSettings?.chart_property?.y_axis_mode,
            no_of_top_posts:
              payloadChartSettings?.chart_property?.no_of_top_posts,
            show_legend: payloadChartSettings?.chart_property?.show_legend
              ? payloadChartSettings?.chart_property?.show_legend
              : payloadChartSettings?.chart_property?.show_legend === false
              ? false
              : true,
          },
          order_by: axisData?.order_by,
          filter_by_data: axisData?.filter_by_data,
          postcard_pills_filter: axisData?.postcard_pills_filter,
          filter_by:
            ["wordcloud", "post-card", "survey-card", "review-card"]?.includes(
              axisData?.chart?.chart_type
            ) && axisData?.y_axes
              ? [...axisData?.y_axes]
              : [],
          filter_by_dropdown: axisData?.filter_by_dropdown
            ? [...axisData?.filter_by_dropdown]
            : [],
          filter_by_dropdown_data: axisData?.filter_by_dropdown_data
            ? [...axisData?.filter_by_dropdown_data]
            : [],
          tags: axisData?.tags ? axisData?.tags : [],
          data_source: axisData?.data_source,
          multilevel_breakdown: axisData?.multilevel_breakdown || null,
        };
        // console.log("EDIT basicObj", basicObj);
        dispatch(setEditedWidgetGraphConfig(basicObj, panes, index));
      }
    }
  }, [panes?.[index]?.is_widget_maker_open_obj?.open_flag]);

  useEffect(() => {
    // console.log("USE EFFECT widgetGraphConfig", widgetGraphConfig?.chart_type);
    let y_series_array = [];
    y_series_array = Object.keys(widgetGraphConfig?.y_axis).map(
      (key) => widgetGraphConfig?.y_axis[key]
    );
    const y_series_array1 = y_series_array;
    let y_series_flag = getWidgetMakerFlag(widgetGraphConfig, wm_api_flag);

    y_series_array = y_series_array?.filter((el) => el?.attribute);
    if (
      widgetGraphConfig?.chart_type === "bubble" ||
      widgetGraphConfig?.chart_type === "heatmap" ||
      widgetGraphConfig?.chart_type === "sunburst" ||
      widgetGraphConfig?.chart_type === "sankey" ||
      widgetGraphConfig?.chart_type === "wordcloud" ||
      widgetGraphConfig?.chart_type === "donut" ||
      widgetGraphConfig?.chart_type === "pie"
    ) {
      y_series_array =
        y_series_array?.length > 1 ? [y_series_array[0]] : y_series_array;
    }

    const d = new Date();
    let utcOffset = d.getTimezoneOffset();

    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };

    let card_settings_data = [];
    widgetGraphConfig?.card_settings?.map((d) => {
      if (
        (d?.x_axis?.attribute || (!d?.x_axis?.attribute && d?.y_series)) &&
        d?.y_series?.attribute
      ) {
        card_settings_data = [
          ...card_settings_data,
          {
            x_axis:
              d?.x_axis == null
                ? null
                : Object.keys(d?.x_axis).length == 0
                ? null
                : d?.x_axis,
            y_series: d?.y_series,
          },
        ];
      }
    });

    let pivot_index = axisPanelAtt?.breakdown_by?.findIndex((d) => d?.is_pivot);

    // console.log("chartLoader", chartLoader);
    if (!y_series_flag?.flag && !chartLoader && !graphLoader) {
      if (wm_api_flag) {
        dispatch(setWidgetMakerApiCallFlag(false));
      }
      dispatch(setOptionHighChart({}));
      let card_settings_index = widgetGraphConfig?.card_settings?.length - 1;
      if (
        widgetGraphConfig?.card_settings &&
        Array.isArray(widgetGraphConfig?.card_settings)
      ) {
        for (
          let i = widgetGraphConfig?.card_settings?.length - 1;
          i >= 0;
          i--
        ) {
          let card = widgetGraphConfig?.card_settings?.[i];
          if (card?.x_axis?.atrribute || card?.y_series) {
            card_settings_index = i;
            break;
          }
        }
      }
      let graphObject = {
        // data_source: data_source ? data_source : updatedDataSource,
        data_source: widgetGraphConfig?.y_axis?.y_series_1?.data_source
          ? widgetGraphConfig?.y_axis?.y_series_1?.data_source
          : widgetGraphConfig?.order_by?.data_source
          ? widgetGraphConfig?.order_by?.data_source
          : widgetGraphConfig?.data_source
          ? widgetGraphConfig?.data_source
          : "mentions",
        brand_list: [
          {
            brand_id: 600,
          },
        ],
        start_date: widgetGraphConfig?.duration?.from
          ? widgetGraphConfig?.duration?.from
          : defaultDuration?.from,
        end_date: widgetGraphConfig?.duration?.to
          ? widgetGraphConfig?.duration?.to
          : defaultDuration?.to,
        brands:
          widgetGraphConfig?.brands?.length > 0
            ? widgetGraphConfig?.brands
            : widgetGraphConfig?.brands?.columns?.[0]
            ? widgetGraphConfig?.brands?.columns
            : brandlogicalgroup?.length > 0
            ? brandlogicalgroup
            : brands,
        isBrandModified:
          widgetGraphConfig?.brands?.length > 0
            ? true
            : widgetGraphConfig?.brands?.columns?.[0]
            ? true
            : false,

        filters:
          widgetGraphConfig?.filters?.length > 0
            ? widgetGraphConfig?.filters
            : [],
        x_axis: widgetGraphConfig?.x_axis && widgetGraphConfig?.x_axis,
        // Break down data
        y_axes:
          widgetGraphConfig?.chart_type === "news-card"
            ? null
            : widgetGraphConfig?.breakdown_by?.length > 0
            ? widgetGraphConfig?.breakdown_by
            : widgetGraphConfig?.filter_by
            ? widgetGraphConfig?.filter_by
            : null,
        // y axis data
        y_series:
          widgetGraphConfig?.chart_type === "news-card"
            ? []
            : y_series_array && y_series_array,
        // filter dropdown
        filter_dropdown:
          widgetGraphConfig?.filter_dropdown?.length > 0
            ? widgetGraphConfig?.filter_dropdown
            : [],
        widget_name: "abc",
        chart: {
          chart_type:
            widgetGraphConfig?.chart_type === "donut"
              ? "pie"
              : widgetGraphConfig?.chart_type,
          rich_fields_content: widgetGraphConfig?.rich_fields_content,
          chart_settings: {
            grid_config: widgetMakerGraphData?.chart_settings?.grid_config,
            duration_comparison:
              widgetGraphConfig?.chart_settings?.duration_comparison,
            show_previous_duration_comparison:
              widgetGraphConfig?.chart_settings
                ?.show_previous_duration_comparison,
            show_previous_duration_data:
              widgetGraphConfig?.chart_settings?.show_previous_duration_data,
            show_data_labels:
              widgetGraphConfig?.chart_settings?.global_data_label,
            show_details_on_card:
              widgetGraphConfig?.chart_settings?.show_details_on_card,
            show_as_median: widgetGraphConfig?.chart_settings?.show_as_median, // this is used for scatter chart
            duplicate_for_brands: widgetGraphConfig?.chart_settings
              ?.duplicate_for_brands
              ? widgetGraphConfig?.chart_settings?.duplicate_for_brands
              : false,
            is_stacked: widgetGraphConfig?.chart_settings?.is_stacked,
            show_count_cards:
              widgetGraphConfig?.chart_settings?.data_count_card,
            card_percent: widgetGraphConfig?.chart_settings?.card_percent,
            chart_percent: widgetGraphConfig?.chart_settings?.chart_percent,
            gradient_color: widgetGraphConfig?.chart_settings?.gradient_color,
            total_row: widgetGraphConfig?.chart_settings?.total_row,
            split_cards: widgetGraphConfig?.chart_settings?.split_cards,
            wordcloud_color: widgetGraphConfig?.chart_settings?.wordcloud_color,
            top_posts_in_cards:
              widgetGraphConfig?.chart_settings?.top_posts_in_cards,
            show_header:
              typeof widgetGraphConfig?.chart_settings?.show_header ===
              "boolean"
                ? widgetGraphConfig?.chart_settings?.show_header
                : true,
            chart_property: {
              chart_name: widgetGraphConfig?.chart_property?.chart_name,
              legend_position: "top",
              y_axis_mode: widgetGraphConfig?.chart_property?.y_axis_mode,
              no_of_top_posts:
                widgetGraphConfig?.chart_property?.no_of_top_posts,
              show_legend: widgetGraphConfig?.chart_property?.show_legend,
            },
            y_axes_settings: widgetGraphConfig?.y_axis_settings,
            cards_settings:
              widgetGraphConfig?.chart_type === "news-card"
                ? null
                : card_settings_data
                ? card_settings_data
                : null,
            show_peak: widgetGraphConfig?.chart_settings?.show_peak,
            show_valley: widgetGraphConfig?.chart_settings?.show_valley,
            chart_styles:
              widgetGraphConfig?.chart_settings?.chart_styles || null,
            cluster_chart_type:
              widgetGraphConfig?.chart_settings?.cluster_chart_type || null,
            cluster_style:
              widgetGraphConfig?.chart_settings?.cluster_style || null,
            total_count_flag:
              widgetGraphConfig?.chart_settings?.total_count_flag || false,
          },
        },
        card_settings_index: card_settings_index,
        widgetGraphConfig: widgetGraphConfig,
        order_by:
          widgetGraphConfig?.chart_type === "post-card" ||
          widgetGraphConfig?.chart_type === "survey-card" ||
          widgetGraphConfig?.chart_type === "review-card" ||
          widgetGraphConfig?.chart_type === "author-card" ||
          widgetGraphConfig?.chart_type === "prolific-user" ||
          widgetGraphConfig?.chart_type === "news-card"
            ? widgetGraphConfig?.order_by
            : null,
        utcOffset: utcOffset,
        edit: widgetGraphConfig?.edit,
        filter_by_data:
          widgetGraphConfig?.chart_type === "news-card"
            ? null
            : widgetGraphConfig?.filter_by_data,
        filter_by:
          widgetGraphConfig?.chart_type === "news-card"
            ? null
            : widgetGraphConfig?.postcard_pills_filter,
        filter_by_dropdown: widgetGraphConfig?.filter_by_dropdown
          ? widgetGraphConfig?.filter_by_dropdown
          : [],
        filter_by_dropdown_data: widgetGraphConfig?.filter_by_dropdown_data
          ? widgetGraphConfig?.filter_by_dropdown_data
          : [],
        tags: widgetGraphConfig?.tags ? widgetGraphConfig?.tags : [],
        multilevel_breakdown: widgetGraphConfig?.multilevel_breakdown || null,
        deep_dive_on: widgetGraphConfig?.deep_dive_on,
      };
      // console.log("final graphObject", graphObject);

      // Check and update chart settings based on benchmark line case
      let updatedGraphObject = updateChartSettingsInGraphObjectBasedOnSelection(
        {
          widgetGraphConfig: widgetGraphConfig,
          brandlogicalgroup: brandlogicalgroup,
          brands: brands,
          graphObject: graphObject,
        }
      );
      if (updatedGraphObject) {
        graphObject = updatedGraphObject;
      }
      // Here maintain one flag to indicate this is from widget maker
      graphObject.wm_api_flag = true;
      if (
        widgetGraphConfig?.chart_type === "prolific-user" &&
        widgetGraphConfig?.order_by
      ) {
        authParams &&
          dispatch(setWidgetMakerGraphData(authParams, graphObject));
      } else if (
        (["post-card"]?.includes(widgetGraphConfig?.chart_type) &&
          (widgetGraphConfig?.order_by?.attribute ||
            widgetGraphConfig?.order_by?.offset)) ||
        widgetGraphConfig?.filter_by?.attribute
      ) {
        authParams &&
          dispatch(setWidgetMakerGraphData(authParams, graphObject));
      } else if (
        ["news-card"]?.includes(widgetGraphConfig?.chart_type) &&
        (widgetGraphConfig?.order_by?.attribute ||
          widgetGraphConfig?.order_by?.offset)
      ) {
        authParams &&
          dispatch(setWidgetMakerGraphData(authParams, graphObject));
      } else if (
        (widgetGraphConfig?.chart_type === "review-card" ||
          widgetGraphConfig?.chart_type === "news-card" ||
          widgetGraphConfig?.chart_type === "author-card") &&
        widgetGraphConfig?.order_by?.attribute
      ) {
        authParams &&
          dispatch(setWidgetMakerGraphData(authParams, graphObject));
      } else if (widgetGraphConfig?.chart_type === "survey-card") {
        authParams &&
          dispatch(setWidgetMakerGraphData(authParams, graphObject));
      }

      if (
        (widgetGraphConfig?.chart_type === "network-graph" ||
          widgetGraphConfig?.chart_type === "network-graph-v2") &&
        widgetGraphConfig?.x_axis &&
        widgetGraphConfig?.breakdown_by.length > 0 &&
        (widgetGraphConfig?.breakdown_by.length > 0 &&
          widgetGraphConfig?.breakdown_by?.map((b) => b?.attribute)?.length) ===
          Object?.entries(widgetGraphConfig?.y_axis)?.map(
            (el) => el[1]?.attribute
          )?.length -
            1
      ) {
        graphObject.isNetworkChartV2 =
          graphObject?.chart?.chart_type === "network-graph-v2" ? true : false;
        authParams &&
          dispatch(setWidgetMakerGraphData(authParams, graphObject));
      } else if (
        (widgetGraphConfig?.chart_type === "scatter" ||
          widgetGraphConfig?.chart_type === "combination") &&
        widgetGraphConfig?.x_axis &&
        widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
        widgetGraphConfig?.y_axis?.y_series_2?.attribute
      ) {
        let index = Object.entries(widgetGraphConfig?.y_axis)?.findIndex(
          (el) => !el[1]?.attribute
        );
        authParams &&
          dispatch(setWidgetMakerGraphData(authParams, graphObject));
      } else if (
        (widgetGraphConfig?.chart_type === "bubble" ||
          widgetGraphConfig?.chart_type === "heatmap" ||
          widgetGraphConfig?.chart_type === "sunburst" ||
          widgetGraphConfig?.chart_type === "sankey") &&
        widgetGraphConfig?.x_axis &&
        widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
        widgetGraphConfig?.breakdown_by?.[0]?.attribute
      ) {
        authParams &&
          dispatch(setWidgetMakerGraphData(authParams, graphObject));
      } else if (
        widgetGraphConfig?.x_axis &&
        widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
        [
          "pie",
          "donut",
          "wordcloud",
          "line",
          "bar",
          "horizontal-bar",
          "lollipop",
          "area",
          "quadrant",
          "multilayer-map",
          "treemap",
        ]?.includes(widgetGraphConfig?.chart_type)
      ) {
        let index = Object.entries(widgetGraphConfig?.y_axis)?.findIndex(
          (el) => {
            return !el[1]?.attribute;
          }
        );
        authParams &&
          dispatch(setWidgetMakerGraphData(authParams, graphObject));
      } else if (
        widgetGraphConfig?.chart_type === "map" &&
        widgetGraphConfig?.y_axis?.y_series_1?.attribute
      ) {
        authParams &&
          dispatch(setWidgetMakerGraphData(authParams, graphObject));
      } else if (
        (widgetGraphConfig?.chart_type === "grid" ||
          widgetGraphConfig?.chart_type === "cluster-chart") &&
        widgetGraphConfig?.x_axis &&
        widgetGraphConfig?.y_axis?.y_series_1?.attribute
      ) {
        authParams &&
          dispatch(setWidgetMakerGraphData(authParams, graphObject));
      } else if (
        widgetGraphConfig?.chart_type === "rich-text" &&
        (widgetGraphConfig?.x_axis?.attribute ||
          (widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
            !widgetGraphConfig?.y_axis?.y_series_1?.hide_on_ui))
      ) {
        authParams &&
          dispatch(setWidgetMakerGraphData(authParams, graphObject));
      } else if (
        (widgetGraphConfig?.chart_type === "kpi" ||
          widgetGraphConfig?.chart_type === "progress-kpi") &&
        ((widgetGraphConfig?.x_axis &&
          widgetGraphConfig?.y_axis?.y_series_1?.attribute) ||
          widgetGraphConfig?.y_axis?.y_series_1?.attribute)
      ) {
        authParams &&
          dispatch(setWidgetMakerGraphData(authParams, graphObject));
      } else if (
        widgetGraphConfig?.chart_type === "pivot-grid" &&
        widgetGraphConfig?.x_axis &&
        widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
        widgetGraphConfig?.breakdown_by?.length > 0 &&
        pivot_index > -1
      ) {
        authParams &&
          dispatch(setWidgetMakerGraphData(authParams, graphObject));
      } else if (
        widgetGraphConfig?.x_axis &&
        widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
        widgetGraphConfig?.chart_settings?.group_line_agg &&
        widgetGraphConfig?.chart_settings?.benchmark_line != undefined &&
        supportedBenchmarkTraceChartTypes?.includes(
          widgetGraphConfig?.chart_type
        )
      ) {
        authParams &&
          dispatch(setWidgetMakerGraphData(authParams, graphObject));
      }
    } else {
      if (!wm_api_flag) {
        if (
          widgetGraphConfig?.chart_type === "combination" &&
          y_series_array1?.length > 2
        ) {
          getEmptyFieldNotification();
        } else if (widgetGraphConfig?.chart_type !== "combination") {
          getEmptyFieldNotification();
        }
      } else {
        dispatch(setWidgetMakerApiCallFlag(false));
      }
    }
  }, [
    widgetGraphConfig?.chart_type,
    widgetGraphConfig?.x_axis,
    widgetGraphConfig?.y_axis,
    widgetGraphConfig?.breakdown_by,
    widgetGraphConfig?.duration,
    widgetGraphConfig?.brands,
    widgetGraphConfig?.filters,
    widgetGraphConfig?.order_by,
    widgetGraphConfig?.filter_by,
    widgetGraphConfig?.filter_dropdown,
    widgetGraphConfig?.filter_by_dropdown,
    widgetGraphConfig?.order_by?.offset,
    refreshChart,
    widgetGraphConfig?.chart_settings?.benchmark_line,
    widgetGraphConfig?.chart_settings?.group_line_agg,
    widgetGraphConfig?.chart_settings?.benchmark_static_value,
    widgetGraphConfig?.card_settings,
    widgetGraphConfig?.chart_settings?.duration_comparison,
    widgetGraphConfig?.chart_settings?.show_previous_duration_comparison,
    widgetGraphConfig?.chart_settings?.show_previous_duration_data,
    widgetGraphConfig?.chart_settings?.total_row,
    widgetGraphConfig?.postcard_pills_filter,
    widgetGraphConfig?.chart_settings?.split_cards,
    widgetGraphConfig?.chart_settings?.top_posts_in_cards,
    widgetGraphConfig?.chart_property?.no_of_top_posts,
    widgetGraphConfig?.chart_settings?.wordcloud_color,
    widgetGraphConfig?.multilevel_breakdown,
    widgetGraphConfig?.deep_dive_on,
    widgetGraphConfig?.chart_settings?.total_count_flag,
  ]);
  useEffect(() => {
    if (
      widgetGraphConfig?.chart_type === "scatter" &&
      widgetGraphConfig?.y_axis_settings
    ) {
      let y_axes_settings = widgetGraphConfig?.y_axis_settings
        ? widgetGraphConfig?.y_axis_settings
        : widgetGraphConfig?.chart?.chart_settings?.y_axis_settings;
      // If anyone has is_median_static true then set it to true
      // else set it to false
      let valueOfStaicMedian = Array.isArray(y_axes_settings)
        ? y_axes_settings?.find((setting) => setting?.is_median_static)
        : false;
      // If valueOfStaicMedian is false and previousValueOfStaicMedian is true then set refreshChart to true
      // For calling api to get updated median
      if (!valueOfStaicMedian && previousValueOfStaicMedian) {
        setPreviousValueOfStaicMedian(valueOfStaicMedian);
        setRefreshChart(!refreshChart);
      } else {
        setPreviousValueOfStaicMedian(valueOfStaicMedian);
      }
    }
  }, [widgetGraphConfig?.y_axis_settings]);
  return (
    <Layout>
      <WidgetMakerHeader />
      <Content className="m-0 d-flex">
        <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
          <div
            className="bg__white d-flex border-right"
            style={{
              minHeight: firstPage
                ? "calc(100vh - 9.8rem)"
                : "calc(100vh - 5.2rem)",
              maxWidth: showChartSide ? "31.5rem" : "53rem",
            }}
          >
            <div
              style={{ width: showChartSide ? "" : "26.1rem" }}
              className="h-100 border-right border-color"
            >
              <AttributeTabs
                setShowChartSide={setShowChartSide}
                firstPage={firstPage}
              />
            </div>
            <div style={{ width: "27.1rem" }}>
              {showChartSettings ? (
                <div className={`tabs_Configure ${chartLoader && "disable"}`}>
                  <ChartSetting
                    setShowChartSettings={setShowChartSettings}
                    firstPage={firstPage}
                  />
                </div>
              ) : (
                <div className={`tabs_Configure ${chartLoader && "disable"}`}>
                  <Tabs
                    className="tabs_widgetMaker_Configure"
                    defaultActiveKey="1"
                    onChange={onChange}
                  >
                    <TabPane
                      className="w-100 widgetMaker_Configure-tabs"
                      tab="Configure"
                      key="configure"
                    >
                      <ConfigurePanel
                        setShowChartSettings={setShowChartSettings}
                        firstPage={firstPage}
                      />
                    </TabPane>
                    <TabPane
                      className="w-100 widgetMaker_Configure-tabs"
                      // tab="Filters"
                      tab={
                        <span>
                          Filters
                          {widgetGraphConfig?.filters?.length ? (
                            <Tooltip
                              placement="leftTop"
                              overlayStyle={{
                                width: widgetGraphConfig?.filters?.length
                                  ? "22rem"
                                  : "15rem",
                              }}
                              color="#3B5175"
                              title={
                                <>
                                  <div
                                    className="custom_scroll"
                                    style={{
                                      maxWidth: "27rem",
                                      maxHeight: "23rem",
                                      overflow: "auto",
                                      scrollBehavior: "smooth",
                                    }}
                                  >
                                    {widgetGraphConfig?.filters?.length
                                      ? widgetGraphConfig?.filters?.map(
                                          (el) => {
                                            return (
                                              el?.attribute !== "brandid" &&
                                              el?.attribute?.toLowerCase() !==
                                                "brandid" &&
                                              el?.attribute?.toLowerCase() !==
                                                "createddate" && (
                                                <div className="mb-2">
                                                  <p className="mb-0 text-white">
                                                    <strong>
                                                      {el?.attribute?.toLowerCase() ===
                                                      "brandid"
                                                        ? "Brands"
                                                        : All_WM_attributes &&
                                                          All_WM_attributes[
                                                            el?.attribute
                                                          ]
                                                        ? All_WM_attributes[
                                                            el?.attribute
                                                          ]
                                                        : All_WM_attributes[
                                                            el?.attribute?.toLowerCase()
                                                          ]
                                                        ? All_WM_attributes[
                                                            el?.attribute?.toLowerCase()
                                                          ]
                                                        : el?.attribute?.toLowerCase() ===
                                                          "categoryid"
                                                        ? "Category"
                                                        : el?.attribute?.toLowerCase() ===
                                                          "subcategoryid_aug"
                                                        ? "Sub Category"
                                                        : el?.attribute?.toLowerCase() ===
                                                          "subsubcategoryid"
                                                        ? "Sub Sub Category"
                                                        : el?.attribute?.replace(
                                                            "Type",
                                                            ""
                                                          )}
                                                    </strong>
                                                  </p>
                                                  {el?.type === "int" &&
                                                    !Array.isArray(
                                                      el?.columns
                                                    ) && (
                                                      <span className="font-weight-light text-white">
                                                        {el?.columns?.from +
                                                          " - " +
                                                          el?.columns?.to}
                                                      </span>
                                                    )}
                                                  {el?.attribute?.toLowerCase() ===
                                                  "createddate" ? (
                                                    <span
                                                      className="font-weight-light"
                                                      style={{
                                                        color: "#fff",
                                                      }}
                                                    >
                                                      {`${el?.columns?.from} - ${el?.columns?.to}`}
                                                    </span>
                                                  ) : (
                                                    Array.isArray(
                                                      el?.columns
                                                    ) &&
                                                    el?.columns?.map(
                                                      (e, index) => {
                                                        return (
                                                          <span
                                                            className="font-weight-light"
                                                            style={{
                                                              color:
                                                                e?.type ===
                                                                "include"
                                                                  ? "#5ed66d"
                                                                  : e?.type ===
                                                                      "exclude" &&
                                                                    "#fb7665",
                                                            }}
                                                          >
                                                            {(index
                                                              ? ", "
                                                              : "") +
                                                              (e?.display_name
                                                                ? e?.display_name
                                                                : e?.name ===
                                                                  null
                                                                ? "Any"
                                                                : e?.name === 0
                                                                ? "No"
                                                                : e?.name === 1
                                                                ? "Yes"
                                                                : e?.name)}
                                                          </span>
                                                        );
                                                      }
                                                    )
                                                  )}
                                                </div>
                                              )
                                            );
                                          }
                                        )
                                      : ` `}
                                  </div>
                                </>
                              }
                            >
                              <Badge
                                style={{
                                  backgroundColor: "#185edf",
                                  fontSize: "1rem",
                                  marginLeft: "1rem",
                                }}
                                title=""
                                count={
                                  widgetGraphConfig?.filters?.length
                                    ? widgetGraphConfig?.filters?.length
                                    : 0
                                }
                              ></Badge>
                            </Tooltip>
                          ) : (
                            ""
                          )}
                        </span>
                      }
                      key="filters"
                    >
                      {/* <FilterPanel /> */}
                      <div
                        style={{
                          maxHeight: firstPage
                            ? "calc(100vh - 19.7rem)"
                            : "calc(100vh - 15rem)",
                          overflow: "auto",
                        }}
                        className="custom_scroll1 mr-1 Filters_Popup"
                      >
                        <FilterDrawer
                          type="widgetMaker"
                          filterSearch={filterSearch}
                          setfilterSearch={setfilterSearch}
                          isFilterApplied={isFilterApplied}
                          setisFilterApplied={setisFilterApplied}
                          widgetMakerClearFilter={widgetMakerClearFilter}
                          setWidgetMakerClearFilter={setWidgetMakerClearFilter}
                          searchTerm={searchTerm}
                          setSearchTerm={setSearchTerm}
                        />
                      </div>

                      <div className="d-flex justify-content-between align-items-center mx-2 my-2">
                        <Button
                          className="btn_Clear"
                          onClick={() => setWidgetMakerClearFilter(true)}
                        >
                          Clear Filter
                        </Button>
                        <Button
                          type="primary"
                          onClick={() => setisFilterApplied(true)}
                          className="ant-btn-primary_blue"
                        >
                          Apply
                        </Button>
                      </div>
                    </TabPane>
                  </Tabs>
                </div>
              )}
            </div>
          </div>
        </DragDropContext>
        <div
          className="w-100 h-100 p-15 hs-overflow-x-locked wm_custom_scroller custom_scroll1"
          style={{
            maxHeight: firstPage
              ? "calc(100vh - 9.8rem)"
              : "calc(100vh - 5.2rem)",
            overflow: "auto",
          }}
        >
          <Button
            className="btn_Clear d-inline-flex align-items-center mb-15"
            onClick={() => {
              setRefreshChart(!refreshChart);
            }}
          >
            <SyncOutlined /> Refresh
          </Button>{" "}
          &nbsp;
          <Button
            className={`reset-btn border-0 align-items-center mb-15 ${
              isAllFieldEmpty ? "disable" : ""
            }`}
            onClick={() => setOpenExitModal(true)}
            onMouseOver={handleMouseOverReset}
            onMouseOut={handleMouseOutReset}
          >
            <img
              src={authParams?.theme_type === "1" ? resetDarkIcon : resetIcon}
              className="mr-1"
              style={{ maxWidth: "1.4rem" }}
              alt="Reset Icon"
            />{" "}
            Reset
          </Button>
          {openExitModal && (
            <ExitModal
              visible={openExitModal}
              setVisible={setOpenExitModal}
              resetWidgetMaker={resetWidgetMaker}
              type="reset_widget_maker"
            />
          )}
          <ErrorBoundary>
            <WidgetMakerChart
              refWidth={showChartSide}
              isWidgetMakerPreview={true}
            />
          </ErrorBoundary>
        </div>
      </Content>
    </Layout>
  );
};

export default React.memo(EditWidgetMetaData, isEqual);
